$(document).ready(function() {
  let allowRefresh = false;
  function handleError(error, context) {
    console.error(`Error in ${context}:`, error);
    // You can add more error handling logic here, such as displaying an error message to the user
  }
 // Saves data after 1 second of inactivity
  let table;
  const ribbonColors = [
    { name: 'Red', color: 'Red' },
    { name: 'White', color: 'White' },
    { name: 'Green', color: 'Green' },
    { name: 'Blue', color: 'Blue' },
    { name: 'Black', color: 'Black' },
    { name: 'Dark-red', color: '#8B0000' }
  ];

  const ribbonColorOptions = ribbonColors.map(item => 
    `<option value="${item.name}" style="background: ${item.color};">${item.name}</option>`
  ).join('');

  const GT_PERI_LOG = '◇GT-PERISH◇';
  function perishableLog(message, payload) {
    if (payload !== undefined) /* console.log(GT_PERI_LOG + ' ' + message, payload) */;
    else /* console.log(GT_PERI_LOG + ' ' + message) */;
  }
  function getRowProductTags($row) {
    const $opt = $row.find('select[name="products"] option:selected');
    const enc = $opt.attr('data-tags');
    if (enc) {
      try {
        return JSON.parse(decodeURIComponent(enc));
      } catch (err) {
        perishableLog('parse data-tags failed', { err: String(err) });
      }
    }
    const pid = $opt.val();
    if (pid && typeof allProductsCache !== 'undefined' && allProductsCache) {
      const p = allProductsCache.find(function (x) { return String(x.id) === String(pid); });
      if (p && p.tags) return p.tags;
    }
    return [];
  }
  const GT_STATE_ABBR_MAP = {
    'alabama':'AL','alaska':'AK','arizona':'AZ','arkansas':'AR','california':'CA',
    'colorado':'CO','connecticut':'CT','delaware':'DE','florida':'FL','georgia':'GA',
    'hawaii':'HI','idaho':'ID','illinois':'IL','indiana':'IN','iowa':'IA','kansas':'KS',
    'kentucky':'KY','louisiana':'LA','maine':'ME','maryland':'MD','massachusetts':'MA',
    'michigan':'MI','minnesota':'MN','mississippi':'MS','missouri':'MO','montana':'MT',
    'nebraska':'NE','nevada':'NV','new hampshire':'NH','new jersey':'NJ','new mexico':'NM',
    'new york':'NY','north carolina':'NC','north dakota':'ND','ohio':'OH','oklahoma':'OK',
    'oregon':'OR','pennsylvania':'PA','rhode island':'RI','south carolina':'SC',
    'south dakota':'SD','tennessee':'TN','texas':'TX','utah':'UT','vermont':'VT',
    'virginia':'VA','washington':'WA','west virginia':'WV','wisconsin':'WI','wyoming':'WY',
    'district of columbia':'DC'
  };
  function getRowStateAbbr($row) {
    const $provinceSelect = $row.find('select[name="province"]');
    if (!$provinceSelect.length) return '';
    const selectedOption = $provinceSelect.find('option:selected');
    const abbr = selectedOption.attr('data-state-abbr');
    if (abbr) return abbr.trim().toUpperCase();
    const fullName = ($provinceSelect.val() || '').trim().toLowerCase();
    return (GT_STATE_ABBR_MAP[fullName] || fullName).toUpperCase();
  }
  function doesStateMatchPerishableDescription(stateAbbr, description) {
    if (!stateAbbr || !description) return false;
    const states = String(description).split(',').map(function (s) { return s.trim().toUpperCase(); });
    return states.indexOf(stateAbbr.toUpperCase()) !== -1;
  }
  function handleizeStrBulk(str) {
    return String(str || '')
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }
  function findPerishableMeta(productTags) {
    const entries = window.__GT_PERISHABLE_META__ || [];
    if (!productTags || !productTags.length) return null;
    const normalizedRaw = productTags.map(function (t) { return String(t).trim().toLowerCase(); });
    const normalizedHandle = productTags.map(function (t) { return handleizeStrBulk(t); });
    for (let i = 0; i < entries.length; i++) {
      const entry = entries[i];
      const entryTagRaw = (entry.tag || '').trim().toLowerCase();
      const entryTagHandle = handleizeStrBulk(entry.tag);
      const entryHandle = (entry.handle || '').trim().toLowerCase();
      if (entryTagRaw && normalizedRaw.indexOf(entryTagRaw) !== -1) return entry;
      if (entryTagHandle && normalizedHandle.indexOf(entryTagHandle) !== -1) return entry;
      if (entryHandle && normalizedHandle.indexOf(entryHandle) !== -1) return entry;
      if (entryHandle && normalizedRaw.indexOf(entryHandle) !== -1) return entry;
    }
    return null;
  }
  function hasPerishableProductTag($row) {
    return !!findPerishableMeta(getRowProductTags($row));
  }
  const GT_DAY_NAME_TO_NUM = {
    sunday: 0, sun: 0, monday: 1, mon: 1, tuesday: 2, tue: 2, tues: 2,
    wednesday: 3, wed: 3, thursday: 4, thu: 4, thur: 4, thurs: 4,
    friday: 5, fri: 5, saturday: 6, sat: 6
  };
  function parsePerishableVariantDays(daysStr) {
    if (!daysStr || !String(daysStr).trim()) return [];
    const nums = [];
    String(daysStr).split(',').forEach(function (part) {
      const key = part.trim().toLowerCase().replace(/\./g, '');
      if (!key) return;
      const num = GT_DAY_NAME_TO_NUM[key];
      if (num !== undefined && nums.indexOf(num) === -1) nums.push(num);
    });
    return nums;
  }
  function metaHasPerishableVariantDays(meta) {
    return !!(meta && (
      String(meta.shipping_variant_1_days || '').trim() ||
      String(meta.shipping_variant_2_days || '').trim()
    ));
  }
  function normalizePerishableProductType(meta) {
    return String(meta && meta.product_type || '').trim().toLowerCase();
  }
  function isStrawberryPerishableMeta(meta) {
    return normalizePerishableProductType(meta) === 'strawberry';
  }
  function isNonStrawberryGiftingCompanyMeta(meta) {
    const type = normalizePerishableProductType(meta);
    return !type || type === 'non-strawberry+gifting-company';
  }
  function isGiftingCompanyDeliverableDay(dayNum, days1, days2) {
    if (!days1.length && !days2.length) return true;
    return days1.indexOf(dayNum) !== -1 || days2.indexOf(dayNum) !== -1;
  }
  function getFirstGiftingCompanyDeliverableDate(anchorDate, days1, days2) {
    if (!anchorDate) return null;
    const start = normalizeCalendarDateBulk(anchorDate);
    for (let offset = 0; offset < 21; offset++) {
      const d = new Date(start);
      d.setDate(d.getDate() + offset);
      const dow = d.getDay();
      if (dow === 0 || dow === 6) continue;
      if (isHoliday(d)) continue;
      if (isMondayDeliveryBlackout(d)) continue;
      if (!isGiftingCompanyDeliverableDay(dow, days1, days2)) continue;
      return normalizeCalendarDateBulk(d);
    }
    return null;
  }
  function resolveGiftingCompanyVariantByDays(meta, targetDate, dayNum, days1, days2, perishDaysDiff, isNextDayDelivery) {
    if (!targetDate) return null;
    if (!isGiftingCompanyDeliverableDay(dayNum, days1, days2)) return null;
    // Variant 1 only on the single first available delivery day
    if (isNextDayDelivery) {
      if (meta.shipping_variant_1) {
        return { slot: 1, variantName: meta.shipping_variant_1 };
      }
      return null;
    }
    if (meta.shipping_variant_2) {
      return { slot: 2, variantName: meta.shipping_variant_2 };
    }
    return null;
  }
  function isFirstGiftingCompanyDeliverableDate(date, anchorDate, days1, days2) {
    const firstDeliverable = getFirstGiftingCompanyDeliverableDate(anchorDate, days1, days2);
    return !!(firstDeliverable && isSameCalendarDayBulk(normalizeCalendarDateBulk(date), firstDeliverable));
  }
  function resolvePerishableVariantForDate(meta, date, perishDaysDiff, stateAbbr, anchorDate) {
    if (!meta || !date) return null;
    const dayNum = date.getDay();
    const isStrawberry = isStrawberryPerishableMeta(meta);
    const isGiftingCompanyType = isNonStrawberryGiftingCompanyMeta(meta);
    const stateInDescription = !!(stateAbbr && doesStateMatchPerishableDescription(stateAbbr, meta.description));
    if (metaHasPerishableVariantDays(meta)) {
      if (perishDaysDiff < 0) return null;
      const days1 = parsePerishableVariantDays(meta.shipping_variant_1_days);
      const days2 = parsePerishableVariantDays(meta.shipping_variant_2_days);
      if (isStrawberry) {
        const strawberrySlot = stateInDescription ? 1 : 2;
        const strawberryDays = stateInDescription ? days1 : days2;
        const strawberryVariant = stateInDescription ? meta.shipping_variant_1 : meta.shipping_variant_2;
        if (strawberryDays.length && strawberryDays.indexOf(dayNum) === -1) return null;
        if (!strawberryVariant) return null;
        return { slot: strawberrySlot, variantName: strawberryVariant };
      }
      if (isGiftingCompanyType) {
        const isNextDayGifting = isFirstGiftingCompanyDeliverableDate(date, anchorDate, days1, days2);
        return resolveGiftingCompanyVariantByDays(meta, date, dayNum, days1, days2, perishDaysDiff, stateInDescription);
      }
      if (perishDaysDiff === 0) {
        if (days1.indexOf(dayNum) !== -1 && meta.shipping_variant_1) {
          return { slot: 1, variantName: meta.shipping_variant_1 };
        }
        return null;
      }
      if (perishDaysDiff === 1) {
        if (days2.indexOf(dayNum) !== -1 && meta.shipping_variant_2) {
          return { slot: 2, variantName: meta.shipping_variant_2 };
        }
        return null;
      }
      if (days2.indexOf(dayNum) !== -1 && meta.shipping_variant_2) {
        return { slot: 2, variantName: meta.shipping_variant_2 };
      }
      if (days1.indexOf(dayNum) !== -1 && meta.shipping_variant_1) {
        return { slot: 1, variantName: meta.shipping_variant_1 };
      }
      return null;
    }
    if (isStrawberry) {
      if (perishDaysDiff < 0) return null;
      if (stateInDescription && meta.shipping_variant_1) {
        return { slot: 1, variantName: meta.shipping_variant_1 };
      }
      if (!stateInDescription && meta.shipping_variant_2) {
        return { slot: 2, variantName: meta.shipping_variant_2 };
      }
      return null;
    }
    if (isGiftingCompanyType) {
      if (perishDaysDiff < 0) return null;
      if (stateInDescription && meta.shipping_variant_1) {
        return { slot: 1, variantName: meta.shipping_variant_1 };
      }
      if (meta.shipping_variant_2) {
        return { slot: 2, variantName: meta.shipping_variant_2 };
      }
      if (meta.shipping_variant_1) {
        return { slot: 1, variantName: meta.shipping_variant_1 };
      }
      return null;
    }
    if (perishDaysDiff < 0 || perishDaysDiff > 1) return null;
    if (perishDaysDiff === 0 && meta.shipping_variant_1) {
      return { slot: 1, variantName: meta.shipping_variant_1 };
    }
    if (perishDaysDiff === 1 && meta.shipping_variant_2) {
      return { slot: 2, variantName: meta.shipping_variant_2 };
    }
    return null;
  }
  function shouldDisablePerishableVariantDay(meta, date, perishDaysDiff, stateAbbr, anchorDate) {
    if (!meta || !metaHasPerishableVariantDays(meta)) return false;
    if (perishDaysDiff < 0) return true;
    return !resolvePerishableVariantForDate(meta, date, perishDaysDiff, stateAbbr, anchorDate);
  }
  function normalizeCalendarDateBulk(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }
  function isSameCalendarDayBulk(a, b) {
    return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
  }
  function getNextPerishableWeekendBlockDates(anchorDate) {
    const anchor = normalizeCalendarDateBulk(anchorDate);
    const d = new Date(anchor);
    while (d.getDay() !== 6) {
      d.setDate(d.getDate() + 1);
    }
    const sat = normalizeCalendarDateBulk(d);
    const sun = new Date(sat);
    sun.setDate(sun.getDate() + 1);
    const mon = new Date(sat);
    mon.setDate(mon.getDate() + 2);
    return [sat, sun, mon];
  }
  function isInNextPerishableWeekendBlock(date, anchorDate) {
    if (!anchorDate) return false;
    const target = normalizeCalendarDateBulk(date);
    const blocked = getNextPerishableWeekendBlockDates(anchorDate);
    return blocked.some(function (b) { return isSameCalendarDayBulk(b, target); });
  }
  function getPerishableDeliveryDaysDiff(anchorDate, targetDate) {
    const start = normalizeCalendarDateBulk(anchorDate);
    const end = normalizeCalendarDateBulk(targetDate);
    if (end < start) return -1;
    let count = 0;
    const cur = new Date(start);
    while (cur <= end) {
      const dow = cur.getDay();
      if (dow !== 0 && dow !== 6 && !isHoliday(cur)) count++;
      cur.setDate(cur.getDate() + 1);
    }
    return count - 1;
  }
  function getPerishableEarliestSelectableBulk(currentDate, $row, effectiveDateWithoutTime) {
    const vendor = $row ? getRowVendor($row) : '';
    const cutoffTime = new Date(currentDate);
    if (isGiftingCompanyVendor(vendor)) {
      cutoffTime.setHours(13, 0, 0, 0);
    } else {
      cutoffTime.setHours(14, 30, 0, 0);
    }
    if (currentDate >= cutoffTime) {
      return effectiveDateWithoutTime;
    }
    return normalizeCalendarDateBulk(currentDate);
  }
  // Real-time ZIP-to-state lookup via API with cache
  const GT_ZIP_STATE_CACHE = {};
  function fetchStateFromZipAsync(zip) {
    if (!zip || zip.length < 5) return Promise.resolve('');
    if (GT_ZIP_STATE_CACHE[zip] !== undefined) return Promise.resolve(GT_ZIP_STATE_CACHE[zip]);
    return fetch('https://api.zippopotam.us/us/' + zip)
      .then(function (res) {
        if (!res.ok) { GT_ZIP_STATE_CACHE[zip] = ''; return ''; }
        return res.json();
      })
      .then(function (data) {
        if (!data || !data.places || !data.places.length) { GT_ZIP_STATE_CACHE[zip] = ''; return ''; }
        const abbr = (data.places[0]['state abbreviation'] || '').toUpperCase();
        GT_ZIP_STATE_CACHE[zip] = abbr;
        perishableLog('fetchStateFromZipAsync: resolved', { zip: zip, state: abbr });
        return abbr;
      })
      .catch(function () { GT_ZIP_STATE_CACHE[zip] = ''; return ''; });
  }
  function getStateFromZipCached(zip) {
    if (!zip || zip.length < 5) return '';
    return GT_ZIP_STATE_CACHE[zip] || '';
  }
  function isPerishableActiveForRow($row) {
    const tags = getRowProductTags($row);
    const meta = findPerishableMeta(tags);
    if (!meta) return { active: false, meta: null, reason: 'no tag match', stateAbbr: '' };
    const zipVal = ($row.find('input[name="zip"]').val() || '').replace(/[^0-9]/g, '').slice(0, 5);
    // Use cached ZIP state lookup (real-time fetch fills cache beforehand)
    let stateAbbr = getStateFromZipCached(zipVal);
    if (!stateAbbr) {
      stateAbbr = getRowStateAbbr($row);
    }
    if (!stateAbbr) return { active: false, meta: meta, reason: 'no state determinable from zip or dropdown', stateAbbr: '' };
    if (!zipVal || !checkZone(zipVal.replace(/^0+/, ""))) {
      return { active: false, meta: meta, reason: 'zip "' + zipVal + '" not in any zone', stateAbbr: stateAbbr };
    }
    if (isStrawberryPerishableMeta(meta)) {
      const strawberrySlot = doesStateMatchPerishableDescription(stateAbbr, meta.description) ? 1 : 2;
      return { active: true, meta: meta, stateAbbr: stateAbbr, reason: 'strawberry tag+zone match (variant ' + strawberrySlot + ' for ' + stateAbbr + ')' };
    }
    if (isNonStrawberryGiftingCompanyMeta(meta)) {
      return { active: true, meta: meta, stateAbbr: stateAbbr, reason: 'non-strawberry+gifting-company tag+zone match (' + stateAbbr + ')' };
    }
    const stateMatch = doesStateMatchPerishableDescription(stateAbbr, meta.description);
    if (!stateMatch) return { active: false, meta: meta, reason: 'state "' + stateAbbr + '" (from zip ' + zipVal + ') not in description "' + meta.description + '"', stateAbbr: stateAbbr };
    return { active: true, meta: meta, stateAbbr: stateAbbr, reason: 'tag+state(zip:' + stateAbbr + ')+zone match' };
  }
  function logPerishableRowTrace(reason, $row, extra) {
    const tags = getRowProductTags($row);
    const meta = findPerishableMeta(tags);
    const stateAbbr = getRowStateAbbr($row);
    const perishCheck = isPerishableActiveForRow($row);
    perishableLog('[' + reason + '] context', Object.assign({}, extra || {}, {
      productId: $row.find('select[name="products"]').val(),
      tags: tags,
      stateAbbr: stateAbbr,
      metaTagMatched: !!meta,
      perishableActive: perishCheck.active,
      perishableReason: perishCheck.reason
    }));
    if (meta) {
      perishableLog('[' + reason + '] FULL perishable_product entry', Object.assign({}, meta));
    }
  }
  function logAllRowsPerishable(reason) {
    $('#orderTableBody tr').each(function () {
      logPerishableRowTrace(reason, $(this));
    });
  }
  function findShippingRadioByVariantTitle($row, title) {
    const want = String(title || '').trim().toLowerCase();
    if (!want) return null;
    let $found = null;
    $row.find('input[name^="shipping-"]').each(function () {
      const t = String($(this).attr('data-variant-title') || '').trim().toLowerCase();
      if (t && t === want) {
        $found = $(this);
        return false;
      }
    });
    return $found;
  }
  function findShippingRadioForPerishableFallback($row, slot) {
    const slotLower = slot === 'overnight' ? 'overnight' : 'expedited';
    let $best = null;
    $row.find('input[name^="shipping-"]').each(function () {
      const t = String($(this).attr('data-variant-title') || '').trim().toLowerCase();
      if (!t || t.indexOf('affordable') !== -1) return;
      if (slotLower === 'overnight' && t.indexOf('overnight') !== -1) {
        if (t === 'overnight') { $best = $(this); return false; }
        if (!$best) $best = $(this);
      }
      if (slotLower === 'expedited' && t.indexOf('expedited') !== -1) {
        if (t === 'expedited') { $best = $(this); return false; }
        if (!$best) $best = $(this);
      }
    });
    return $best;
  }
  function tryApplyPerishableCalendarShipping($row, selectedDate) {
    if (!hasPerishableProductTag($row)) return false;
    const perishCheck = isPerishableActiveForRow($row);
    if (!selectedDate || isNaN(selectedDate.getTime())) return false;
    if (selectedDate.getDay() === 6) {
      perishableLog('tryApplyPerishableCalendarShipping: Saturday — keep legacy price/radio matching', {});
      return false;
    }
    const shippingProduct = window.__GT_EXPEDITED_SHIPPING_PRODUCT__;
    if (!shippingProduct || !shippingProduct.variants) {
      perishableLog('tryApplyPerishableCalendarShipping: shipping product not loaded yet — skip override', {});
      return false;
    }
    const currentDate = getCurrentEasternTime();
    const effectiveDate = getEffectiveDate(currentDate);
    const dateWithoutTime = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate());
    const effectiveDateWithoutTime = new Date(effectiveDate.getFullYear(), effectiveDate.getMonth(), effectiveDate.getDate());
    const easternToday = normalizeCalendarDateBulk(currentDate);
    const earliestSelectable = getPerishableEarliestSelectableBulk(currentDate, $row, effectiveDateWithoutTime);
    if (dateWithoutTime < earliestSelectable) return false;
    if (dateWithoutTime.getDay() === 0) return false;
    const businessDaysDiff = getPerishableDeliveryDaysDiff(easternToday, dateWithoutTime);
    if (businessDaysDiff < 0) return false;
    const perishEligible = perishCheck.active || (perishCheck.meta && isStrawberryPerishableMeta(perishCheck.meta));
    const useVariantDayLists = perishEligible && perishCheck.meta && metaHasPerishableVariantDays(perishCheck.meta);
    if (!useVariantDayLists && businessDaysDiff > 1) {
      perishableLog('tryApplyPerishableCalendarShipping: businessDaysDiff not 0/1 — legacy selection', { businessDaysDiff: businessDaysDiff });
      return false;
    }
    let $matchRadio = null;
    let targetTitle = null;
    if (perishEligible && perishCheck.meta) {
      const meta = perishCheck.meta;
      const variantSlot = resolvePerishableVariantForDate(meta, dateWithoutTime, businessDaysDiff, perishCheck.stateAbbr, earliestSelectable);
      if (!variantSlot) {
        perishableLog('tryApplyPerishableCalendarShipping: no variant for this day', { businessDaysDiff: businessDaysDiff, dayOfWeek: dateWithoutTime.getDay(), variant1Days: meta.shipping_variant_1_days, variant2Days: meta.shipping_variant_2_days });
        return false;
      }
      targetTitle = variantSlot.variantName;
      $matchRadio = findShippingRadioByVariantTitle($row, targetTitle);
    } else {
      $matchRadio = findShippingRadioForPerishableFallback($row, businessDaysDiff === 0 ? 'overnight' : 'expedited');
      targetTitle = businessDaysDiff === 0 ? 'Overnight' : 'Expedited';
      perishableLog('tryApplyPerishableCalendarShipping: tag-only (no state/zip) — default shipping', {
        reason: perishCheck.reason,
        slot: targetTitle,
        businessDaysDiff: businessDaysDiff
      });
    }
    if (!$matchRadio || !$matchRadio.length) {
      perishableLog('tryApplyPerishableCalendarShipping: no radio with data-variant-title match', {
        wantedTitle: targetTitle,
        availableTitles: $row.find('input[name^="shipping-"]').map(function () { return $(this).attr('data-variant-title'); }).get()
      });
      return false;
    }
    const vid = $matchRadio.val();
    const variant = shippingProduct.variants.find(function (v) { return String(v.id) === String(vid); });
    perishableLog('tryApplyPerishableCalendarShipping: APPLY shipping variant', {
      businessDaysDiff: businessDaysDiff,
      perishableActive: perishCheck.active,
      metaTag: perishCheck.meta ? perishCheck.meta.tag : null,
      metaDescription: perishCheck.meta ? perishCheck.meta.description : null,
      targetTitle: targetTitle,
      variantId: vid,
      variantFoundInJson: !!variant
    });
    $row.find('input[name^="shipping-"]').prop('checked', false);
    $matchRadio.prop('checked', true);
    return true;
  }

  window.GT_PERISHABLE = {
    logAllRows: logAllRowsPerishable,
    logRow: logPerishableRowTrace,
    log: perishableLog
  };

  // Initialize DataTable
  table = $('#orderTable').DataTable({
    paging: false,
    pageLength: 50,
    lengthChange: false,
    searching: false,
    ordering: false,
    info: false,
    autoWidth: false,
    columns: [
      { data: 'index', className: 'column-index' },
      { data: 'product', className: 'column-gifts' },
      { data: 'view', className: 'column-view' },
      { data: 'ribbonType', className: 'column-ribbon-type' },
      { data: 'ribbonColor', className: 'column-ribbon-color' },
      { data: 'ribbonMessage', className: 'column-ribbon-message' },
      { data: 'firstName', className: 'column-name' },
      { data: 'lastName', className: 'column-name' },
      { data: 'company', className: 'column-company' },
      { data: 'address1', className: 'column-address' },
      { data: 'address2', className: 'column-address' },
      { data: 'city', className: 'column-city' },
      { data: 'country', className: 'column-country' },
      { data: 'province', className: 'column-state' },
      { data: 'zip', className: 'column-zip' },
      { data: 'DeliveryDate', className: 'column-Delivery-Date' },
      { data: 'phone', className: 'column-phone' },
      { data: 'cardMessage', className: 'column-card-message' },
      { data: 'actions', className: 'column-actions' }
    ],
    columnDefs: [
      { orderable: false, targets: [-1] }
    ],
    "dom": 't<"dataTables_wrapper_bottom"lip>',
    "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]],
    "pageLength": 5,
    "language": {
      "lengthMenu": "Show _MENU_ entries",
      "info": "Showing _START_ to _END_ of _TOTAL_ entries",
      "infoEmpty": "Showing 0 to 0 of 0 entries",
      "infoFiltered": "(filtered from _MAX_ total entries)",
      "paginate": {
        "first": "First",
        "last": "Last",
        "next": "Next",
        "previous": "Previous"
      }
    },
    "drawCallback": function(settings) {
      var api = this.api();
      var pageInfo = api.page.info();
      
      // Only show pagination if there's more than one page
      if (pageInfo.pages <= 1) {
        $('.dataTables_paginate').hide();
      } else {
        $('.dataTables_paginate').show();
      }
      
      // Only show info if there are entries
      if (pageInfo.recordsTotal > 50) {
        $('.dataTables_info').show();
      } else {
        $('.dataTables_info').hide();
      }

       /* console.log('have Stoped---') */
      // Initialize country and province selectors for visible rows
      //initializeCountryProvinceSelectors();
    }
  });

  function adjustColumnWidths() {
    table.columns.adjust().draw();
  }

  $(window).on('resize', adjustColumnWidths);
  adjustColumnWidths();

  $('a[data-toggle="tab"]').on('shown.bs.tab', adjustColumnWidths);

  function createRow(index) {
    return {
      index: index,
      product: `
        <div class="product_info_data">
          <div class="product_image_cover">
            <img class="product-image" src="https://cdn.shopify.com/s/files/1/0761/9903/5189/files/Group_359.jpg?v=1726751100" alt="Product Image">
          </div>
          <div class="product_select_info">
            <select name="products" class="product-select gift-select" data-row-index="${index}">
              <option value="">Loading products...</option>
            </select>
            <div class="selected_productID">
              <span class="productID-label">Gift #: <span></span></span>
            </div>
          </div>
        </div>
      `,
      view: `
        <div class="product_link_price_info" style="display: none;">
          <a href="#" target="_blank" class="view-link" style="display: none;">
            <span>
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="24" viewBox="0 0 32 24" fill="none">
                <path d="M18.5417 12C18.5417 13.6569 17.1986 15 15.5417 15C13.8849 15 12.5417 13.6569 12.5417 12C12.5417 10.3431 13.8849 9 15.5417 9C17.1986 9 18.5417 10.3431 18.5417 12Z" stroke="#6D809F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M15.5422 5C11.0646 5 7.27427 7.94288 6 12C7.27425 16.0571 11.0646 19 15.5422 19C20.0198 19 23.8101 16.0571 25.0844 12C23.8101 7.94291 20.0198 5 15.5422 5Z" stroke="#6D809F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
          </a> 
          <div class="tooltip-container">
            <button class="tooltip-trigger">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M10 6H10.01M10 9V14M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z" stroke="#257EFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            <aside class="tooltip-content" style="display: none;">
              <div class="multiship-product__details">
                <h2 class="gift-summry-heading">Gift Summary</h2>
                <dl>
                  <dt>Gift:</dt>
                  <dd class="gift-fee">$0.00</dd>
                  <dt class="ribbon-line" style="display: none;">Ribbon:</dt>
                  <dd class="ribbon-fee" style="display: none;">$0.00</dd>
                  <dt class="signature-line" style="display: none;">Adult Signature Fee:</dt>
                  <dd class="signature-fee" style="display: none;">$0.00</dd>
                  <dt>Shipping:</dt>
                  <dd class="shipping-fee">$0.00</dd>
                  <dt>Tax:</dt>
                  <dd class="tax-fee">TBD</dd>
                </dl>
                <div class="sub_total-wrap">
                  <dt>Product Total:</dt>
                  <dd class="product-sub_total">$0.00</dd>
                </div>
              </div>
            </aside>
          </div>
        </div>
      `,
      ribbonType: `
        <div class="ribbon-type-container">
          <select name="products-ribbon" class="ribbon-type-select" style="display: none;">
            ${(window.GT_BULK_TEMPLATES && window.GT_BULK_TEMPLATES.ribbonOptions) || ''}
          </select>
          <div class="personal-message-container" style="display: none;">
            <div class='personal-message__opt-out'>
              <input
                type="checkbox"
                id="personal-message-opt-out-${index}"
                name="opt-out-personal-message"
                value="true"
              >
              <label for="personal-message-opt-out-${index}">
                No message
              </label>
            </div>
            <div class="personal-message-fields"></div>
          </div>
        </div>
      `,
      ribbonColor: `
        <select name="ribbon-color" class="ribbon-color-select" style="display: none;">
          ${ribbonColorOptions}
        </select>
      `,
      ribbonMessage: `
        <div class="product__ribbon-message-container forcefully-hidden" style="display: none;">
          <h3 class='product__ribbons-title h5' for='ProductRibbonMessage'>Ribbon Message (Maximum characters: 45)</h3>
          <textarea class='product__ribbon-message' id="ProductRibbonMessage" maxlength="45" name="Message" placeholder="Enter your message" required=""></textarea>
        </div>
      `,
      firstName: '<input type="text" id="firstName" name="firstName">',
      lastName: '<input type="text" id="lastName" name="lastName">',
      company: '<input type="text" id="company" name="company">',
      address1: '<input type="text" id="address1" name="address1">',
      address2: '<input type="text" id="address2" name="address2">',
      city: '<input type="text" id="city" name="city">',
      country: `
        <div class="select-options-country">
          <div class="select-country">
            <select class='select__select country' id="MultiShipCountry-${index}" name="country" data-address-country-select data-default="" autocomplete="country">
              ${(window.GT_BULK_TEMPLATES && window.GT_BULK_TEMPLATES.countryOptions) || ''}
            </select>
          </div>
        </div>
      `,
      province: `
        <div class="select-options-state" id="MultiShipProvinceContainer-${index}">
          <div class="select-state">
            <select class='select__select' id="MultiShipProvince-${index}" name="province" data-default="" autocomplete="address-level1"></select>
          </div>
        </div>
      `,
      zip: `
        <div class="zip-input-field">
          <input type="text" id="zip-${index}" name="zip" data-zone="">
        </div>
      `,
      DeliveryDate: `
        <div class="delivery_date">
          <shipping-methods data-line='${index}' id='ShippingMethods-${index}' class='multiship-methods' data-hour="${(window.GT_BULK_TEMPLATES && window.GT_BULK_TEMPLATES.shippingHour) || ''}">${((window.GT_BULK_TEMPLATES && window.GT_BULK_TEMPLATES.shippingMethodsHtml) || '').replace(/__INDEX__/g, String(index))}</shipping-methods>
          <div class="delivery-date_cover disabled">
            <input type="text" id="DeliveryDate-${index}" name="delivery_date" readonly>
            <button type="button" class="calendar_modal" data-row="${index}">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M3 10H21M7 3V5M17 3V5M6.2 21H17.8C18.9201 21 19.4802 21 19.908 20.782C20.2843 20.5903 20.5903 20.2843 20.782 19.908C21 19.4802 21 18.9201 21 17.8V8.2C21 7.07989 21 6.51984 20.782 6.09202C20.5903 5.71569 20.2843 5.40973 19.908 5.21799C19.4802 5 18.9201 5 17.8 5H6.2C5.0799 5 4.51984 5 4.09202 5.21799C3.71569 5.40973 3.40973 5.71569 3.21799 6.09202C3 6.51984 3 7.07989 3 8.2V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.07989 21 6.2 21Z" stroke="#BABABA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
      </div>
      `,
      phone: '<input type="text" id="phone" name="phone">',
      cardMessage: '<textarea class="text-area multiship-card__message" name="note" id="Cart-note-second" maxlength="250" placeholder="Enter Your Gift Card Message Here. Please include your signature/from."></textarea>',
      actions: `
        <button class="action-btn clone-btn tooltip-btn" data-tooltip="Clone">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M8 8H7.2C6.0799 8 5.51984 8 5.09202 8.21799C4.71569 8.40973 4.40973 8.71569 4.21799 9.09202C4 9.51984 4 10.0799 4 11.2V16.8C4 17.9201 4 18.4802 4.21799 18.908C4.40973 19.2843 4.71569 19.5903 5.09202 19.782C5.51984 20 6.0799 20 7.2 20H12.8C13.9201 20 14.4802 20 14.908 19.782C15.2843 19.5903 15.5903 19.2843 15.782 18.908C16 18.4802 16 17.9201 16 16.8V16M11.2 16H16.8C17.9201 16 18.4802 16 18.908 15.782C19.2843 15.5903 19.5903 15.2843 19.782 14.908C20 14.4802 20 13.9201 20 12.8V7.2C20 6.0799 20 5.51984 19.782 5.09202C19.5903 4.71569 19.2843 4.40973 18.908 4.21799C18.4802 4 17.9201 4 16.8 4H11.2C10.0799 4 9.51984 4 9.09202 4.21799C8.71569 4.40973 8.40973 4.71569 8.21799 5.09202C8 5.51984 8 6.07989 8 7.2V12.8C8 13.9201 8 14.4802 8.21799 14.908C8.40973 15.2843 8.71569 15.5903 9.09202 15.782C9.51984 16 10.0799 16 11.2 16Z" stroke="#6D809F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          Clone
        </button>
        <button class="action-btn remove-btn tooltip-btn" data-tooltip="Remove">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M4 6H20M16 6L15.7294 5.18807C15.4671 4.40125 15.3359 4.00784 15.0927 3.71698C14.8779 3.46013 14.6021 3.26132 14.2905 3.13878C13.9376 3 13.523 3 12.6936 3H11.3064C10.477 3 10.0624 3 9.70951 3.13878C9.39792 3.26132 9.12208 3.46013 8.90729 3.71698C8.66405 4.00784 8.53292 4.40125 8.27064 5.18807L8 6M18 6V16.2C18 17.8802 18 18.7202 17.673 19.362C17.3854 19.9265 16.9265 20.3854 16.362 20.673C15.7202 21 14.8802 21 13.2 21H10.8C9.11984 21 8.27976 21 7.63803 20.673C7.07354 20.3854 6.6146 19.9265 6.32698 19.362C6 18.7202 6 17.8802 6 16.2V6M14 10V17M10 10V17" stroke="#DD0202" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          Remove
        </button>`
    };
  }

  function initializeProductSelect() {
    $('#orderTable').off('change.bulkGiftProduct').on('change.bulkGiftProduct', 'select[name="products"].gift-select', async function() {
      const $row = $(this).closest('tr');
      updateProductDetails($row);
      clearErrorStyles($row);
      updateAgeVerificationAndSubmitButton();

      $('.inventory-error-message').remove();

      const selectedOption = $(this).find('option:selected');
      const productHandle = selectedOption.attr('data-url')?.replace('/products/', '');
      if (productHandle) {
        await fetchProductInventory(productHandle);
      }

      logPerishableRowTrace('product-select-change', $row);
      (function() {
        var tags = getRowProductTags($row);
        var meta = findPerishableMeta(tags);
        var zipVal = ($row.find('input[name="zip"]').val() || '').replace(/[^0-9]/g, '').slice(0, 5);
        var stateAbbr = getStateFromZipCached(zipVal) || getRowStateAbbr($row);
        /* console.log('%c🟡◇GT-PERISH-STATUS◇🟡 ═══ PRODUCT CHANGE ═══', 'color:#ccaa00;font-weight:bold;font-size:12px') */;
        /* console.log('%c🟡 Product Tags:', 'color:#ccaa00;font-weight:bold', tags) */;
        if (meta) {
          /* console.log('%c🟡✅ TAG MATCH: "' + meta.tag + '"', 'color:#00cc00;font-weight:bold', { variant1: meta.shipping_variant_1 || '(empty)', variant2: meta.shipping_variant_2 || '(empty)', description: meta.description }) */;
        } else {
          /* console.log('%c🟡❌ NO TAG MATCH in metaobject entries', 'color:#cc0000;font-weight:bold') */;
        }
        /* console.log('%c🟡 State: ' + (stateAbbr || 'N/A') + ' | ZIP: ' + (zipVal || 'N/A'), 'color:#ccaa00;font-weight:bold') */;
        var perishCheck = isPerishableActiveForRow($row);
        /* console.log('%c🟡 Perishable Active: ' + perishCheck.active + ' | Reason: ' + perishCheck.reason, perishCheck.active ? 'color:#00cc00;font-weight:bold' : 'color:#cc0000;font-weight:bold') */;
      })();
      const existingDate = $row.find('input[name="delivery_date"]').val();
      initializeDatepicker($row);
      if (existingDate) {
        setDatepickerDate($row, existingDate);
        updateEstimatedDeliveryDate($row);
      }
    });
  }

  function removeRow($button) {
      if (table.rows().count() > 1) {
          const $row = $button.closest("tr");
          const removedIndex = table.row($row).index();

          // Capture state of all remaining rows BEFORE redraw (DataTables wipes DOM state on draw)
          const savedRowsState = [];
          table.rows().every(function (idx) {
              if (idx === removedIndex) return;
              const $r = $(this.node());
              savedRowsState.push({
                  productVal: $r.find('select[name="products"]').val(),
                  ribbonVal: $r.find('select[name="products-ribbon"]').val(),
                  ribbonColor: $r.find('select[name="ribbon-color"]').val(),
                  recipientName: $r.find('input[name="recipient_name"]').val(),
                  address1: $r.find('input[name="address1"]').val(),
                  address2: $r.find('input[name="address2"]').val(),
                  city: $r.find('input[name="city"]').val(),
                  country: $r.find('select[name="country"]').val(),
                  province: $r.find('select[name="province"]').val(),
                  zip: $r.find('input[name="zip"]').val(),
                  phone: $r.find('input[name="phone"]').val(),
                  deliveryDate: $r.find('input[name="delivery_date"]').val(),
                  cardMessage: $r.find('.multiship-card__message').val(),
                  optOutMessage: $r.find('input[name="opt-out-personal-message"]').prop('checked'),
                  ageVerification: $r.find('input[name="age_verification"]').prop('checked')
              });
          });

          destroyDatepicker($row); // Cleanup any attached datepickers
          table.row($row).remove().draw(false); // Remove the row and redraw the table

          updateAgeVerificationAndSubmitButton();
          updateRowIndexes(); // Refresh row indexes (this also triggers a redraw)

          // After all redraws are done, repopulate dropdowns and restore state
          populateAllDropdowns();
          table.rows().every(function (idx) {
              if (idx >= savedRowsState.length) return;
              const $r = $(this.node());
              const saved = savedRowsState[idx];
              if (saved.productVal) {
                  $r.find('select[name="products"]').val(saved.productVal);
                  try { updateProductDetails($r); } catch (e) {}
              }
              if (saved.ribbonVal) $r.find('select[name="products-ribbon"]').val(saved.ribbonVal);
              if (saved.ribbonColor) $r.find('select[name="ribbon-color"]').val(saved.ribbonColor);
              if (saved.recipientName) $r.find('input[name="recipient_name"]').val(saved.recipientName);
              if (saved.address1) $r.find('input[name="address1"]').val(saved.address1);
              if (saved.address2) $r.find('input[name="address2"]').val(saved.address2);
              if (saved.city) $r.find('input[name="city"]').val(saved.city);
              if (saved.country) $r.find('select[name="country"]').val(saved.country);
              if (saved.province) $r.find('select[name="province"]').val(saved.province);
              if (saved.zip) $r.find('input[name="zip"]').val(saved.zip);
              if (saved.phone) $r.find('input[name="phone"]').val(saved.phone);
              if (saved.deliveryDate) $r.find('input[name="delivery_date"]').val(saved.deliveryDate);
              if (saved.cardMessage) $r.find('.multiship-card__message').val(saved.cardMessage);
              if (saved.optOutMessage) $r.find('input[name="opt-out-personal-message"]').prop('checked', true);
              if (saved.ageVerification) $r.find('input[name="age_verification"]').prop('checked', true);
              try {
                  initializeDatepicker($r);
                  if (saved.deliveryDate) setDatepickerDate($r, saved.deliveryDate);
              } catch (e) {}
          });
          try { initializeCountryProvinceSelectors(); } catch (e) {}
      } else {
          resetTable(); // Reset the table if only one row remains
      }
  }

  function processBatch(batchIndex, totalBatches, count, $originalRow, originalRowData, batchSize) {
      return new Promise((resolve, reject) => {
        if (batchIndex >= totalBatches) {
          updateRowIndexes();
          updateAgeVerificationAndSubmitButton();
          
          table.draw();
          resolve();
          return;
        }

        const start = batchIndex * batchSize;
        const end = Math.min(start + batchSize, count);
        const newRowsData = [];

        for (let i = start; i < end; i++) {
          const newRowData = createRow(table.rows().count() + i + 1);
          newRowsData.push(newRowData);
        }

        table.rows.add(newRowsData).draw(false);
        const addedRows = table.rows(function(idx, data, node) {
          return idx >= table.page.info().recordsTotal - newRowsData.length;
        });

        // Populate products in new rows
        populateAllDropdowns();

        addedRows.every(function (rowIdx) {
          const $clonedRow = $(this.node());
          copyRowData($originalRow, $clonedRow);
          updateProductDetails($clonedRow);
          initializeDatepicker($clonedRow);
          const $noMessageCheckbox = $clonedRow.find('input[name="opt-out-personal-message"]');
          handleNoMessageCheckbox($noMessageCheckbox);
        });

         
          //initializeCountryProvinceSelectors();
          initializeCountryProvinceSelectors(addedRows.nodes());
          

        // Process next batch
        setTimeout(() => {
          processBatch(batchIndex + 1, totalBatches, count, $originalRow, originalRowData, batchSize)
            .then(resolve)
            .catch(reject);
        }, 0);
      });
    }

    function cloneRow($button, count = 1) {
      const $originalRow = $button.closest("tr");
      const originalRowData = table.row($originalRow).data();
      const batchSize = 50; // Process 50 rows at a time
      const totalBatches = Math.ceil(count / batchSize);

      // Show loading overlay
      const $progressLoader = $('#progressLoader');
      $progressLoader.show();

      function updateProgress(progress) {
        $progressLoader.find('.progress').css('width', `${progress}%`);
        // $progressLoader.find('.progress-text').text(`${Math.round(progress)}%`);
      }

      function processBatch(batchIndex) {
        return new Promise((resolve, reject) => {
          if (batchIndex >= totalBatches) {
            updateRowIndexes();
            updateAgeVerificationAndSubmitButton();
          
            table.draw();
            resolve();
            return;
          }

          const start = batchIndex * batchSize;
          const end = Math.min(start + batchSize, count);
          const newRowsData = [];

          for (let i = start; i < end; i++) {
            const newRowData = createRow(table.rows().count() + i + 1);
            newRowsData.push(newRowData);
          }

          table.rows.add(newRowsData).draw(false);
          const addedRows = table.rows(function(idx, data, node) {
            return idx >= table.page.info().recordsTotal - newRowsData.length;
          });

          // Populate products in new rows
          populateAllDropdowns();

          addedRows.every(function (rowIdx) {
            const $clonedRow = $(this.node());
            copyRowData($originalRow, $clonedRow);
            updateProductDetails($clonedRow);
            initializeDatepicker($clonedRow);
            const $noMessageCheckbox = $clonedRow.find('input[name="opt-out-personal-message"]');
            handleNoMessageCheckbox($noMessageCheckbox);
          });

         
          //initializeCountryProvinceSelectors();
          initializeCountryProvinceSelectors(addedRows.nodes());
         

          const progress = ((batchIndex + 1) / totalBatches) * 100;
          updateProgress(progress);

          // Process next batch
          setTimeout(() => {
            processBatch(batchIndex + 1)
              .then(resolve)
              .catch(reject);
          }, 0);
        });
      }

      processBatch(0)
        .then(() => {
          $progressLoader.hide();
          
        })
        .catch((error) => {
          console.error('Error during cloning:', error);
          $progressLoader.hide();
          alert('An error occurred while cloning rows. Please try again.');
        });
    }

  function copyRowData($originalRow, $clonedRow) {
    const copyValue = (selector) => {
      $clonedRow.find(selector).val($originalRow.find(selector).val());
    };

    const copyAttribute = (selector, attribute) => {
      $clonedRow.find(selector).attr(attribute, $originalRow.find(selector).attr(attribute));
    };

    const copyVisibility = (selector) => {
      const $original = $originalRow.find(selector);
      const $cloned = $clonedRow.find(selector);
      $cloned.toggle($original.is(":visible"));
      $cloned.toggleClass("forcefully-hidden", $original.hasClass("forcefully-hidden"));
    };

    // Copy select values
    ['products', 'products-ribbon', 'ribbon-color'].forEach(selectName => {
      copyValue(`select[name="${selectName}"]`);
    });

    // Copy product ID
    const productId = $originalRow.find('select[name="products"]').val();
    $clonedRow.find(".selected_productID .productID-label span").text(productId);

    // Copy product image and view link
    copyAttribute(".product-image", "src");
    $clonedRow.find(".product-image").toggleClass("hidden", $originalRow.find(".product-image").hasClass("hidden"));
    copyAttribute(".view-link", "href");
    $clonedRow.find(".view-link").toggle($originalRow.find(".view-link").is(":visible"));

    // Copy ribbon message
    copyValue(".product__ribbon-message");

    // Copy personal messages
    const $originalPersonalMessageContainer = $originalRow.find(".personal-message-container");
    const $clonedPersonalMessageContainer = $clonedRow.find(".personal-message-container");
    $clonedPersonalMessageContainer.html($originalPersonalMessageContainer.html());
    $clonedPersonalMessageContainer.toggle($originalPersonalMessageContainer.is(":visible"));

    // Copy the "No message" checkbox state and handle textarea accordingly
    const $originalNoMessageCheckbox = $originalRow.find('input[name="opt-out-personal-message"]');
    const $clonedNoMessageCheckbox = $clonedRow.find('input[name="opt-out-personal-message"]');
    const noMessageChecked = $originalNoMessageCheckbox.prop("checked");
    
    $clonedNoMessageCheckbox.prop("checked", noMessageChecked);

    const $clonedTextareas = $clonedPersonalMessageContainer.find(".personal-message__body");
    $clonedTextareas.prop('disabled', noMessageChecked);
    if (!noMessageChecked) {
      $originalPersonalMessageContainer.find(".personal-message__body").each(function (index) {
        $clonedTextareas.eq(index).val($(this).val());
      });
    }

    $clonedNoMessageCheckbox.off('change').on('change', function() {
      handleNoMessageCheckbox($(this));
    });

    // Copy card message
    copyValue('textarea[name="note"]');

    // Copy visibility and classes of elements
    ["ribbon-type-select", "ribbon-color-select", "personal-message-container", "product__ribbon-message-container"].forEach(copyVisibility);

    $clonedRow.find(".multiship-card__message").on("input", function () {
      $(this).closest("tr").removeClass("error");
    });
  }

  function handleDeleteAll() {
    if (table.rows().count() > 1) {
      table.clear().draw();
      const newRowData = createRow(1);
      table.row.add(newRowData).draw();
      updateAgeVerificationAndSubmitButton();
      initializeCountryProvinceSelectors();
      calculateTotals();
      initializeDatepickers();
      table.page(0).draw('page'); // Reset to first page
    }
  }

  

  function checkForWineProducts() {
    let hasWineProduct = false;
    table.rows().every(function(rowIdx, tableLoop, rowLoop) {
      const $row = $(this.node());
      const $select = $row.find('select[name="products"]');
      const selectedOption = $select.find('option:selected');
      if (selectedOption.data('wine-product') === true) {
        hasWineProduct = true;
        return false; // break the loop
      }
    });
    return hasWineProduct;
  }

  function updateAgeVerificationAndSubmitButton() {
    const hasWineProduct = checkForWineProducts();
    const $ageVerificationContainer = $('.product-warning__container');
    const $submitButton = $('#submitOrderBtn');
    //const $taxCalucationButton = $('#TaxCalculation');
    const $ageVerificationCheckbox = $('#ProductAgeVerification');

    if (hasWineProduct) {
      $ageVerificationContainer.show();
      $submitButton.prop('disabled', !$ageVerificationCheckbox.prop('checked'));
      //$taxCalucationButton.prop('disabled', !$ageVerificationCheckbox.prop('checked'));
    } else {
      $ageVerificationContainer.hide();
      $submitButton.prop('disabled', false);
      // $taxCalucationButton.prop('disabled', false);
    }
  }

  function updateRibbonColorSelectStyle($select) {
    const selectedColor = $select.val();
    const $option = $select.find(`option[value="${selectedColor}"]`);
    let backgroundColor = $option.css('background-color');
    
    // Convert color names to hex
    const colorMap = {
      'Red': '#FF0000',
      'White': '#FFFFFF',
      'Green': '#00FF00',
      'Blue': '#0000FF',
      'Black': '#000000',
      'Dark-red': '#8B0000'
    };
    
    if (colorMap[selectedColor]) {
      backgroundColor = colorMap[selectedColor];
    }
    
    // Check if backgroundColor is a valid color
    if (backgroundColor && backgroundColor !== 'transparent' && backgroundColor !== 'rgba(0, 0, 0, 0)') {
      const textColor = getContrastColor(backgroundColor);
  
      $select.css({
        'background-color': backgroundColor,
        'color': textColor
      });
    } else {
      console.warn('Invalid background color:', backgroundColor);
      // Set a default style or handle the error as appropriate
      $select.css({
        'background-color': '',
        'color': ''
      });
    }
  }

  function getContrastColor(hexColor) {
    // Special case for white
    if (!hexColor || typeof hexColor !== 'string') {
      console.warn('Invalid hex color:', hexColor);
      return '#000000'; // Default to black text
    }
    if (hexColor.toLowerCase() === '#ffffff') {
      return '#000000'; // Black text for white background
    }

    // Convert hex to RGB
    const r = parseInt(hexColor.substr(1, 2), 16);
    const g = parseInt(hexColor.substr(3, 2), 16);
    const b = parseInt(hexColor.substr(5, 2), 16);
    
    // Calculate luminance
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    
    // Return black or white based on luminance
    return luminance > 0.5 ? '#000000' : '#FFFFFF';
  }

  function updateProductDetails($row) {
    const productId = $row.find('select[name="products"]').val();
    const $productImage = $row.find('.product-image');
    const $select = $row.find('select[name="products"]');
    const $viewLink = $row.find('.view-link');
    const $viewLinkTab = $row.find('.product_link_price_info');
    const $tooltipPrice = $row.find('.tooltip-container');
    const $ribbonTypeSelect = $row.find('select[name="products-ribbon"]');
    const $ribbonColorSelect = $row.find('select[name="ribbon-color"]');
    const $ribbonOwnMessage = $row.find('.product__ribbon-message-container');
    const $personalMessageContainer = $row.find('.personal-message-container');
    const $priceInfo = $row.find(".tooltip-content .multiship-product__details");
    const $ribbonFeeElement = $priceInfo.find('.ribbon-fee');
    const $ribbonFeeContainer = $ribbonFeeElement.closest('dt, dd');
    const $tooltipContent = $row.find(".tooltip-content .multiship-product__details");
    if (!$ribbonColorSelect.val()) {
      $ribbonColorSelect.val($ribbonColorSelect.find('option:first').val()).trigger('change');
    }
    
    updateRibbonColorSelectStyle($ribbonColorSelect);

    const currentShippingFee = parseFloat($priceInfo.find(".shipping-fee").text().replace('$', '')) || 22.38;
    if ($select.find(`option[value="${productId}"]`).length === 0) {
      const productName = $select.find('option:selected').text();
      const $opt = $('<option></option>').val(productId).text(productName);
      if (typeof allProductsCache !== 'undefined' && allProductsCache) {
        const cached = allProductsCache.find(function (p) { return String(p.id) === String(productId); });
        if (cached && cached.tags) {
          $opt.attr('data-tags', encodeURIComponent(JSON.stringify(cached.tags)));
        }
      }
      $opt.appendTo($select);
    }
    if (productId && productId !== '') {
      const $selectedOption = $select.find(`option[value="${productId}"]`);
      if ($selectedOption.length === 0) {
        $selectedOption = $('<option></option>').attr('value', productId).text(productId);
        $select.append($selectedOption);
        $select.val(productId);
      }
      const price = parseFloat($selectedOption.data('price') || 0);
      $row.find('.selected_productID .productID-label span').text(productId);
      const imageUrl = $selectedOption.data('image');
      const productUrl = $selectedOption.data('url');
      const hasRibbon = $selectedOption.data('has-ribbon') === true;
      const isWine = $selectedOption.data('is-wine') === true;
      const pType = $selectedOption.data('p-type');

      $productImage.attr('src', imageUrl);
      $viewLink.attr('href', productUrl).show();
      $viewLinkTab.show();
      $tooltipPrice.show();

      $tooltipContent.find(".gift-fee").text(`$${price.toFixed(2)}`);

      // Handle ribbon visibility and options
        if (hasRibbon) {
            $ribbonTypeSelect.show();
            $ribbonColorSelect.show();
            $personalMessageContainer.hide();
            $ribbonOwnMessage.removeClass('forcefully-hidden').show();
  
            if (!$ribbonTypeSelect.val()) {
                $ribbonTypeSelect.val($ribbonTypeSelect.find('option:first').val()).trigger('change');
            }
            if (!$ribbonColorSelect.val()) {
                $ribbonColorSelect.val($ribbonColorSelect.find('option:first').val()).trigger('change');
            }
            handleRibbonTypeChange($ribbonTypeSelect);
        } else {
            // Reset ribbon-related elements if product doesn't support ribbons
            $ribbonTypeSelect.hide().val('');
            $ribbonColorSelect.hide().val('');
            $ribbonOwnMessage.addClass('forcefully-hidden').hide();
            $priceInfo.find(".ribbon-line, .ribbon-fee").hide();
            $priceInfo.find(".ribbon-fee").text('$0.00');
            
            if (pType) {
                const [c, l] = pType.split('c');
                updatePersonalMessageFields($personalMessageContainer, parseInt(c), parseInt(l), true);
                $personalMessageContainer.show();
            } else {
                $personalMessageContainer.hide();
            }
        }

      // Handle signature fee display
      if (isWine) {
        fetch('/products/signature-fee.js')
          .then(response => response.json())
          .then(product => {
            const signatureFee = product.price / 100;
            $tooltipContent.find(".signature-line, .signature-fee").show();
            $tooltipContent.find(".signature-fee").text(`$${signatureFee.toFixed(2)}`);
            updatePriceInfo($row, price, currentShippingFee, signatureFee, hasRibbon);
          })
          .catch(error => {
            console.error('Error fetching signature fee:', error);
            updatePriceInfo($row, price, currentShippingFee, 0, hasRibbon);
          });
      } else {
        $tooltipContent.find(".signature-line, .signature-fee").hide();
        updatePriceInfo($row, price, currentShippingFee, 0, hasRibbon);
      }

      calculateTotals();
    } else {
      resetProductDetails($row);
    }

    
  }

  function resetProductDetails($row) {
    $row.find('.product-image').attr('src', 'https://cdn.shopify.com/s/files/1/0761/9903/5189/files/Group_359.jpg?v=1726751100');
    $row.find('.view-link').hide().attr('href', '#');
    $row.find('select[name="products-ribbon"]').hide().val('');
    $row.find('.tooltip-container').hide();
    $row.find('select[name="ribbon-color"]').hide().val('');
    $row.find('.personal-message-container').hide();
    $row.find('.product__ribbon-message-container').hide();
    $row.find('.ribbon-fee').closest('dt, dd').hide();
    resetPriceInfo($row);
  }

  function handleRibbonTypeChange($ribbonTypeSelect) {
    const selectedRibbonType = $ribbonTypeSelect.val();
    const $row = $ribbonTypeSelect.closest('tr');
    const $ribbonColorSelect = $row.find('select[name="ribbon-color"]');
    const $ribbonOwnMessage = $row.find('.product__ribbon-message-container');
    const $productSelect = $row.find('select[name="products"]');
    const $selectedOption = $productSelect.find('option:selected');
    
    // Get current values
    const $priceInfo = $row.find(".tooltip-content .multiship-product__details");
    const giftPrice = parseFloat($priceInfo.find(".gift-fee").text().replace(/[^0-9.]/g, '')) || 0;
    const signatureFee = parseFloat($priceInfo.find(".signature-fee").text().replace(/[^0-9.]/g, '')) || 0;
    const shippingFee = parseFloat($priceInfo.find(".shipping-fee").text().replace(/[^0-9.]/g, '')) || 22.38;
    
    // Check if product requires signature fee
    const isWine = $selectedOption.data('is-wine') === true;
    const hasRibbon = $selectedOption.data('has-ribbon') === true;
  
    // Handle UI updates for ribbon selection
    if (!selectedRibbonType || selectedRibbonType === '45979875410229' || selectedRibbonType == '45979875475765') {
        $ribbonColorSelect.prop('selectedIndex', 0).trigger('change');
        if (selectedRibbonType === '45979875410229') {
            $ribbonColorSelect.prop('disabled', true);
        }else{
           $ribbonColorSelect.prop('disabled', false);
        }
        $ribbonOwnMessage.addClass('forcefully-hidden').hide();
        // Explicitly set ribbon fee to 0
        $priceInfo.find(".ribbon-fee").text("$0.00");
    } else {
        $ribbonColorSelect.prop('disabled', false);
        $ribbonOwnMessage.removeClass('forcefully-hidden').show();
    }
  
    // Calculate ribbon fee
    let ribbonFee = 0;
    if (hasRibbon && selectedRibbonType) {
        ribbonFee = parseFloat(getRibbonFee($ribbonTypeSelect)) || 0;
    }
  
    // Update price info with new ribbon fee
    updatePriceInfo($row, giftPrice, shippingFee, signatureFee, hasRibbon, ribbonFee);
  
    
  }

  function updatePersonalMessageFields($container, maxChars, numLines, preserveValues = false) {
    const $fields = $container.find('.personal-message-fields');
    const existingValues = preserveValues ? $fields.find('.personal-message__body').map(function() {
      return $(this).val();
    }).get() : [];
    $fields.empty();
    for (let i = 1; i <= numLines; i++) {
      const $field = $(`
        <div class="personal-message-field">
          <div class="personal-message__header h5">
            <span>Line ${i} Message (Maximum characters: ${maxChars})</span>
          </div>
          <textarea class='personal-message__body personal_message_${i}' name="properties[Personal Message Line ${i}]" maxlength="${maxChars}"></textarea>
        </div>`);
      if (preserveValues && existingValues[i - 1]) {
        $field.find('textarea').val(existingValues[i - 1]);
      }
      $fields.append($field);
    }
  }

  function handleNoMessageCheckbox($checkbox) {
    const $container = $checkbox.closest('.personal-message-container');
    const $textareas = $container.find('.personal-message__body');
    const isChecked = $checkbox.prop('checked');
    $textareas.prop('disabled', isChecked);
    if (isChecked) {
      $textareas.val(''); // Clear textareas when "No message" is checked
    }
    // Update the personalMessagesDisabled property
    $checkbox.closest('tr').find('.personal-message__body').data('personalMessagesDisabled', isChecked);
   
  }

  function parseShippingDataPrice($el) {
    if (!$el || !$el.length) return NaN;
    // Prefer attr — jQuery .data() coerces "22.38" to a number, which has no .replace()
    const raw = $el.attr('data-price');
    const fallback = $el.data('price');
    const value = raw != null && raw !== '' ? raw : fallback;
    return parseFloat(String(value == null ? '' : value).replace(/[^0-9.]/g, ''));
  }

  function updatePriceInfo($row, price, shippingFee, signatureFee = 0, hasRibbon = false, ribbonFee = 0) {
    if (!$row || !$row.length) {
        console.error('Invalid row element provided to updatePriceInfo');
        return;
    }
  
    // Get the selected shipping method's price if it exists
    const selectedShippingMethod = $row.find('input[name^="shipping-"]:checked');
    const parsedSelected = selectedShippingMethod.length ? parseShippingDataPrice(selectedShippingMethod) : NaN;
    const currentShippingFee = !isNaN(parsedSelected) && parsedSelected > 0
        ? parsedSelected
        : (parseFloat(shippingFee) || 22.38);
  
    // Convert all inputs to numbers and handle undefined/null values
    const safePrice = parseFloat(price) || 0;
    const safeSignatureFee = parseFloat(signatureFee) || 0;
    const safeRibbonFee = parseFloat(ribbonFee) || 0;
  
    try {
        const $priceInfo = $row.find(".tooltip-content .multiship-product__details");
        if (!$priceInfo.length) {
            console.error('Price info element not found');
            return;
        }
  
        // Keep existing values if no new values are provided
        const existingPrice = parseFloat($priceInfo.find(".gift-fee").text().replace(/[^0-9.]/g, '')) || 0;
        const existingSignatureFee = parseFloat($priceInfo.find(".signature-fee").text().replace(/[^0-9.]/g, '')) || 0;
        const existingRibbonFee = parseFloat($priceInfo.find(".ribbon-fee").text().replace(/[^0-9.]/g, '')) || 0;
  
        // Use new values or existing values
        const finalPrice = safePrice || existingPrice;
        const finalSignatureFee = safeSignatureFee || existingSignatureFee;
        
        // Modify how ribbon fee is handled
        const finalRibbonFee = safeRibbonFee > 0 ? safeRibbonFee : existingRibbonFee;
  
        // Update individual components
        $priceInfo.find(".gift-fee").text(`$${finalPrice.toFixed(2)}`);
        $priceInfo.find(".shipping-fee").text(`$${currentShippingFee.toFixed(2)}`);
  
        // Handle ribbon fee display - more robust handling
        if (finalRibbonFee > 0 || hasRibbon) {
            $priceInfo.find(".ribbon-fee").text(`$${finalRibbonFee.toFixed(2)}`);
            $priceInfo.find(".ribbon-line, .ribbon-fee").show();
        } else {
            $priceInfo.find(".ribbon-fee").text("$0.00");
            $priceInfo.find(".ribbon-line, .ribbon-fee").hide();
        }
    
        // Handle signature fee display
        if (finalSignatureFee > 0) {
            $priceInfo.find(".signature-fee").text(`$${finalSignatureFee.toFixed(2)}`);
            $priceInfo.find(".signature-line, .signature-fee").show();
        } else {
            $priceInfo.find(".signature-fee").text("$0.00");
            $priceInfo.find(".signature-line, .signature-fee").hide();
        }
  
        // Calculate total including all fees
        const total = finalPrice + currentShippingFee + finalRibbonFee + finalSignatureFee;
        $priceInfo.find(".product-sub_total").text(`$${total.toFixed(2)}`);
  
       
  
        // Update overall totals
        calculateTotals();
  
    } catch (error) {
        console.error('Error in updatePriceInfo:', error);
        // Set fallback values if there's an error
        const $priceInfo = $row.find(".tooltip-content .multiship-product__details");
        $priceInfo.find(".shipping-fee").text(`$${currentShippingFee.toFixed(2)}`);
        $priceInfo.find(".product-sub_total").text(`$${(safePrice + currentShippingFee).toFixed(2)}`);
    }
}

  function calculateTotals() {
    let subtotal = 0;
    let estimatedTotal = 0;
    table.rows().every(function(rowIdx, tableLoop, rowLoop) {
      const $row = $(this.node());
      const $priceInfo = $row.find(".tooltip-content .multiship-product__details");
      const giftPrice = parseFloat($priceInfo.find(".gift-fee").text().replace('$', '')) || 0;
      const ribbonPrice = parseFloat($priceInfo.find(".ribbon-fee").text().replace('$', '')) || 0;
      const shippingPrice = parseFloat($priceInfo.find(".shipping-fee").text().replace('$', '')) || 0;
      const signatureFee = parseFloat($priceInfo.find(".signature-fee").text().replace('$', '')) || 0;
      subtotal += giftPrice + ribbonPrice + shippingPrice + signatureFee;
    });
    estimatedTotal = subtotal;
    $('.footer_subtotal .total-subtotal:nth-child(1) h3').text('$' + subtotal.toFixed(2));
    $('.footer_subtotal .total-subtotal:nth-child(3) h3').text('$' + estimatedTotal.toFixed(2));
    $('#payment-form #amount').val(estimatedTotal.toFixed(2))
    
  }

  function getRibbonFee($ribbonTypeSelect) {
    const selectedRibbonId = $ribbonTypeSelect.val();
    if (!selectedRibbonId) return 0;
    
    // First try to get price from data attribute
    const selectedOption = $ribbonTypeSelect.find(`option[value="${selectedRibbonId}"]`);
    const price = parseFloat(selectedOption.data("price"));
    
    // Fallback to predefined prices if data-price is not available
    const ribbonFees = {
        '45979875410229': 0.00,      // Ribbon Included
        '45979875442997': 9.95,      // Personalized Message
        '45979875475765': 7.95       // Occasion
    };
    
    return price || ribbonFees[selectedRibbonId] || 0;
  }

  function resetPriceInfo($row) {
    const $priceInfo = $row.find(".tooltip-content .multiship-product__details");
    $priceInfo.find(".gift-fee, .ribbon-fee, .shipping-fee, .signature-fee, .product-sub_total").text("$0.00");
    $priceInfo.find(".ribbon-line, .ribbon-fee, .signature-line, .signature-fee").hide();
  }

  function populateRowData($row, data) {
    const setValue = (selector, value) => {
      $row.find(selector).val(value).trigger('change');
    };

    setValue('select[name="products"]', data.productId);
    setValue('select[name="products-ribbon"]', data.ribbonType);
    setValue('select[name="ribbon-color"]', data.ribbonColor);
    setValue('.product__ribbon-message', data.ribbonMessage);

    $row.find('.personal-message__body').each(function(i) {
      $(this).val(data.personalMessages[i] || '');
    });

    const $noMessageCheckbox = $row.find('input[name="opt-out-personal-message"]');
    $noMessageCheckbox.prop('checked', data.noMessage).trigger('change');

    const $personalMessageTextareas = $row.find('.personal-message__body');
    $personalMessageTextareas.prop('disabled', data.personalMessagesDisabled);

    if (data.noMessage) {
      $personalMessageTextareas.val('');
    }

    ['firstName', 'lastName', 'company', 'address1', 'address2', 'city'].forEach(field => {
      setValue(`input[name="${field}"]`, data[field]);
    });

    setValue('select[name="country"]', data.country);
    setValue('input[name="zip"]', data.zip);
    setValue('input[name="delivery_date"]', data.deliveryDate);
    setValue('textarea[name="note"]', data.cardMessage);

    setTimeout(() => {
       
       setValue('select[name="province"]', data.province);
    }, 100);

    const $priceInfo = $row.find(".tooltip-content .multiship-product__details");
    $priceInfo.find(".shipping-fee").text(`$${data.shippingPrice.toFixed(2)}`);
    $priceInfo.find(".gift-fee").text(`$${data.price.toFixed(2)}`);
    $priceInfo.find(".signature-fee").text(`$${data.signatureFee.toFixed(2)}`);

    if (data.isWine) {
      $priceInfo.find(".signature-fee").closest('dt, dd').show();
    } else {
      $priceInfo.find(".signature-fee").closest('dt, dd').hide();
    }

    updatePriceInfo($row, data.price, data.shippingPrice, data.signatureFee, data.hasRibbon);
    validateZipAndActivateCalendar($row.find('input[name="zip"]'));
  }

  function resetTable() {
    table.clear();
    table.row.add(createRow(1)).draw();
    initializeCountryProvinceSelectors();
    initializeDatepickers();
  }

  

  function getRowData($row, index) {
    const getValue = (selector, defaultValue = '') => {
      const element = $row.find(selector);
      return element.length ? element.val() || defaultValue : defaultValue;
    };

    const getNumericValue = (selector) => {
      return parseFloat(getValue(selector).replace('$', '')) || 0;
    };

    const $selectedOption = $row.find('select[name="products"] option:selected');
    const $priceInfo = $row.find(".tooltip-content .multiship-product__details");

    return {
      index: index + 1,
      productId: getValue('select[name="products"]'),
      isWine: $selectedOption.data('is-wine') === true,
      price: getNumericValue(".gift-fee"),
      ribbonType: getValue('select[name="products-ribbon"]'),
      ribbonColor: getValue('select[name="ribbon-color"]'),
      ribbonMessage: getValue('.product__ribbon-message'),
      personalMessages: $row.find('.personal-message__body').map(function() {
        return $(this).val() || '';
      }).get(),
      noMessage: $row.find('input[name="opt-out-personal-message"]').is(':checked'),
      personalMessagesDisabled: $row.find('.personal-message__body').prop('disabled'),
      firstName: getValue('input[name="firstName"]'),
      lastName: getValue('input[name="lastName"]'),
      company: getValue('input[name="company"]'),
      address1: getValue('input[name="address1"]'),
      address2: getValue('input[name="address2"]'),
      city: getValue('input[name="city"]'),
      country: getValue('select[name="country"]'),
      province: getValue('select[name="province"]'),
      zip: getValue('input[name="zip"]'),
      deliveryDate: getValue('input[name="delivery_date"]'),
      phone: getValue('input[name="phone"]'),
      cardMessage: getValue('textarea[name="note"]'),
      shippingPrice: getNumericValue(".shipping-fee"),
      signatureFee: getNumericValue(".signature-fee"),
      hasRibbon: getNumericValue(".ribbon-fee") > 0
    };
  }

  function initializeCountryProvinceSelectors(newRow = null) {
    const savedSelections = [];
    $('#orderTable tbody tr:visible').each(function () {
        const $row = $(this);
        const countrySelect = $row.find('select[name="country"]');
        const provinceSelect = $row.find('select[name="province"]');

        savedSelections.push({
            rowId: $row.find('td:first').text(),
            country: countrySelect.val(),
            province: provinceSelect.val() || "Alabama", // Default to Alabama
        });
    });

    // State abbreviations mapping
    const stateAbbreviations = {
      'Alabama': 'AL',
      'Alaska': 'AK',
      'Arizona': 'AZ',
      'Arkansas': 'AR',
      'California': 'CA',
      'Colorado': 'CO',
      'Connecticut': 'CT',
      'Delaware': 'DE',
      'Florida': 'FL',
      'Georgia': 'GA',
      'Hawaii': 'HI',
      'Idaho': 'ID',
      'Illinois': 'IL',
      'Indiana': 'IN',
      'Iowa': 'IA',
      'Kansas': 'KS',
      'Kentucky': 'KY',
      'Louisiana': 'LA',
      'Maine': 'ME',
      'Maryland': 'MD',
      'Massachusetts': 'MA',
      'Michigan': 'MI',
      'Minnesota': 'MN',
      'Mississippi': 'MS',
      'Missouri': 'MO',
      'Montana': 'MT',
      'Nebraska': 'NE',
      'Nevada': 'NV',
      'New Hampshire': 'NH',
      'New Jersey': 'NJ',
      'New Mexico': 'NM',
      'New York': 'NY',
      'North Carolina': 'NC',
      'North Dakota': 'ND',
      'Ohio': 'OH',
      'Oklahoma': 'OK',
      'Oregon': 'OR',
      'Pennsylvania': 'PA',
      'Rhode Island': 'RI',
      'South Carolina': 'SC',
      'South Dakota': 'SD',
      'Tennessee': 'TN',
      'Texas': 'TX',
      'Utah': 'UT',
      'Vermont': 'VT',
      'Virginia': 'VA',
      'Washington': 'WA',
      'West Virginia': 'WV',
      'Wisconsin': 'WI',
      'Wyoming': 'WY',
      'American Samoa': 'AS',
      'Armed Forces Americas': 'AA',
      'Armed Forces Europe': 'AE',
      'Armed Forces Pacific': 'AP',
      'Washington DC': 'DC',
      'District of Columbia': 'DC',
      'Micronesia': 'FM',
      'Guam': 'GU',
      'Marshall Islands': 'MH',
      'Northern Mariana Islands': 'MP',
      'Palau': 'PW',
      'Puerto Rico': 'PR',
      'U.S. Virgin Islands': 'VI',
      'Virgin Islands': 'VI'
    };

    if (!Shopify.CountryProvinceSelector.prototype.hasOwnProperty('originalReplaceProvinces')) {
        Shopify.CountryProvinceSelector.prototype.originalReplaceProvinces =
            Shopify.CountryProvinceSelector.prototype.replaceProvinces;

        Shopify.CountryProvinceSelector.prototype.replaceProvinces = function (provinces) {
            this.originalReplaceProvinces.call(this, provinces);

            const provinceSelect = document.getElementById(this.provinceSelector);
            if (provinceSelect) {
                Array.from(provinceSelect.options).forEach(option => {
                    const stateName = option.text.trim();
                    const stateAbbr = stateAbbreviations[stateName];
                    if (stateAbbr) {
                        option.setAttribute('data-state-abbr', stateAbbr);
                    }
                });
            }
        };
    }

    const $rowsToProcess = newRow ? $(newRow) : $('#orderTable tbody tr:visible');
    $rowsToProcess.each(function () {
        const $row = $(this);
        const countryElement = $row.find('select[name="country"]')[0];
        const provinceElement = $row.find('select[name="province"]')[0];
        const containerElement = $row.find('[id^="MultiShipProvinceContainer-"]')[0]; // Added

        if (Shopify && Shopify.CountryProvinceSelector && countryElement && provinceElement && containerElement) {
            new Shopify.CountryProvinceSelector(countryElement.id, provinceElement.id, {
                hideElement: containerElement.id
            });

            const savedSelection = savedSelections.find(s => s.rowId === $row.find('td:first').text());
            if (savedSelection) {
                $(countryElement).val(savedSelection.country).trigger('change');
                setTimeout(() => {
                    
                    $(provinceElement).val(savedSelection.province);
                    
                }, 200);
            }

            $(countryElement).off('change.stateAbbr').on('change.stateAbbr', function () {
                setTimeout(() => {
                    if (provinceElement) {
                        Array.from(provinceElement.options).forEach(option => {
                            const stateName = option.text.trim();
                            const stateAbbr = stateAbbreviations[stateName];
                            if (stateAbbr) {
                                option.setAttribute('data-state-abbr', stateAbbr);
                            }
                        });
                    }
                }, 100);
            });
        }
    });
}

  function truncateZipCode(zip) {
    return zip.replace(/^(\d{5}).*/, "$1");
  }

  function updateRowIndexes() {
    table.rows().every(function(index) {
      $(this.node()).find("td:eq(0)").text(index + 1);
    });
    table.draw();
  }

  // ZIP code data and related functions
  //https://cdn.shopify.com/s/files/1/0761/9903/5189/files/zip_code.json?v=1733463661
  let Scenario1 = [];
  let Scenario2 = [];
  let Scenario3 = [];
  let Scenario4 = [];
 //"https://cdn.shopify.com/s/files/1/0761/9903/5189/files/zip_codes_new_USPS.json?v=1767247834"
  fetch("https://cdn.shopify.com/s/files/1/0761/9903/5189/files/GT_UPDATE_ZIP_CODES_08_20_2026.json?v=1787210742")
    .then((response) => response.json())
    .then((data) => {
      Object.keys(data).forEach((key) => {
        data[key].forEach((item) => {
          const postalCode = item["Postal Code"].toString().replace(/^0+/, "");
          if (item["Service Days"] <= 3) {
            Scenario1.push(postalCode);
          } else if (item["Service Days"] === 4) {
            Scenario2.push(postalCode);
          } else if (item["Service Days"] === 5 || item["Service Days"] === 6) {
            Scenario3.push(postalCode);
          } else if (item["Service Days"] === 7 || item["Service Days"] === 8) {
            Scenario4.push(postalCode);
          }
        });
      });
      
    })
    .catch((error) => {
      console.error("Error fetching ZIP code data:", error);
    });

  function checkZone(zip) {
    zip = zip.replace(/^0+/, "");
    if (Scenario1.includes(zip)) return "SCzones1";
    if (Scenario2.includes(zip)) return "SCzones2";
    if (Scenario3.includes(zip)) return "SCzones3";
    if (Scenario4.includes(zip)) return "SCzones4";
    return false;
  }

  function validateZip(zipInput) {
    let originalZip = zipInput.value;
    let zip = originalZip.replace(/^0+/, "");
    let zone = checkZone(zip);
    let parentElement = zipInput.closest("tr");
    if (zone) {
      zipInput.setAttribute("zone", zone);
      zipInput.classList.remove("zoneisNotAvailable");
      parentElement.classList.add("zoneisAvailable");
      parentElement.classList.remove("error");
    } else {
      zipInput.removeAttribute("zone");
      zipInput.classList.add("zoneisNotAvailable");
      parentElement.classList.remove("zoneisAvailable");
      parentElement.classList.add("error");
    }
    zipInput.value = originalZip;
  }

  // Datepicker related functions
  function initializeDatepickers() {
    table.rows().every(function(index) {
      initializeDatepicker($(this.node()));
    });
  }

  function getCurrentEasternTime() {
    return new Date(new Date().toLocaleString("en-US", {timeZone: "America/New_York"}));
  }

  function isGiftingCompanyVendor(vendor) {
    const v = (vendor || '').trim().toLowerCase();
    return v === 'gifting company' || v === 'gifting-company';
  }

  function getRowVendor($row) {
    return $row.find('select[name="products"] option:selected').attr('data-vendor') || '';
  }

  function isMondayDeliveryBlackout(date) {
    if (date.getDay() !== 1) return false;
    const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const blackoutEnd = new Date(2026, 9, 26);
    const blackoutResume = new Date(2026, 10, 2);
    return d <= blackoutEnd && d < blackoutResume;
  }

  function getEffectiveDate(currentDate, $row) {
    const vendor = $row ? getRowVendor($row) : '';
    const cutoffTime = new Date(currentDate);
    if (isGiftingCompanyVendor(vendor)) {
      cutoffTime.setHours(13, 0, 0, 0);
    } else {
      cutoffTime.setHours(14, 30, 0, 0);
    }
    let effectiveDate = new Date(currentDate);
    if (currentDate >= cutoffTime) {
      effectiveDate = getNextBusinessDay(effectiveDate);
    }
    return getNextBusinessDay(effectiveDate);
  }

  function getNextBusinessDay(date) {
    const nextDay = new Date(date);
    do {
      nextDay.setDate(nextDay.getDate() + 1);
    } while (nextDay.getDay() === 0 || isMondayDeliveryBlackout(nextDay));
    return nextDay;
  }

  function isNextBusinessDay(baseDate, targetDate) {
    const nextDay = getNextBusinessDay(new Date(baseDate));
    return nextDay.getTime() === targetDate.getTime();
  }

  function getPerishableVariantPrice(variantTitle) {
    if (!variantTitle) { perishableLog('◆V2-PRICE◆ empty variantTitle passed'); return null; }
    const want = String(variantTitle).trim().toLowerCase();
    const variants = window.gtShippingProductVariants || [];
    perishableLog('◆V2-PRICE◆ lookup start', { searchTitle: want, globalVariantsCount: variants.length, allTitles: variants.map(function(v){ return v.title; }) });
    for (let i = 0; i < variants.length; i++) {
      if (String(variants[i].title || '').trim().toLowerCase() === want) {
        const vp = parseFloat(variants[i].price);
        perishableLog('◆V2-PRICE◆ MATCH in gtShippingProductVariants', { matchedTitle: variants[i].title, rawPrice: variants[i].price, computed: vp > 0 ? vp / 100 : 'ZERO/NaN' });
        if (!isNaN(vp) && vp > 0) return vp / 100;
      }
    }
    perishableLog('◆V2-PRICE◆ NOT found in gtShippingProductVariants, trying __GT_EXPEDITED_SHIPPING_PRODUCT__');
    const sp = window.__GT_EXPEDITED_SHIPPING_PRODUCT__;
    if (sp && sp.variants) {
      const v = sp.variants.find(function (vr) { return String(vr.title).trim().toLowerCase() === want; });
      if (v) {
        perishableLog('◆V2-PRICE◆ MATCH in __GT_EXPEDITED_SHIPPING_PRODUCT__', { matchedTitle: v.title, rawPrice: v.price, computed: parseFloat(v.price) > 0 ? parseFloat(v.price) / 100 : 'ZERO/NaN' });
        if (parseFloat(v.price) > 0) return parseFloat(v.price) / 100;
      } else {
        perishableLog('◆V2-PRICE◆ NOT found in expedited product', { availableTitles: sp.variants.map(function(vr){ return vr.title; }) });
      }
    }
    const $hiddenInput = $(`#ShippingStandard-${variantTitle}`);
    if ($hiddenInput.length) {
      const val = parseFloat($hiddenInput.val().replace(/[^0-9.]/g, ''));
      perishableLog('◆V2-PRICE◆ hidden input found', { id: 'ShippingStandard-' + variantTitle, value: $hiddenInput.val(), parsed: val });
      if (!isNaN(val) && val > 0) return val;
    }
    perishableLog('◆V2-PRICE◆ FAILED - no price found for "' + variantTitle + '"');
    return null;
  }

  /**
   * True when this weekday falls in the Standard shipping window for the ZIP zone
   * (not Overnight / Expedited). Saturdays / Sundays are never Standard.
   */
  function isStandardShippingWindowDate(dateWithoutTime, effectiveDateWithoutTime, zone) {
    if (!dateWithoutTime || dateWithoutTime.getDay() === 0 || dateWithoutTime.getDay() === 6) {
      return false;
    }
    const businessDaysDiff = getBusinessDaysDifference(effectiveDateWithoutTime, dateWithoutTime);
    if (businessDaysDiff < 0) return false;
    switch (zone) {
      case 'SCzones1':
        return businessDaysDiff >= 2;
      case 'SCzones2':
        return businessDaysDiff > 3;
      case 'SCzones3':
        return businessDaysDiff > 5;
      case 'SCzones4':
        return businessDaysDiff > 7;
      default:
        return true;
    }
  }

  function getCustomContent(date, $row) {
    const currentDate = getCurrentEasternTime();
    const effectiveDate = getEffectiveDate(currentDate, $row);
    const zipCode = $row.find('input[name="zip"]').val();
    const zone = checkZone(zipCode);
    const prices = {
      overnight: parseFloat($row.find("#Overnight-price").text().trim().replace('$', '')) || 0,
      expedited: parseFloat($row.find("#Expedited-price").text().trim().replace('$', '')) || 0,
      standard: parseFloat($row.find("#Standard-price").text().trim().replace('$', '')) || 0,
      saturday: parseFloat($row.find("#Saturday-price").text().trim().replace('$', '')) || 0
    };
    const dateWithoutTime = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const effectiveDateWithoutTime = new Date(effectiveDate.getFullYear(), effectiveDate.getMonth(), effectiveDate.getDate());
    const easternToday = normalizeCalendarDateBulk(currentDate);
    const earliestSelectable = hasPerishableProductTag($row)
      ? getPerishableEarliestSelectableBulk(currentDate, $row, effectiveDateWithoutTime)
      : effectiveDateWithoutTime;
    const perishableAnchor = normalizeCalendarDateBulk(earliestSelectable);

    // Disable past dates
    if (dateWithoutTime < earliestSelectable) {
      return {disabled: true};
    }

    // Handle Sundays
    if (dateWithoutTime.getDay() === 0) { // Sunday
      return {disabled: true, html: date.getDate().toString()};
    }

    // Disable Mondays through Oct 26, 2026 (available again from Nov 2, 2026)
    if (isMondayDeliveryBlackout(dateWithoutTime)) {
      return {disabled: true, html: date.getDate().toString()};
    }

    // EDIT MODE: only Standard delivery dates selectable (no Saturday / Overnight / Expedited)
    if (window.GT_BULK_EDIT_MODE) {
      if (!isStandardShippingWindowDate(dateWithoutTime, effectiveDateWithoutTime, zone)) {
        return { disabled: true, html: date.getDate().toString() };
      }
      const stdPrice = prices.standard > 0 ? prices.standard : 22.38;
      return {
        html: `${date.getDate()}<span data-price="$${stdPrice.toFixed(2)}" class="custom-content">$${stdPrice.toFixed(2)}</span>`
      };
    }

    // Handle Saturdays
    if (dateWithoutTime.getDay() === 6) { // Saturday
      const perishCheckSat = isPerishableActiveForRow($row);
      if ((perishCheckSat.active || (perishCheckSat.meta && isStrawberryPerishableMeta(perishCheckSat.meta))) && perishCheckSat.meta && metaHasPerishableVariantDays(perishCheckSat.meta)) {
        const perishDaysDiffSat = getPerishableDeliveryDaysDiff(easternToday, dateWithoutTime);
        const variantSlotSat = resolvePerishableVariantForDate(perishCheckSat.meta, dateWithoutTime, perishDaysDiffSat, perishCheckSat.stateAbbr, perishableAnchor);
        if (variantSlotSat) {
          const perishPriceSat = getPerishableVariantPrice(variantSlotSat.variantName);
          if (perishPriceSat !== null && perishPriceSat > 0) {
            return {
              html: `${date.getDate()}<span data-price="$${perishPriceSat.toFixed(2)}" data-perishable="true" data-variant-title="${variantSlotSat.variantName}" class="custom-content">$${perishPriceSat.toFixed(2)}</span>`
            };
          }
        }
        return { disabled: true, html: date.getDate().toString() };
      }
      const satGiftingMeta = findPerishableMeta(getRowProductTags($row));
      if (hasPerishableProductTag($row) && satGiftingMeta && isNonStrawberryGiftingCompanyMeta(satGiftingMeta)) {
        return { disabled: true, html: date.getDate().toString() };
      }
      return {
        html: `${date.getDate()}<span data-price="$${prices.saturday.toFixed(2)}" class="custom-content">$${prices.saturday.toFixed(2)}</span>`
      };
    }
    
    let price;
    const businessDaysDiff = getBusinessDaysDifference(effectiveDateWithoutTime, dateWithoutTime);

    const perishDaysDiff = hasPerishableProductTag($row)
      ? getPerishableDeliveryDaysDiff(easternToday, dateWithoutTime)
      : businessDaysDiff;
    const perishCheck = isPerishableActiveForRow($row);
    const perishMeta = perishCheck.meta || findPerishableMeta(getRowProductTags($row));
    const zipValForState = ($row.find('input[name="zip"]').val() || '').replace(/[^0-9]/g, '').slice(0, 5);
    const perishState = perishCheck.stateAbbr || getStateFromZipCached(zipValForState) || getRowStateAbbr($row);
    if (perishMeta && perishDaysDiff >= 0) {
      let variantSlot = null;
      if (perishCheck.active) {
        variantSlot = resolvePerishableVariantForDate(perishMeta, dateWithoutTime, perishDaysDiff, perishState, perishableAnchor);
      }
      if (!variantSlot && (perishDaysDiff <= 1 || (perishMeta && (isNonStrawberryGiftingCompanyMeta(perishMeta) || isStrawberryPerishableMeta(perishMeta))))) {
        variantSlot = resolvePerishableVariantForDate(perishMeta, dateWithoutTime, perishDaysDiff, perishState, perishableAnchor);
      }
      if (variantSlot) {
        const perishPrice = getPerishableVariantPrice(variantSlot.variantName);
        const slotName = 'shipping_variant_' + variantSlot.slot + ': ' + variantSlot.variantName;
        if (perishPrice !== null && perishPrice > 0) {
          perishableLog('◆V2-RENDER◆ SUCCESS override applied', { date: date.toDateString(), slot: slotName, price: perishPrice, dayOfWeek: dateWithoutTime.getDay(), perishDaysDiff: perishDaysDiff, variant1Days: perishMeta.shipping_variant_1_days, variant2Days: perishMeta.shipping_variant_2_days });
          return {
            html: `${date.getDate()}<span data-price="$${perishPrice.toFixed(2)}" data-perishable="true" data-variant-title="${variantSlot.variantName}" class="custom-content">$${perishPrice.toFixed(2)}</span>`,
            _perishSlot: slotName
          };
        }
        if (perishCheck.active) {
          perishableLog('◆V2-RENDER◆ FAILED price null/zero — disabled', { date: date.toDateString(), slot: slotName, variant1: perishMeta.shipping_variant_1, variant2: perishMeta.shipping_variant_2, priceResult: perishPrice });
          return { disabled: true, html: date.getDate().toString() };
        }
      }
      if ((perishCheck.active || (perishMeta && isStrawberryPerishableMeta(perishMeta))) && shouldDisablePerishableVariantDay(perishMeta, dateWithoutTime, perishDaysDiff, perishState, perishableAnchor)) {
        perishableLog('◆V2-RENDER◆ day not in variant days — disabled', { date: date.toDateString(), dayOfWeek: dateWithoutTime.getDay(), perishDaysDiff: perishDaysDiff, variant1Days: perishMeta.shipping_variant_1_days, variant2Days: perishMeta.shipping_variant_2_days });
        return { disabled: true, html: date.getDate().toString() };
      }
      if (
        hasPerishableProductTag($row) &&
        perishDaysDiff <= 1 &&
        !(perishMeta && isNonStrawberryGiftingCompanyMeta(perishMeta) && metaHasPerishableVariantDays(perishMeta))
      ) {
        if (perishDaysDiff === 0 && prices.overnight > 0) {
          return {
            html: `${date.getDate()}<span data-price="$${prices.overnight.toFixed(2)}" id="Overnight-price" class="custom-content">$${prices.overnight.toFixed(2)}</span>`
          };
        }
        if (perishDaysDiff === 1 && prices.expedited > 0) {
          return {
            html: `${date.getDate()}<span data-price="$${prices.expedited.toFixed(2)}" id="Expedited-price" class="custom-content">$${prices.expedited.toFixed(2)}</span>`
          };
        }
      }
    }

    switch (zone) {
      case "SCzones1":
        price = businessDaysDiff === 0 ? prices.overnight : businessDaysDiff === 1 ? prices.expedited : prices.standard;
        break;
      case "SCzones2":
        price = businessDaysDiff === 0 ? prices.overnight : businessDaysDiff <= 3 ? prices.expedited : prices.standard;
        break;
      case "SCzones3":
        price = businessDaysDiff === 0 ? prices.overnight : businessDaysDiff <= 5 ? prices.expedited : prices.standard;
        break;
      case "SCzones4":
        // Service Days 7 and 8: overnight for same day, expedited for next seven days, standard for all other days
        price = businessDaysDiff === 0 ? prices.overnight : businessDaysDiff <= 7 ? prices.expedited : prices.standard;
        break;
      default:
        price = prices.standard;
    }
    return {
      html: `${date.getDate()}<span data-price="$${price.toFixed(2)}" class="custom-content">$${price.toFixed(2)}</span>`
    };
  }

  function getBusinessDaysDifference(startDate, endDate) {
    let count = 0;
    const curDate = new Date(startDate.getTime());
    while (curDate <= endDate) {
      const dayOfWeek = curDate.getDay();
      if (dayOfWeek !== 0 && dayOfWeek !== 6 && !isHoliday(curDate)) count++;
      curDate.setDate(curDate.getDate() + 1);
    }
    return count - 1; // Subtract 1 because we want 0 for the first business day
  }

  function addBusinessDays(date, days) {
    let result = new Date(date);
    let addedDays = 0;
    while (addedDays < days) {
      result.setDate(result.getDate() + 1);
      if (result.getDay() !== 0 && result.getDay() !== 6 && !isHoliday(result)) {
        addedDays++;
      }
    }
    return result;
  }

  function isSameDate(date1, date2) {
    return date1.getTime() === date2.getTime();
  }

  function isWithinBusinessDays(startDate, endDate, days) {
    return getBusinessDaysDifference(startDate, endDate) <= days;
  }

  function isHoliday(date) {
    const holidays = [
      new Date(date.getFullYear(), 11, 25), // Christmas
      new Date(date.getFullYear(), 0, 1), // New Year's Day
      new Date(2026, 6, 3), // Friday, July 3, 2026
    ];
    return holidays.some(holiday => 
      date.getDate() === holiday.getDate() && 
      date.getMonth() === holiday.getMonth() && 
      date.getFullYear() === holiday.getFullYear()
    );
  }

  function initializeDatepicker($row) {
    const $dateInput = $row.find('input[name="delivery_date"]');
    const $calendarButton = $row.find(".calendar_modal");
    const $zipInput = $row.find('input[name="zip"]');
    const $deliveryDateCover = $row.find('.delivery-date_cover');

    // Destroy existing datepicker if it exists
    if ($dateInput[0].datepicker) {
      $dateInput[0].datepicker.destroy();
    }

    const datepicker = new AirDatepicker($dateInput[0], {
      locale: {
        days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
        months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        today: "Today",
        clear: "Clear",
        dateFormat: "MM/dd/yyyy",
        timeFormat: "HH:mm aa",
        firstDay: 0
      },
      minDate: getCurrentEasternTime(),
      onSelect: ({date}) => {
        if (date) {
          // Use calendar Y/M/D at noon — AirDatepicker can hand back UTC midnight
          const safe = toCalendarDate(date) || calendarDateAtNoon(date.getFullYear(), date.getMonth(), date.getDate());
          const formattedDate = formatDate(safe);
          $dateInput.val(formattedDate);
          updateEstimatedDeliveryDate($row);
          $deliveryDateCover.removeClass('disabled');
          $row.find(".shipping-fee").closest('dt, dd').show();
          datepicker.hide();
        }
      },
      onRenderCell: ({date, cellType}) => {
        if (cellType === 'day') {
          const customContent = getCustomContent(date, $row);
          if (isHoliday(date)) {
            customContent.disabled = true;
            customContent.classes = 'holiday';
            customContent.html = `<span class="holiday-date">${date.getDate()}</span>`;
          }
          return customContent;
        }
      }
    });

    // Store the datepicker instance on the input element for easy access
    $dateInput[0].datepicker = datepicker;

    $calendarButton.on("click", function() {
      if (!$(this).prop('disabled')) {
        
        datepicker.show();
      }
    });

    $zipInput.on('change', function() {
      
      validateZipAndActivateCalendar($(this));
    });

    const savedDate = $dateInput.val();
    if (savedDate) {
      
      setDatepickerDate($row, savedDate);
      $deliveryDateCover.removeClass('disabled');
    }
  }

  function destroyDatepicker($row) {
    const $dateInput = $row.find('input[name="delivery_date"]');
    if ($dateInput[0] && $dateInput[0].datepicker) {
      $dateInput[0].datepicker.destroy();
      delete $dateInput[0].datepicker;
    }
  }

  // Add this new function to set the delivery date in the datepicker
  
   function setDatepickerDate($row, date) {
    const $dateInput = $row.find('input[name="delivery_date"]');
    if (!$dateInput.length || !$dateInput[0]) return;

    let datepicker = $dateInput[0].datepicker;

    if (!datepicker) {
      initializeDatepicker($row);
      datepicker = $dateInput[0].datepicker;
    }

    if (datepicker && date) {
      const currentDate = getCurrentEasternTime();
      const effectiveDate = getEffectiveDate(currentDate, $row);

      // Always normalize via toCalendarDate (fixes SheetJS UTC midnight → Dec 16 in US TZ)
      let resolvedDate = toCalendarDate(date);
      if (!resolvedDate && date instanceof Date && !isNaN(date.getTime())) {
        resolvedDate = calendarDateAtNoon(date.getFullYear(), date.getMonth(), date.getDate());
      }

      if (resolvedDate instanceof Date && !isNaN(resolvedDate) && resolvedDate >= effectiveDate) {
        const customContent = getCustomContent(resolvedDate, $row);

        if (!customContent.disabled) {
          const formattedDate = formatDate(resolvedDate);
          // Set text first so a late onSelect cannot leave a shifted day
          $dateInput.val(formattedDate);
          $dateInput.attr(
            'data-excel-ymd',
            resolvedDate.getFullYear() + '-' +
              String(resolvedDate.getMonth() + 1).padStart(2, '0') + '-' +
              String(resolvedDate.getDate()).padStart(2, '0')
          );
          try {
            datepicker.selectDate(resolvedDate);
          } catch (err) {
            console.warn('datepicker.selectDate failed', err);
          }
          // Re-assert after selectDate (AirDatepicker onSelect can overwrite with TZ-shifted day)
          $dateInput.val(formattedDate);
          updateEstimatedDeliveryDate($row);
          $row.find('.delivery-date_cover').removeClass('disabled');
        } else {
          console.warn(`Date ${resolvedDate} is not selectable for row ${$row.index()}`);
          $dateInput.val('');
        }
      } else {
        console.warn(`Invalid date: ${date} for row ${$row.index()}. Setting to effective date.`);
        $dateInput.val('');
        updateEstimatedDeliveryDate($row);
        $row.find('.delivery-date_cover').removeClass('disabled');
      }
    } else {
      console.warn(`Unable to set date for row ${$row.index()}. Datepicker or date is missing.`);
      $dateInput.val('');
    }
  }


  // Add a new function to handle ZIP code validation and calendar activation
  function validateZipAndActivateCalendar($zipInput) {
    const zip = $zipInput.val().trim();
    const cleanZip = zip.replace(/[^0-9]/g, '').slice(0, 5);
    const isValidZip = checkZone(cleanZip);
    const $row = $zipInput.closest("tr");
    const $deliveryDateCover = $row.find('.delivery-date_cover');
    const $deliveryDateInput = $row.find('input[name="delivery_date"]');

    $zipInput.val(cleanZip); // Set the cleaned ZIP code

    if (isValidZip) {
      let zone = checkZone(cleanZip);
      $zipInput.attr("zone", zone);
      $zipInput.removeClass("zoneisNotAvailable");
      $row.addClass("zoneisAvailable");
      $deliveryDateCover.removeClass('disabled');
      
      // Reinitialize datepicker with new ZIP, but keep the existing date
      const existingDate = $deliveryDateInput.val();
      initializeDatepicker($row);
      if (existingDate) {
        setDatepickerDate($row, existingDate);
      }
    } else {
      $zipInput.removeAttr("zone");
      $zipInput.addClass("zoneisNotAvailable");
      $row.removeClass("zoneisAvailable");
      $deliveryDateCover.addClass('disabled');
    }

    // If a delivery date is set, ensure the cover is not disabled
    if ($deliveryDateInput.val()) {
      $deliveryDateCover.removeClass('disabled');
    }
  }

  function formatDate(date) {
    // Format from local calendar parts only — never UTC/timezone conversion
    if (!(date instanceof Date) || isNaN(date.getTime())) return '';
    // Normalize to noon so DST / UTC midnight never shifts the calendar day
    const safe = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12, 0, 0);
    const months = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    return months[safe.getMonth()] + " " + safe.getDate() + ", " + safe.getFullYear();
  }

  /**
   * Parse a display date like "December 17, 2026" as a local calendar date
   * (avoids new Date(string) timezone off-by-one).
   */
  function parseLocalDisplayDate(value) {
    if (value instanceof Date && !isNaN(value.getTime())) {
      return calendarDateAtNoon(value.getFullYear(), value.getMonth(), value.getDate());
    }
    if (typeof value !== 'string') return null;
    const trimmed = value.trim();
    if (!trimmed) return null;

    const named = trimmed.match(/^([A-Za-z]+)\s+(\d{1,2}),?\s*(\d{4})$/);
    if (named) {
      const months = {
        january: 0, february: 1, march: 2, april: 3, may: 4, june: 5,
        july: 6, august: 7, september: 8, october: 9, november: 10, december: 11
      };
      const mi = months[named[1].toLowerCase()];
      if (mi != null) {
        return calendarDateAtNoon(parseInt(named[3], 10), mi, parseInt(named[2], 10));
      }
    }

    // Excel short month: 17-Dec-2026 or 17-Dec-26
    const dMonY = trimmed.match(/^(\d{1,2})[\/\-\s]+([A-Za-z]{3,9})[\/\-\s]+(\d{2,4})$/);
    if (dMonY) {
      const months = {
        jan: 0, january: 0, feb: 1, february: 1, mar: 2, march: 2,
        apr: 3, april: 3, may: 4, jun: 5, june: 5, jul: 6, july: 6,
        aug: 7, august: 7, sep: 8, sept: 8, september: 8,
        oct: 9, october: 9, nov: 10, november: 10, dec: 11, december: 11
      };
      const mi = months[dMonY[2].toLowerCase()];
      if (mi != null) {
        let y = parseInt(dMonY[3], 10);
        if (y < 100) y += 2000;
        return calendarDateAtNoon(y, mi, parseInt(dMonY[1], 10));
      }
    }

    // M/D/YYYY or M-D-YYYY (also 2-digit year from Excel)
    const mdy = trimmed.match(/^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{2,4})$/);
    if (mdy) {
      let y = parseInt(mdy[3], 10);
      if (y < 100) y += 2000;
      return calendarDateAtNoon(y, parseInt(mdy[1], 10) - 1, parseInt(mdy[2], 10));
    }

    const iso = trimmed.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
    if (iso) {
      return calendarDateAtNoon(parseInt(iso[1], 10), parseInt(iso[2], 10) - 1, parseInt(iso[3], 10));
    }
    return null;
  }

  function calendarDateAtNoon(year, monthIndex, day) {
    return new Date(year, monthIndex, day, 12, 0, 0);
  }

  /** Build a local noon Date from any Excel/SheetJS/string value without TZ shift. */
  function toCalendarDate(value) {
    if (value == null || value === '') return null;

    if (value instanceof Date && !isNaN(value.getTime())) {
      // SheetJS excel dates are UTC midnight for the calendar day — always use UTC Y/M/D
      if (
        value.getUTCHours() === 0 &&
        value.getUTCMinutes() === 0 &&
        value.getUTCSeconds() === 0
      ) {
        return calendarDateAtNoon(
          value.getUTCFullYear(),
          value.getUTCMonth(),
          value.getUTCDate()
        );
      }
      return calendarDateAtNoon(value.getFullYear(), value.getMonth(), value.getDate());
    }

    if (typeof value === 'number' || (typeof value === 'string' && /^\d+(\.\d+)?$/.test(String(value).trim()))) {
      const serial = Number(value);
      if (!isFinite(serial) || serial <= 0) return null;
      const utcMs = Math.round((serial - 25569) * 86400 * 1000);
      const utc = new Date(utcMs);
      return calendarDateAtNoon(utc.getUTCFullYear(), utc.getUTCMonth(), utc.getUTCDate());
    }

    if (typeof value === 'string') {
      return parseLocalDisplayDate(value);
    }

    return null;
  }

  function updateEstimatedDeliveryDate($row) {
    const $deliveryDateInput = $row.find('input[name="delivery_date"]');
    logPerishableRowTrace('updateEstimatedDeliveryDate', $row, { deliveryRaw: $deliveryDateInput.val() });

    if (!$deliveryDateInput.val()) {
      return;
    }
    const selectedDate = parseLocalDisplayDate($deliveryDateInput.val());
    if (!selectedDate || isNaN(selectedDate.getTime())) {
      perishableLog('updateEstimatedDeliveryDate: invalid date — abort row update', { raw: $deliveryDateInput.val() });
      return;
    }

    const $shippingMethodInputs = $row.find('input[name^="shipping-"]');
    $shippingMethodInputs.prop('checked', false);

    // EDIT MODE: always lock to Standard — ignore Saturday / Overnight / Expedited / perishable
    if (window.GT_BULK_EDIT_MODE) {
      const currentDate = getCurrentEasternTime();
      const effectiveDate = getEffectiveDate(currentDate, $row);
      const effectiveDateWithoutTime = new Date(effectiveDate.getFullYear(), effectiveDate.getMonth(), effectiveDate.getDate());
      const dateWithoutTime = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate());
      const zone = checkZone($row.find('input[name="zip"]').val());
      if (!isStandardShippingWindowDate(dateWithoutTime, effectiveDateWithoutTime, zone)) {
        $deliveryDateInput.val('');
        $row.find('.delivery-date_cover').addClass('disabled');
        if (typeof eboForceStandardShippingOnly === 'function') eboForceStandardShippingOnly($row);
        return;
      }
      if (typeof eboForceStandardShippingOnly === 'function') eboForceStandardShippingOnly($row);
      else {
        $shippingMethodInputs.filter('[value="' + GT_STANDARD_SHIPPING_VARIANT_ID + '"]').prop('checked', true).prop('disabled', false);
      }
      const $std = $row.find('input[name^="shipping-"]:checked');
      let shippingPrice = typeof parseShippingDataPrice === 'function' ? parseShippingDataPrice($std) : NaN;
      if (isNaN(shippingPrice) || shippingPrice <= 0) {
        shippingPrice = parseFloat(String($row.find('#Standard-price').text() || '').replace(/[^0-9.]/g, '')) || 22.38;
      }
      const $priceInfo = $row.find('.tooltip-content .multiship-product__details');
      const giftPrice = parseFloat($priceInfo.find('.gift-fee').text().replace('$', '')) || 0;
      const ribbonFee = parseFloat($priceInfo.find('.ribbon-fee').text().replace('$', '')) || 0;
      const signatureFee = parseFloat($priceInfo.find('.signature-fee').text().replace('$', '')) || 0;
      $row.find('.delivery-estimate').html(
        'Estimated Delivery Date: <b data-date="' + formatDate(selectedDate) + '" class="delivery-date">' + formatDate(selectedDate) + '</b>'
      );
      updatePriceInfo($row, giftPrice, shippingPrice, signatureFee, ribbonFee > 0);
      return;
    }

    const perishableHandled = tryApplyPerishableCalendarShipping($row, selectedDate);
    let shippingPrice;

    if (perishableHandled) {
      const $checked = $row.find('input[name^="shipping-"]:checked');
      const rawDataPrice = String($checked.data('price') || '').replace(/[^0-9.]/g, '');
      if (rawDataPrice) {
        shippingPrice = parseFloat(rawDataPrice) || 22.38;
      } else {
        const sp = window.__GT_EXPEDITED_SHIPPING_PRODUCT__;
        const vid = $checked.val();
        const v = sp && sp.variants ? sp.variants.find(function (vr) { return String(vr.id) === String(vid); }) : null;
        shippingPrice = v ? parseFloat(v.price) / 100 : 22.38;
      }
      perishableLog('updateEstimatedDeliveryDate: perishable path — price from selected variant radio', {
        shippingPrice: shippingPrice,
        variantTitle: $checked.attr('data-variant-title'),
        variantId: $checked.val()
      });
    } else {
      const customContent = getCustomContent(selectedDate, $row);
      const $priceSpan = $('<div>').html(customContent.html).find('span');
      shippingPrice = parseFloat($priceSpan.data('price')?.replace(/[^0-9.]/g, '')) || 22.38;
      const isSaturday = selectedDate.getDay() === 6;

      let methodFound = false;
      $shippingMethodInputs.each(function() {
          const $method = $(this).closest('.multiship-method');
          const $priceElement = $method.find('.multiship-method__price');
          const methodPrice = $priceElement.text().trim();
          const methodTitle = $method.find('label div:first').text().trim().toLowerCase();
          if (isSaturday && methodTitle.includes('saturday') || !isSaturday && methodPrice === $priceSpan.data('price')) {
              $(this).prop('checked', true);
              methodFound = true;
              return false;
          }
      });

      if (!methodFound) {
          $shippingMethodInputs.each(function() {
              const $priceElement = $(this).closest('.multiship-method').find('.multiship-method__price');
              if ($priceElement.text().trim() === $priceSpan.data('price')) {
                  $(this).prop('checked', true);
                  return false;
              }
          });
      }
    }

    const $priceInfo = $row.find(".tooltip-content .multiship-product__details");
    const giftPrice = parseFloat($priceInfo.find(".gift-fee").text().replace('$', '')) || 0;
    const ribbonFee = parseFloat($priceInfo.find(".ribbon-fee").text().replace('$', '')) || 0;
    const signatureFee = parseFloat($priceInfo.find(".signature-fee").text().replace('$', '')) || 0;

    const $deliveryEstimate = $row.find('.delivery-estimate');
    $deliveryEstimate.html(`Estimated Delivery Date: <b data-date="${formatDate(selectedDate)}" class="delivery-date">${formatDate(selectedDate)}</b>`);

    updatePriceInfo($row, giftPrice, shippingPrice, signatureFee, ribbonFee > 0);
  }

  function validateCardMessages() {
    let isValid = true;
    let emptyRows = [];
    let errorRows = [];
    
    table.rows().every(function(index) {
      const $row = $(this.node());
      const rowData = getRowData($row, index);
      let rowHasError = false;

      const setErrorState = (condition, $element, errorMessage) => {
        if (condition) {
          isValid = false;
          rowHasError = true;
          $row.addClass("error");
          $element.closest("td").addClass("error");
          if (errorMessage) {
            // Uncomment the following lines if you want to display error messages
            // const $errorMessageElement = $element.siblings(".form__message");
            // if ($errorMessageElement.length) {
            //   $errorMessageElement.text(errorMessage);
            // } else {
            //   $('<div class="form__message">' + errorMessage + "</div>").insertAfter($element);
            // }
          }
        } else {
          $element.closest("td").removeClass("error");
          // $element.siblings(".form__message").remove();
        }
      };

      // Address, delivery date, and card message are optional (filled later via metafield update).
      // Still require product + shipping method (validated in validateRowData).
      setErrorState(!rowData.productId, $row.find('select[name="products"]'), "Please select a product");
      const zipVal = (rowData.zip || '').replace(/^0+/, '');
      if (zipVal) {
        setErrorState(rowData.productId && !checkZone(zipVal), $row.find('input[name="zip"]'), "Please enter a valid ZIP code");
      } else {
        $row.find('input[name="zip"]').closest("td").removeClass("error");
      }
      $row.find(".multiship-card__message").closest("td").removeClass("error");
      $row.find('input[name="delivery_date"]').closest("td").removeClass("error");
      
      const $personalMessageContainer = $row.find('.personal-message-container');
      const $personalMessageTextareas = $personalMessageContainer.find('.personal-message__body');
      const $noMessageCheckbox = $row.find('input[name="opt-out-personal-message"]');

      let personalMessageError = false;
      let errorMessage = "";
      function containsEmoji(text) {
        const emojiRegex = /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F1E0}-\u{1F1FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/u;
        return emojiRegex.test(text);
      }

      if ($personalMessageContainer.is(":visible")) {
        if (!$noMessageCheckbox.prop('checked')) {
          $personalMessageTextareas.each(function() {
            const messageText = $(this).val().trim();
            if (messageText === "") {
              personalMessageError = true;
              errorMessage = "Personal Message is required";
            } else if (containsEmoji(messageText)) {
              personalMessageError = true;
              errorMessage = "Emojis are not allowed in Personal Message";
            }
          });
        }
      }

      setErrorState(personalMessageError, $personalMessageContainer, errorMessage);

      // Address fields optional — clear any prior error styles
      ['firstName', 'lastName', 'address1', 'city', 'country', 'province'].forEach(field => {
          $row.find(`[name="${field}"]`).closest("td").removeClass("error");
      });

      // Track empty rows (product still required)
      if (!rowData.productId) {
        emptyRows.push(index + 1);
      }

      if (rowHasError) {
        errorRows.push(index);
      }
    });

    // Display error message if form is not valid
    if (!isValid) {
      let errorMessage = "Please fix the errors in your order details.";
      if (emptyRows.length > 0) {
        errorMessage += ` Missing information in row(s): ${emptyRows.join(", ")}.`;
      }
      // alert(errorMessage);

      // Scroll to the first error
      if (errorRows.length > 0) {
        const $firstErrorRow = $(table.row(errorRows[0]).node());
        $('html, body').animate({
          scrollTop: $firstErrorRow.offset().top - 100
        }, 500);
      }
    }

    return isValid;
  }

  function clearErrorStyles($row) {
    $row.removeClass("error");
  }


  // File upload handling
  $('#fileInput').on('change', function(e) {
    const file = e.target.files[0];
    if (!file) {
      alert('No file selected. Please choose an Excel file to upload.');
      return;
    }
  
    const reader = new FileReader();
    const $fileUploadLoader = $('#fileUploadLoader');
    $fileUploadLoader.show();
  
    function updateProgress(progress) {
      $fileUploadLoader.find('.progress-bar').css('width', `${progress}%`);
    }
  
    reader.onload = function(e) {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array', cellDates: false, cellText: true });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const json = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: null, raw: false });
  
        const filteredJson = json.filter((row, index) => 
          index === 0 || (row.some(cell => cell !== null && cell !== '') && row[0] !== null && row[0] !== '')
        );

        // EDIT MODE: update recipient fields on existing gifts only — no new products
        if (window.GT_BULK_EDIT_MODE) {
          processEditModeExcelUpload(filteredJson, $fileUploadLoader, updateProgress);
          return;
        }
  
        // Clear existing table data
        table.clear().draw();
        
        // Set flag to prevent state overrides during Excel processing
        window.isProcessingExcel = true;
        
        // Smart optimization: Populate dropdowns once for all rows
        const rowsToProcess = filteredJson.slice(1);
        
        // Process rows in batches for better performance
        const batchSize = 20; // Process 20 rows at a time
        let currentBatch = 0;
        
        function processBatch() {
          const startIndex = currentBatch * batchSize;
          const endIndex = Math.min(startIndex + batchSize, rowsToProcess.length);
          
          // Create all rows for this batch
          const batchRows = [];
          for (let i = startIndex; i < endIndex; i++) {
            const newRowData = createRow(i + 1);
            batchRows.push(newRowData);
          }
          
          // Add all rows to table at once
          table.rows.add(batchRows).draw(false);
          
          // Populate dropdowns once for all rows in this batch
          populateAllDropdowns();
          
          // Initialize country/province selectors for the new rows
          const newRowIndices = [];
          for (let i = startIndex; i < endIndex; i++) {
            newRowIndices.push(table.rows().count() - (endIndex - i));
          }
          
          // Initialize state dropdowns for new rows
          newRowIndices.forEach(rowIndex => {
            const $newRow = $(table.row(rowIndex).node());
            initializeCountryProvinceSelectors($newRow[0]); // Pass the DOM element
          });
          
          // Process each row in the batch
          for (let i = startIndex; i < endIndex; i++) {
            const row = rowsToProcess[i];
            const $newRow = $(table.row(table.rows().count() - (endIndex - i)).node());
            populateRowFromExcel($newRow, row);
          }
          
          // Update progress
          const progress = ((endIndex) / rowsToProcess.length) * 100;
          updateProgress(progress);
          
          currentBatch++;
          
          // Continue with next batch
          if (endIndex < rowsToProcess.length) {
            requestAnimationFrame(processBatch);
          } else {
            // All rows processed, finalize
            setTimeout(async () => {
              // Initialize datepickers and validate zip codes for all rows
              table.rows().every(function(rowIdx) {
                const $row = $(this.node());
                initializeDatepicker($row);
                // Re-apply Excel calendar day AFTER datepicker init (prevents Dec 16 TZ shift)
                const ymd = $row.find('input[name="delivery_date"]').attr('data-excel-ymd');
                if (ymd) {
                  const parts = ymd.split('-').map(Number);
                  if (parts.length === 3 && parts[0] && parts[1] && parts[2]) {
                    setDatepickerDate($row, calendarDateAtNoon(parts[0], parts[1] - 1, parts[2]));
                  }
                }
                validateZipAndActivateCalendar($row.find('input[name="zip"]'));
              });
              
              // Initialize country/province selectors
              initializeCountryProvinceSelectors();
              
              // Calculate totals and wait for completion
              calculateTotals();
              
              // Update age verification and submit button
              updateAgeVerificationAndSubmitButton();
              
              // Clear Excel processing flag
              window.isProcessingExcel = false;
              
              // Update progress to show finalization
              updateProgress(100);
              
              // Fetch inventory for all products in the table
              const productHandles = new Set();
              table.rows().every(function(rowIdx) {
                const $row = $(this.node());
                const $select = $row.find('select[name="products"]');
                const selectedOption = $select.find('option:selected');
                if (selectedOption.length && selectedOption.val()) {
                  const productHandle = selectedOption.attr('data-url')?.replace('/products/', '');
                  if (productHandle) {
                    productHandles.add(productHandle);
                  }
                }
              });
              
              // Fetch inventory for all unique products
              const inventoryPromises = Array.from(productHandles).map(handle => fetchProductInventory(handle));
              await Promise.all(inventoryPromises);
              
              // Validate inventory after file upload
              const inventoryErrors = await validateInventory();
              if (inventoryErrors.length > 0) {
                displayInventoryErrors(inventoryErrors);
              }
              
              // Wait for totals calculation to complete, then hide loader
              setTimeout(() => {
                // Double-check that totals are calculated
                setTimeout(() => {
                  $fileUploadLoader.hide();
                }, 500); // Additional delay to ensure totals are fully calculated
              }, 1000); // Wait for calculateTotals to complete
              
            }, 500);
          }
        }
        
        // Start batch processing
        processBatch();
      } catch (error) {
        console.error('Error processing file:', error);
        $fileUploadLoader.hide();
        alert('An error occurred while processing the file. Please make sure it\'s a valid Excel file and try again.');
      }
    };
  
    reader.onerror = function(error) {
      console.error('Error reading file:', error);
      $fileUploadLoader.hide();
      alert('An error occurred while reading the file. Please try again.');
    };
  
    reader.readAsArrayBuffer(file);
    setTimeout(function() { 
      DefaultCountySelection();
    }, 100);
  });

  /**
   * Edit Bulk Order spreadsheet upload:
   * - Requires order already loaded into the table
   * - Row count must match existing gifts exactly
   * - Matches by Gift # (product id), NOT table/spreadsheet row order
   *   (metafield load order often differs from the Excel row order)
   * - Duplicate Gift #s are paired in remaining-pool order (FIFO)
   * - Updates address / delivery date / card message only — no product add/change
   */
  function processEditModeExcelUpload(filteredJson, $fileUploadLoader, updateProgress) {
    const $existingRows = $('#orderTableBody tr[data-ebo-gid]');
    const existingCount = $existingRows.length;
    const excelRows = (filteredJson || []).slice(1);

    function normalizeProductId(raw) {
      if (raw == null) return '';
      let s = String(raw).trim();
      if (!s) return '';
      // Excel often emits 12345.0 for numeric IDs
      if (/^\d+\.0+$/.test(s)) s = s.replace(/\.0+$/, '');
      return s;
    }

    function normalizeName(raw) {
      return String(raw == null ? '' : raw).trim().toLowerCase().replace(/\s+/g, ' ');
    }

    if (!window.GT_EDIT_OWNER || !window.GT_EDIT_LINE_ITEMS || !existingCount) {
      $fileUploadLoader.hide();
      alert('Load an order into the table first, then upload the spreadsheet to update addresses and card messages.');
      return;
    }

    if (!excelRows.length) {
      $fileUploadLoader.hide();
      alert('No gift rows found in the spreadsheet.');
      return;
    }

    if (excelRows.length !== existingCount) {
      $fileUploadLoader.hide();
      alert(
        'Upload blocked: spreadsheet has ' + excelRows.length + ' gift row(s) but this order has ' +
        existingCount + '.\n\nRow count must match exactly — you cannot add extra products or remove gifts via upload.'
      );
      return;
    }

    // Index loaded table rows by product id (and keep full unused list for name fallback)
    const unusedRows = [];
    $existingRows.each(function () {
      const $row = $(this);
      const productId = normalizeProductId($row.find('select[name="products"]').val());
      const productName = normalizeName($row.find('select[name="products"] option:selected').text());
      unusedRows.push({
        $row: $row,
        productId: productId,
        productName: productName,
        gid: String($row.attr('data-ebo-gid') || '')
      });
    });

    const pairs = [];
    const mismatches = [];

    excelRows.forEach(function (excelRow, excelIndex) {
      const excelProductId = normalizeProductId(excelRow[1]);
      const excelGiftName = normalizeName(excelRow[0]);
      let matchIndex = -1;

      // 1) Prefer exact Gift # (product id) match — order-independent
      if (excelProductId) {
        matchIndex = unusedRows.findIndex(function (r) {
          return r.productId && r.productId === excelProductId;
        });
      }

      // 2) Fallback: gift title match when Gift # missing or not found
      if (matchIndex < 0 && excelGiftName) {
        matchIndex = unusedRows.findIndex(function (r) {
          if (!r.productName) return false;
          return (
            r.productName === excelGiftName ||
            r.productName.indexOf(excelGiftName) !== -1 ||
            excelGiftName.indexOf(r.productName) !== -1
          );
        });
      }

      if (matchIndex < 0) {
        mismatches.push(
          'Spreadsheet row ' + (excelIndex + 1) + ': no unmatched order gift for Gift # "' +
          (excelProductId || '(missing)') + '"' +
          (excelGiftName ? ' / "' + excelRow[0] + '"' : '') + '.'
        );
        return;
      }

      const matched = unusedRows.splice(matchIndex, 1)[0];
      pairs.push({ excelRow: excelRow, excelIndex: excelIndex, rowMeta: matched });
    });

    if (mismatches.length || unusedRows.length) {
      $fileUploadLoader.hide();
      const leftover = unusedRows.map(function (r) {
        return 'Gift # ' + (r.productId || '?') + (r.productName ? ' (' + r.productName + ')' : '');
      });
      alert(
        'Upload blocked — could not map spreadsheet rows to the loaded metafield gifts (order may differ; matching is by Gift #).\n\n' +
        mismatches.slice(0, 10).join('\n') +
        (mismatches.length > 10 ? '\n…and ' + (mismatches.length - 10) + ' more' : '') +
        (leftover.length ? '\n\nUnmatched order gifts left: ' + leftover.slice(0, 8).join(', ') : '')
      );
      return;
    }

    window.isProcessingExcel = true;
    updateProgress(10);

    const updatedRows = [];
    pairs.forEach(function (pair, i) {
      populateRowFromExcel(pair.rowMeta.$row, pair.excelRow, { recipientOnly: true });
      updatedRows.push(pair.rowMeta.$row);
      updateProgress(10 + Math.round(((i + 1) / pairs.length) * 70));
    });

    setTimeout(function () {
      updatedRows.forEach(function ($row) {
        initializeDatepicker($row);
        const ymd = $row.find('input[name="delivery_date"]').attr('data-excel-ymd');
        if (ymd) {
          const parts = ymd.split('-').map(Number);
          if (parts.length === 3 && parts[0] && parts[1] && parts[2]) {
            setDatepickerDate($row, calendarDateAtNoon(parts[0], parts[1] - 1, parts[2]));
          }
        }
        validateZipAndActivateCalendar($row.find('input[name="zip"]'));
        if (typeof eboForceStandardShippingOnly === 'function') {
          eboForceStandardShippingOnly($row);
        }
        if ($row.find('input[name="delivery_date"]').val() && typeof updateEstimatedDeliveryDate === 'function') {
          try { updateEstimatedDeliveryDate($row); } catch (err) { /* ignore */ }
        }
      });

      if (typeof initializeCountryProvinceSelectors === 'function') {
        initializeCountryProvinceSelectors();
      }
      if (typeof calculateTotals === 'function') calculateTotals();

      window.isProcessingExcel = false;
      updateProgress(100);

      const $status = $('#ebo-status');
      const successMsg =
        'Spreadsheet applied to ' + existingCount +
        ' gift(s) matched by Gift # (row order ignored): addresses / delivery dates / card messages updated. Products unchanged. Click Save Metafield when ready.';
      if ($status.length) {
        $status.attr('class', 'ebo-status ebo-status--success').text(successMsg).show();
      } else {
        alert(successMsg);
      }

      setTimeout(function () {
        $fileUploadLoader.hide();
      }, 400);
    }, 600);
  }

  function populateRowFromExcel($row, excelData, options) {
  options = options || {};
  const recipientOnly = !!options.recipientOnly;
  // State abbreviations mapping
  const stateAbbreviations = {
    'Alabama': 'AL',
    'Alaska': 'AK',
    'Arizona': 'AZ',
    'Arkansas': 'AR',
    'California': 'CA',
    'Colorado': 'CO',
    'Connecticut': 'CT',
    'Delaware': 'DE',
    'Florida': 'FL',
    'Georgia': 'GA',
    'Hawaii': 'HI',
    'Idaho': 'ID',
    'Illinois': 'IL',
    'Indiana': 'IN',
    'Iowa': 'IA',
    'Kansas': 'KS',
    'Kentucky': 'KY',
    'Louisiana': 'LA',
    'Maine': 'ME',
    'Maryland': 'MD',
    'Massachusetts': 'MA',
    'Michigan': 'MI',
    'Minnesota': 'MN',
    'Mississippi': 'MS',
    'Missouri': 'MO',
    'Montana': 'MT',
    'Nebraska': 'NE',
    'Nevada': 'NV',
    'New Hampshire': 'NH',
    'New Jersey': 'NJ',
    'New Mexico': 'NM',
    'New York': 'NY',
    'North Carolina': 'NC',
    'North Dakota': 'ND',
    'Ohio': 'OH',
    'Oklahoma': 'OK',
    'Oregon': 'OR',
    'Pennsylvania': 'PA',
    'Rhode Island': 'RI',
    'South Carolina': 'SC',
    'South Dakota': 'SD',
    'Tennessee': 'TN',
    'Texas': 'TX',
    'Utah': 'UT',
    'Vermont': 'VT',
    'Virginia': 'VA',
    'Washington': 'WA',
    'West Virginia': 'WV',
    'Wisconsin': 'WI',
    'Wyoming': 'WY',
    'American Samoa': 'AS',
    'Armed Forces Americas': 'AA',
    'Armed Forces Europe': 'AE',
    'Armed Forces Pacific': 'AP',
    'Washington DC': 'DC',
    'District of Columbia': 'DC',
    'Micronesia': 'FM',
    'Guam': 'GU',
    'Marshall Islands': 'MH',
    'Northern Mariana Islands': 'MP',
    'Palau': 'PW',
    'Puerto Rico': 'PR',
    'U.S. Virgin Islands': 'VI',
    'Virgin Islands': 'VI'
  };

  // Reverse mapping for abbreviation to state name
  const abbrToState = Object.entries(stateAbbreviations).reduce((acc, [state, abbr]) => {
    acc[abbr] = state;
    return acc;
  }, {});

  const fieldMap = {
    0: 'products', // Gift
    1: 'productId', // Gift #
    7: 'products-ribbon', // Ribbon Type
    8: 'ribbon-color', // Ribbon Color
    9: 'ribbonMessage', // Ribbon Your Own Message
    11: 'delivery_date', // Delivery Date (Double Click)
    13: 'firstName',
    14: 'lastName',
    15: 'company',
    16: 'address1',
    17: 'address2',
    18: 'city',
    19: 'province', // State
    20: 'zip',
    21: 'phone',
    22: 'note' // Card Message
  };

  // Edit-mode upload: never touch product / ribbon — recipient + delivery + card only
  const recipientOnlyFields = {
    delivery_date: true,
    firstName: true,
    lastName: true,
    company: true,
    address1: true,
    address2: true,
    city: true,
    province: true,
    zip: true,
    phone: true,
    note: true
  };

  const ribbonTypeMap = {
    'classic - $0': '45979875410229',
    'your own message - $9.95': '45979875442997',
    'thank you - $7.95': '45979875475765'
  };

   function populateStateField($row, stateValue) {
  const stateSelect = $row.find('select[name="province"]');
  if (!stateSelect.length) {
    console.error('State select not found');
    return;
  }

  // Normalize the input value
  const normalizedValue = stateValue.trim().toUpperCase();
  
  // First try direct match with abbreviation
  if (normalizedValue.length === 2) {
    const stateName = abbrToState[normalizedValue];
    if (stateName) {
      // Try to find the option that matches either the abbreviation or full name
      const options = Array.from(stateSelect[0].options);
      const option = options.find(opt => 
        opt.value.toUpperCase() === normalizedValue ||
        opt.value.toUpperCase() === stateName.toUpperCase() ||
        opt.textContent.toUpperCase() === normalizedValue ||
        opt.textContent.toUpperCase() === stateName.toUpperCase()
      );

      if (option) {
        // Set the value and trigger necessary events
        stateSelect.val(option.value);
        option.selected = true;
        
        // Ensure the change is registered
        stateSelect
          .trigger('change')
          .trigger('input')
          .trigger('select');
        
        // Multiple attempts to ensure state selection sticks
        setTimeout(() => {
          if (stateSelect.val() !== option.value) {
            stateSelect.val(option.value).trigger('change');
            $(option).prop('selected', true);
            
            // Try again after another delay
            setTimeout(() => {
              if (stateSelect.val() !== option.value) {
                stateSelect.val(option.value);
                $(option).prop('selected', true);
                stateSelect.trigger('change').trigger('input');
                
                // Final attempt
                setTimeout(() => {
                  // Check what's actually displayed in the UI
                  const selectedText = stateSelect.find('option:selected').text();
                  
                  if (selectedText !== option.textContent) {
                    // Force the correct option to be selected
                    stateSelect[0].selectedIndex = Array.from(stateSelect[0].options).indexOf(option);
                    stateSelect.trigger('change');
                  }
                }, 200);
              }
            }, 200);
          }
        }, 100);
        
        return;
      }
    }
  }  
  
  // If abbreviation didn't work, try full state name
  const stateAbbr = stateAbbreviations[stateValue];
  if (stateAbbr) {
    const options = Array.from(stateSelect[0].options);
    const option = options.find(opt => 
      opt.value.toUpperCase() === stateAbbr ||
      opt.textContent.toUpperCase() === stateValue.toUpperCase()
    );

    if (option) {
      stateSelect.val(option.value);
      option.selected = true;
      stateSelect
        .trigger('change')
        .trigger('input')
        .trigger('select');
        
      setTimeout(() => {
        if (stateSelect.val() !== option.value) {
          stateSelect.val(option.value).trigger('change');
          $(option).prop('selected', true);
        }
      }, 100);
      
      return;
    }
  }

  // Try a more flexible matching approach
  const options = Array.from(stateSelect[0].options);
  const flexibleMatch = options.find(opt => 
    opt.textContent.toLowerCase().includes(stateValue.toLowerCase()) ||
    opt.value.toLowerCase().includes(stateValue.toLowerCase()) ||
    stateValue.toLowerCase().includes(opt.textContent.toLowerCase()) ||
    stateValue.toLowerCase().includes(opt.value.toLowerCase())
  );
  
  if (flexibleMatch) {
    stateSelect.val(flexibleMatch.value);
    flexibleMatch.selected = true;
    stateSelect.trigger('change').trigger('input').trigger('select');
    
    // Additional DOM manipulation to ensure it sticks
    setTimeout(() => {
      if (stateSelect.val() !== flexibleMatch.value) {
        stateSelect[0].value = flexibleMatch.value;
        flexibleMatch.selected = true;
        stateSelect.trigger('change');
      }
    }, 100);
  }
}

  Object.entries(fieldMap).forEach(([index, field]) => {
    if (recipientOnly && !recipientOnlyFields[field]) {
      return;
    }
    const value = excelData[index];
    if (value !== null && value !== undefined && value !== '') {
      try {
        switch (field) {
          case 'products':
            populateProductField($row, value);
            break;
          case 'productId':
            $row.find('.selected_productID .productID-label span').text(value);
            break;
          case 'products-ribbon':
            populateRibbonTypeField($row, value, ribbonTypeMap);
            break;
          case 'ribbon-color':
            $row.find(`select[name="${field}"]`).val(value).trigger('change');
            break;
          case 'ribbonMessage':
            $row.find('.product__ribbon-message').val(value);
            break;
          case 'province':
              // Ensure country is set to US first (required for state dropdown to work)
              const $countrySelect = $row.find('select[name="country"]');
              if ($countrySelect.length) {
                $countrySelect.val('United States').trigger('change');
              }
              
              // Wait for country selection to process and ensure state dropdown is ready
              setTimeout(() => {
                const $stateSelect = $row.find('select[name="province"]');
                
                if ($stateSelect.length && $stateSelect.find('option').length > 1) {
                  populateStateField($row, value);
                  
                  // Additional attempts to ensure state sticks
                  setTimeout(() => {
                    populateStateField($row, value);
                  }, 500);
                  
                  setTimeout(() => {
                    populateStateField($row, value);
                  }, 1000);
                } else {
                  setTimeout(() => {
                    populateStateField($row, value);
                  }, 1000);
                }
              }, 1000);
            break;
          case 'zip':
            const cleanZip = value.toString().replace(/[^0-9]/g, '').slice(0, 5);
            $row.find(`input[name="${field}"]`).val(cleanZip).trigger('change');
            break;
          case 'delivery_date':
            // Prefer Excel display text; if somehow still a Date/serial, toCalendarDate handles it
            /* console.log('◇GT-DATE◇ sheet col11 value=', value, 'typeof=', typeof value) */;
            populateDeliveryDateField($row, value);
            break;
          case 'note':
            $row.find('textarea[name="note"]').val(value);
            break;
          default:
            $row.find(`input[name="${field}"]`).val(value).trigger('change');
        }
      } catch (error) {
        console.error(`Error populating field ${field}:`, error);
      }
    }
  });
  
  if (!recipientOnly) {
    updateProductDetails($row);
  }
  validateZipAndActivateCalendar($row.find('input[name="zip"]'));
}

function populateProductField($row, value) {
  const $select = $row.find('select[name="products"]');
  let $option = $select.find(`option:contains("${value}")`);
  if ($option.length === 0) {
    $option = $select.find('option').filter(function() {
      return $(this).text().toLowerCase().includes(value.toLowerCase());
    });
  }
  if ($option.length > 0) {
    $select.val($option.val()).trigger('change');
  } else {
    console.warn(`Product not found: ${value}`);
  }
}

function populateRibbonTypeField($row, value, ribbonTypeMap) {
  const $select = $row.find('select[name="products-ribbon"]');
  let mappedValue = ribbonTypeMap[value];
  if (!mappedValue) {
    for (const [key, val] of Object.entries(ribbonTypeMap)) {
       if (value.toLowerCase().includes(key.toLowerCase())) {
        mappedValue = val;
        break;
      }
    }
  }
  if (mappedValue) {
    $select.val(mappedValue).trigger('change');
  } else {
    console.warn(`Ribbon type not found: ${value}`);
  }
}



/**
 * Convert Excel delivery-date cell values to a local calendar Date at noon.
 * Fixes off-by-one (e.g. sheet 12-17-2026 showing as December 16, 2026).
 */
function parseExcelDeliveryDate(value) {
  return toCalendarDate(value);
}

// Function to populate the delivery date field
function populateDeliveryDateField($row, value) {
  const date = parseExcelDeliveryDate(value);
  if (!date || isNaN(date.getTime())) {
    console.warn('◇GT-DATE◇ Invalid delivery date from Excel:', value, typeof value);
    return;
  }
  const formatted = formatDate(date);
  /* console.log('◇GT-DATE◇ excel raw=', value, 'typeof=', typeof value, '→', formatted) */;
  // Write immediately so finalize/re-init can read the correct calendar day
  $row.find('input[name="delivery_date"]').val(formatted);
  $row.find('input[name="delivery_date"]').attr(
    'data-excel-ymd',
    date.getFullYear() + '-' +
      String(date.getMonth() + 1).padStart(2, '0') + '-' +
      String(date.getDate()).padStart(2, '0')
  );
  $row.find('.delivery-date_cover').removeClass('disabled');
  return setDatepickerDate($row, date);
}

  function isValidDeliveryDate(date) {
    const currentDate = getCurrentEasternTime();
    const effectiveDate = getEffectiveDate(currentDate);
    return date >= effectiveDate;
  }

 function DefaultCountySelection() {
  try {
    // State abbreviations mapping
    const stateAbbreviations = {
      'Alabama': 'AL',
      'Alaska': 'AK',
      'Arizona': 'AZ',
      'Arkansas': 'AR',
      'California': 'CA',
      'Colorado': 'CO',
      'Connecticut': 'CT',
      'Delaware': 'DE',
      'Florida': 'FL',
      'Georgia': 'GA',
      'Hawaii': 'HI',
      'Idaho': 'ID',
      'Illinois': 'IL',
      'Indiana': 'IN',
      'Iowa': 'IA',
      'Kansas': 'KS',
      'Kentucky': 'KY',
      'Louisiana': 'LA',
      'Maine': 'ME',
      'Maryland': 'MD',
      'Massachusetts': 'MA',
      'Michigan': 'MI',
      'Minnesota': 'MN',
      'Mississippi': 'MS',
      'Missouri': 'MO',
      'Montana': 'MT',
      'Nebraska': 'NE',
      'Nevada': 'NV',
      'New Hampshire': 'NH',
      'New Jersey': 'NJ',
      'New Mexico': 'NM',
      'New York': 'NY',
      'North Carolina': 'NC',
      'North Dakota': 'ND',
      'Ohio': 'OH',
      'Oklahoma': 'OK',
      'Oregon': 'OR',
      'Pennsylvania': 'PA',
      'Rhode Island': 'RI',
      'South Carolina': 'SC',
      'South Dakota': 'SD',
      'Tennessee': 'TN',
      'Texas': 'TX',
      'Utah': 'UT',
      'Vermont': 'VT',
      'Virginia': 'VA',
      'Washington': 'WA',
      'West Virginia': 'WV',
      'Wisconsin': 'WI',
      'Wyoming': 'WY',
      'American Samoa': 'AS',
      'Armed Forces Americas': 'AA',
      'Armed Forces Europe': 'AE',
      'Armed Forces Pacific': 'AP',
      'Washington DC': 'DC',
      'District of Columbia': 'DC', // Alternative name
      'Micronesia': 'FM',
      'Guam': 'GU',
      'Marshall Islands': 'MH',
      'Northern Mariana Islands': 'MP',
      'Palau': 'PW',
      'Puerto Rico': 'PR',
      'U.S. Virgin Islands': 'VI',
      'Virgin Islands': 'VI' // Alternative name
    };

    // Function to update state dropdown based on country selection
    function updateStateDropdown(countrySelect) {
      const rowId = countrySelect.id.split('-')[1];
      const stateSelect = document.querySelector(`#MultiShipProvince-${rowId}`);
      
      if (!stateSelect) {
        console.error('State select not found for row:', rowId);
        return;
      }
      
      const selectedOption = countrySelect.options[countrySelect.selectedIndex];
      if (!selectedOption) {
        console.error('No selected option found');
        return;
      }
      
      const provinces = JSON.parse(selectedOption.dataset.provinces || '[]');
      
      // Clear existing options
      stateSelect.innerHTML = '';
      
      // Add states with abbreviations
      provinces.forEach(([value, label]) => {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = label;
        // Add state abbreviation as data attribute
        const stateAbbr = stateAbbreviations[label] || '';
        option.setAttribute('data-state-abbr', stateAbbr);
        stateSelect.appendChild(option);
      });
      
      // Only pre-select Alabama if no value is already set and not processing Excel (avoid overriding Excel data)
      if ((!stateSelect.value || stateSelect.value === '') && !window.isProcessingExcel) {
        const alabamaOption = Array.from(stateSelect.options)
          .find(option => option.getAttribute('data-state-abbr') === 'AL');
        
        if (alabamaOption) {
          stateSelect.value = alabamaOption.value;  // Pre-select Alabama if it exists
        } else if (provinces.length > 0) {
          // Otherwise, select the first option in the list
          stateSelect.value = provinces[0][0];
        }
      }
    }

    // Get all country selects
    const countrySelects = document.querySelectorAll('.select__select.country');
    
    countrySelects.forEach((countrySelect) => {
      // Set to United States
      countrySelect.value = 'United States';
      
      // Optional: Remove other options except 'United States' and '---'
      Array.from(countrySelect.options).forEach(option => {
        if (option.value !== 'United States' && option.value !== '---') {
          option.remove();
        }
       
      });
      
      
      
      // Update states and automatically select "Alabama"
      setTimeout(function() { 
       
        //updateStateDropdown(countrySelect);
      }, 50);
    });
    
    return true;
    
  } catch (error) {
    console.error('Error in DefaultCountySelection:', error);
    return false;
  }
}

  // Event Handlers
  // Add tooltip functionality
  $('#orderTable').on('change', 'input[name^="shipping-"]', function() {
      const $row = $(this).closest('tr');
      // Edit mode: block switching away from Standard
      if (window.GT_BULK_EDIT_MODE) {
        const vid = String($(this).val() || '');
        const title = String($(this).attr('data-variant-title') || '').toLowerCase();
        const isChooseDate = $(this).attr('data-show-calendar') === 'true';
        const isStandard =
          !isChooseDate &&
          (vid === GT_STANDARD_SHIPPING_VARIANT_ID || title.indexOf('standard') !== -1);
        if (!isStandard) {
          if (typeof eboForceStandardShippingOnly === 'function') eboForceStandardShippingOnly($row);
          return;
        }
      }
      logPerishableRowTrace('shipping-radio-change', $row, { selectedVariantId: $(this).val(), variantTitle: $(this).attr('data-variant-title') });
      const shippingPrice = parseShippingDataPrice($(this)) || 22.38;
      
      const $priceInfo = $row.find(".tooltip-content .multiship-product__details");
      const giftPrice = parseFloat($priceInfo.find(".gift-fee").text().replace(/[^0-9.]/g, '')) || 0;
      const ribbonFee = parseFloat($priceInfo.find(".ribbon-fee").text().replace(/[^0-9.]/g, '')) || 0;
      const signatureFee = parseFloat($priceInfo.find(".signature-fee").text().replace(/[^0-9.]/g, '')) || 0;
      const hasRibbon = ribbonFee > 0;
  
      
  
      updatePriceInfo($row, giftPrice, shippingPrice, signatureFee, hasRibbon, ribbonFee);
  });
  $('#orderTable').on('mouseenter', '.action-btn', function() {
    $(this).attr('title', $(this).data('tooltip'));
  }).on('mouseleave', '.action-btn', function() {
    $(this).removeAttr('title');
  });

  $('#orderTable').on('change', 'select[name="products"]', function() {
    const $row = $(this).closest('tr');
    updateProductDetails($row);
    clearErrorStyles($row);
    updateAgeVerificationAndSubmitButton();
    const dateInput = $row.find('input[name="delivery_date"]')[0];
    if (dateInput && dateInput.datepicker) {
      dateInput.datepicker.update();
      const existingDate = $row.find('input[name="delivery_date"]').val();
      if (existingDate) {
        setDatepickerDate($row, existingDate);
      }
    }
  });

  $('#ProductAgeVerification').on('change', function() {
    updateAgeVerificationAndSubmitButton();
  });

  $('#orderTable').on('change', 'select[name="ribbon-color"]', function() {
    updateRibbonColorSelectStyle($(this));
  });

  $('#orderTable').on('change', 'select[name="products-ribbon"]', function() {
    handleRibbonTypeChange($(this));
    const $row = $(this).closest('tr');
    updatePriceInfo($row, parseFloat($row.find('.tooltip-content .multiship-product__details .gift-fee').text().replace('$', '')));
  });


  

  $('#orderTable').on('change', 'input[name="opt-out-personal-message"]', function() {
    handleNoMessageCheckbox($(this));
  });

  $(document).on("click", function(e) {
    if (!$(e.target).closest(".tooltip-container").length) {
      $(".tooltip-content").hide();
    }
  });

  $("#orderTable").on("click", ".tooltip-trigger", function(e) {
    e.preventDefault();
    $(".tooltip-content").not($(this).siblings(".tooltip-content")).hide();
    $(this).siblings(".tooltip-content").toggle();
  });

  $("#orderTable").on("input", 'input[name="zip"]', function() {
    this.value = truncateZipCode(this.value);
  });
  var gtZipFetchTimer = null;
  $("#orderTable").on("focus keyup", 'input[name="zip"]', function() {
    const $self = $(this);
    validateZipAndActivateCalendar($self);
    const cleanZip = ($self.val() || '').replace(/[^0-9]/g, '').slice(0, 5);
    if (cleanZip.length === 5) {
      clearTimeout(gtZipFetchTimer);
      gtZipFetchTimer = setTimeout(function () {
        fetchStateFromZipAsync(cleanZip).then(function () {
          const $row = $self.closest('tr');
          const $dateInput = $row.find('input[name="delivery_date"]');
          if ($dateInput[0] && $dateInput[0].datepicker) {
            initializeDatepicker($row);
            const existingDate = $dateInput.val();
            if (existingDate) {
              setDatepickerDate($row, existingDate);
              updateEstimatedDeliveryDate($row);
            }
          }
        });
      }, 800);
    }
  });

  // Modified add row button handler
$("#addRowBtn").on("click", function() {
  const newRowData = createRow(table.rows().count() + 1);
  
  // Add the new row
  const newRow = table.row.add(newRowData).draw();
  const $newRow = $(newRow.node());
  
  // Populate products in the new row's dropdown
  populateAllDropdowns();
  
  // Initialize only the new row
  initializeCountryProvinceSelectors($newRow[0]); // Pass the DOM element
  initializeDatepicker($newRow);
  
  // Initialize the new row's prices
  const $priceInfo = $newRow.find(".tooltip-content .multiship-product__details");
  $priceInfo.find(".gift-fee").text("$0.00");
  $priceInfo.find(".shipping-fee").text("$22.38");
  $priceInfo.find(".ribbon-fee").text("$0.00");
  $priceInfo.find(".signature-fee").text("$0.00");
  $priceInfo.find(".product-sub_total").text("$22.38");

  // Update country selection for new row only
  setTimeout(function() { 
    DefaultCountySelection();
  }, 400);
  
  calculateTotals();
});


  
  
  $("#submitOrderBtn").on("click", async function() {
    logAllRowsPerishable('add-to-cart-submit-order-click');
    // First validate card messages
    if (!validateCardMessages()) {
      const $firstErrorRow = $("#orderTable tr.error").first();
      if ($firstErrorRow.length) {
        $("html, body").animate({
          scrollTop: $firstErrorRow.offset().top - 100
        }, 500);
      }
      return;
    }
    
    // Validate inventory before submission
    const submitButton = $('#submitOrderBtn');
    submitButton.prop('disabled', true);
    submitButton.text("Validating inventory...");
    
    try {
      const inventoryErrors = await validateInventory();
      
      if (inventoryErrors.length > 0) {
        // Display inventory errors and prevent submission
        displayInventoryErrors(inventoryErrors);
        submitButton.prop('disabled', false);
        submitButton.text("Submit Order");
        return;
      }
      
      // Clear any previous inventory error messages
      $('.inventory-error-message').remove();
      
      // Proceed with order submission
      submitButton.text("Processing...");
      generateOrderJSON();
      
    } catch (error) {
      console.error('Error validating inventory:', error);
      // On error, allow submission to proceed (fail open)
      submitButton.text("Processing...");
      generateOrderJSON();
    }
  });

  // TEST: build the same line-item JSON and download it — does NOT create a draft order
  $("#downloadMetafieldJsonBtn").on("click", async function() {
    logAllRowsPerishable('download-metafield-json-click');
    if (!validateCardMessages()) {
      const $firstErrorRow = $("#orderTable tr.error").first();
      if ($firstErrorRow.length) {
        $("html, body").animate({
          scrollTop: $firstErrorRow.offset().top - 100
        }, 500);
      }
      return;
    }

    const $btn = $('#downloadMetafieldJsonBtn');
    $btn.prop('disabled', true).text('Building JSON...');
    window.__GT_BULK_METAFIELD_TEST_ONLY__ = true;

    try {
      await generateOrderJSON();
    } catch (error) {
      console.error('Error building metafield JSON:', error);
      window.__GT_BULK_METAFIELD_TEST_ONLY__ = false;
      alert('Failed to build metafield JSON. Check console.');
    } finally {
      $btn.prop('disabled', false).text('Download Metafield JSON (Test)');
      $('#submitOrderBtn').prop('disabled', false).text('Submit Order');
    }
  });

   // Modified remove row handler
  $("#orderTable").off("click.bulkRemove", ".remove-btn").on("click.bulkRemove", ".remove-btn", function(e) {
    e.preventDefault();
    removeRow($(this));
    calculateTotals();
  });

  $("#deleteAllBtn").on("click", function() {
    $("#deleteConfirmationModal").fadeIn();
  });

  $("#confirmDeleteBtn").on("click", function() {
    handleDeleteAll();
    $("#deleteConfirmationModal").fadeOut();
  });

  $("#cancelDeleteBtn").on("click", function() {
    $("#deleteConfirmationModal").fadeOut();
  });

  $("#orderTable").on("click", ".clone-btn", function(e) {
    e.preventDefault();
    e.stopPropagation();
    const $button = $(this);
    $("#cloneConfirmationModal").fadeIn();
    
    $("#confirmCloneBtn").off("click").on("click", function() {
      const cloneCount = parseInt($("#cloneCountInput").val(), 10);
      if (!isNaN(cloneCount) && cloneCount > 0) {
        const $loadingOverlay = $('<div id="loading-overlay" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); z-index: 9999;"><div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); color: white;">Processing...</div></div>');
        $("body").append($loadingOverlay);
        
        setTimeout(() => {
          $("#cloneConfirmationModal").fadeOut();
          cloneRow($button, cloneCount);
          $loadingOverlay.remove();
        }, 50);
        
        initializeCountryProvinceSelectors();
        
        
      } else {
        alert("Please enter a valid positive number.");
      }
    });
    
    $("#cancelCloneBtn").off("click").on("click", function() {
      $("#cloneConfirmationModal").fadeOut();
    });
  });

  $(document).on("input", ".multiship-card__message", function() {
    $(this).closest("tr").removeClass("error");
  });

  $('#orderTable').on('click', '.calendar_modal', function () {
    const $row = $(this).closest('tr');
    const cleanZip = ($row.find('input[name="zip"]').val() || '').replace(/[^0-9]/g, '').slice(0, 5);
    if (cleanZip.length === 5 && !GT_ZIP_STATE_CACHE[cleanZip]) {
      const self = this;
      fetchStateFromZipAsync(cleanZip).then(function () {
        initializeDatepicker($row);
        const existingDate = $row.find('input[name="delivery_date"]').val();
        if (existingDate) {
          setDatepickerDate($row, existingDate);
        }
        const $dateInput = $row.find('input[name="delivery_date"]');
        if ($dateInput[0] && $dateInput[0].datepicker && !$(self).prop('disabled')) {
          $dateInput[0].datepicker.show();
        }
      });
    }
    logPerishableRowTrace('shipping-calendar-button-click', $row);
  });

  $("#orderTable").on("change", 'input[name="zip"]', function() {
    const $row = $(this).closest("tr");
    const $calendarButton = $row.find(".calendar_modal");
    const $self = $(this);
    const cleanZip = ($self.val() || '').replace(/[^0-9]/g, '').slice(0, 5);
    // Fetch state from ZIP in real-time, then reinitialize datepicker
    fetchStateFromZipAsync(cleanZip).then(function (stateAbbr) {
      perishableLog('zip-change: state resolved from API', { zip: cleanZip, stateAbbr: stateAbbr });
      validateZipAndActivateCalendar($self, $calendarButton);
      logPerishableRowTrace('zip-code-change', $row, { zip: cleanZip, resolvedState: stateAbbr });
      (function() {
        var tags = getRowProductTags($row);
        var meta = findPerishableMeta(tags);
        var perishCheck = isPerishableActiveForRow($row);
        /* console.log('%c🔶◇GT-PERISH-STATUS◇🔶 ═══ ZIP CHANGE ═══', 'color:#ff9900;font-weight:bold;font-size:12px') */;
        /* console.log('%c🔶 ZIP: ' + cleanZip + ' → State: ' + stateAbbr, 'color:#ff9900;font-weight:bold') */;
        /* console.log('%c🔶 Product Tags:', 'color:#ff9900;font-weight:bold', tags) */;
        if (meta) {
          /* console.log('%c🔶✅ TAG MATCH: "' + meta.tag + '"', 'color:#00cc00;font-weight:bold', { variant1: meta.shipping_variant_1 || '(empty)', variant2: meta.shipping_variant_2 || '(empty)', description: meta.description }) */;
        } else {
          /* console.log('%c🔶❌ NO TAG MATCH', 'color:#cc0000;font-weight:bold') */;
        }
        /* console.log('%c🔶 Perishable Active: ' + perishCheck.active + ' | Reason: ' + perishCheck.reason, perishCheck.active ? 'color:#00cc00;font-weight:bold' : 'color:#cc0000;font-weight:bold') */;
      })();
      const existingDate = $row.find('input[name="delivery_date"]').val();
      if (existingDate) {
        setDatepickerDate($row, existingDate);
        updateEstimatedDeliveryDate($row);
      }
    });
  });

  // Province change — handle both manual and programmatic changes
  $(document).on("change", '#orderTable select[name="province"]', function() {
    const $row = $(this).closest("tr");
    logPerishableRowTrace('province-change', $row, { province: $(this).val(), stateAbbr: getRowStateAbbr($row) });
    (function() {
      var tags = getRowProductTags($row);
      var meta = findPerishableMeta(tags);
      var perishCheck = isPerishableActiveForRow($row);
      /* console.log('%c🟣◇GT-PERISH-STATUS◇🟣 ═══ PROVINCE CHANGE ═══', 'color:#9933ff;font-weight:bold;font-size:12px') */;
      /* console.log('%c🟣 Province: ' + $row.find('select[name="province"]').val() + ' | State Abbr: ' + getRowStateAbbr($row), 'color:#9933ff;font-weight:bold') */;
      if (meta) {
        /* console.log('%c🟣✅ TAG MATCH: "' + meta.tag + '"', 'color:#00cc00;font-weight:bold', { variant1: meta.shipping_variant_1 || '(empty)', variant2: meta.shipping_variant_2 || '(empty)', description: meta.description }) */;
      }
      /* console.log('%c🟣 Perishable Active: ' + perishCheck.active + ' | Reason: ' + perishCheck.reason, perishCheck.active ? 'color:#00cc00;font-weight:bold' : 'color:#cc0000;font-weight:bold') */;
    })();
    const existingDate = $row.find('input[name="delivery_date"]').val();
    initializeDatepicker($row);
    if (existingDate) {
      setDatepickerDate($row, existingDate);
      updateEstimatedDeliveryDate($row);
    }
  });
  // Observe province selects for programmatic changes (Shopify CountryProvinceSelector)
  (function() {
    let lastProvinceValues = {};
    setInterval(function() {
      $('#orderTable tbody tr').each(function() {
        const $row = $(this);
        const rowIdx = $row.index();
        const currProv = $row.find('select[name="province"]').val() || '';
        if (lastProvinceValues[rowIdx] !== undefined && lastProvinceValues[rowIdx] !== currProv) {
          perishableLog('province-change-detected (poll)', { rowIdx: rowIdx, old: lastProvinceValues[rowIdx], new: currProv });
          const existingDate = $row.find('input[name="delivery_date"]').val();
          initializeDatepicker($row);
          if (existingDate) {
            setDatepickerDate($row, existingDate);
            updateEstimatedDeliveryDate($row);
          }
        }
        lastProvinceValues[rowIdx] = currProv;
      });
    }, 600);
  })();

  $("#orderTable").on("change", 'select[name="shipping_method"]', function() {
    const $row = $(this).closest("tr");
    updateEstimatedDeliveryDate($row);
  });

  // Initialize the table

  function initializeTable() {
    initializeProductSelect();
    table.clear();
    const newRowData = createRow(1);
    table.row.add(newRowData).draw();
    calculateTotals();
    updateAgeVerificationAndSubmitButton();
    initializeCountryProvinceSelectors();
    initializeDatepickers();
    logAllRowsPerishable('page-load-initial-table');
    (function gtPerishStatusLogBulk() {
      var meta = window.__GT_PERISHABLE_META__ || [];
      /* console.log('%c🟢◇GT-PERISH-STATUS◇🟢 ═══ BULK ORDER PAGE LOAD ═══', 'color:#00cc66;font-weight:bold;font-size:13px') */;
      /* console.log('%c🟢 Metaobject Entries:', 'color:#00cc66;font-weight:bold', meta.map(function(e){ return { handle: e.handle, tag: e.tag, description: e.description, variant1: e.shipping_variant_1, variant2: e.shipping_variant_2 }; })) */;
      /* console.log('%c🟢 Shipping Variants (gtShippingProductVariants):', 'color:#00cc66;font-weight:bold', (window.gtShippingProductVariants || []).map(function(v){ return v.title + ' → $' + (v.price/100).toFixed(2); })) */;
    })();
  }

  initializeTable();

 // Handle page refresh/leave
  window.addEventListener('beforeunload', function(event) {
     if (!$('body').hasClass('invoice_created')) { 
      if (!allowRefresh) {
      // Show the custom modal instead of browser default
      $('#refreshConfirmationModal').fadeIn();
      
      // Cancel the event and show confirmation dialog
      event.preventDefault();
      // Chrome requires returnValue to be set
      event.returnValue = '';
    }
     }
  });

  // Handle Yes button click
  $('#confirmRefreshBtn').on('click', function() {
     if (!$('body').hasClass('invoice_created')) { 
      allowRefresh = true;
      window.location.reload();
     }
  });

  // Handle No button click
  $('#cancelRefreshBtn').on('click', function() {
     if (!$('body').hasClass('invoice_created')) { 
    $('#refreshConfirmationModal').fadeOut();
     }
  });

  // Prevent F5 and Ctrl+R
  $(document).on('keydown', function(e) {
     if (!$('body').hasClass('invoice_created')) { 
    if ((e.which === 116) || (e.which === 82 && e.ctrlKey)) { // F5 or Ctrl+R
      e.preventDefault();
      $('#refreshConfirmationModal').fadeIn();
      return false;
    }
    }
  });
 
$(document).on('change', 'input, select', function() {
    const value = $(this).val();
    
    // Check if the value is not blank and not '---'
    if (value !== "" && value !== "---") {
        // Remove the class from the closest <td> element
        $(this).closest('td').removeClass('error');
    }
});


$(document).ready(function() {
  DefaultCountySelection();
  
  // Load all products for dropdowns
  loadAllProductsForDropdowns();
});

// Global product cache
let allProductsCache = null;
let isLoadingProducts = false;

// Load all products from collection
async function loadAllProductsForDropdowns() {
  if (allProductsCache || isLoadingProducts) {
    if (allProductsCache) {
      populateAllDropdowns();
    }
    return;
  }
  
  isLoadingProducts = true;
  let allProducts = [];
  let page = 1;
  
  try {
    /* console.log('Loading all products...') */;
    
    // Fetch all pages
    while (true) {
      const url = `/collections/all-products/products.json?limit=250&page=${page}`;
      const response = await fetch(url);
      
      if (!response.ok) break;
      
      const data = await response.json();
      
      if (!data.products || data.products.length === 0) break;
      
      allProducts = allProducts.concat(data.products);
      
      // Update loading text in all dropdowns
      $('.product-select.gift-select').each(function() {
        if ($(this).find('option').length === 1) {
          $(this).html(`<option value="">Loading... (${allProducts.length} products)</option>`);
        }
      });
      
      page++;
    }
    
    allProductsCache = allProducts;
    /* console.log(`✅ Loaded ${allProducts.length} products successfully`) */;
    
    // Populate all dropdowns
    populateAllDropdowns();
    if (window.GT_PERISHABLE && typeof window.GT_PERISHABLE.logAllRows === 'function') {
      window.GT_PERISHABLE.logAllRows('page-load-after-products-loaded');
    }
    fetchProduct('/products/expedited-shipping.js').then(function (p) {
      window.__GT_EXPEDITED_SHIPPING_PRODUCT__ = p;
      perishableLog('prefetch expedited-shipping.js complete', p ? { productId: p.id, variantTitles: (p.variants || []).map(function (v) { return v.title; }) } : null);
    });
    
  } catch (error) {
    console.error('Error loading products:', error);
    $('.product-select.gift-select').html('<option value="">Error loading products</option>');
  } finally {
    isLoadingProducts = false;
  }
}

// Populate all dropdowns with cached products
function populateAllDropdowns() {
  if (!allProductsCache) return;
  
  $('.product-select.gift-select').each(function() {
    const $dropdown = $(this);
    
    // Skip if already populated with products
    if ($dropdown.find('option').length > 1) return;
    
    // Clear and add default option
    $dropdown.html('<option value="">Select a product</option>');
    
    // Add all products
    allProductsCache.forEach(product => {
      const tags = product.tags || [];
      const isWine = tags.includes('gt-wine') || tags.includes('not-our-wine');
      // Bulk order only: show ribbon when product has tag `bulk_order_ribbon`
      const hasRibbon = tags.some(function (t) {
        return String(t).toLowerCase() === 'bulk_order_ribbon';
      });
      
      // Extract p-type tag
      let pType = '';
      tags.forEach(tag => {
        if (tag.includes('#.p:')) {
          pType = tag.replace('#.p:', '');
        }
      });
      
      // Get price (API returns price as string in dollars)
      const priceValue = product.variants && product.variants[0] ? product.variants[0].price : 0;
      const price = parseFloat(priceValue).toFixed(2);
      
      // Get image URL and remove protocol to make it protocol-relative
      let imageUrl = product.images && product.images[0] ? product.images[0].src : '//cdn.shopify.com/s/files/1/0761/9903/5189/files/Group_359.jpg?v=1726751100';
      // Remove https: or http: from the URL
      imageUrl = imageUrl.replace(/^https?:/, '');
      
      // Create option element
      const option = $('<option></option>')
        .attr('value', product.id)
        .attr('data-is-wine', isWine)
        .attr('data-url', `/products/${product.handle}`)
        .attr('data-image', imageUrl)
        .attr('data-has-ribbon', hasRibbon)
        .attr('data-p-type', pType)
        .attr('data-price', price)
        .attr('data-wine-product', isWine)
        .attr('data-tags', encodeURIComponent(JSON.stringify(tags)))
        .attr('data-vendor', product.vendor || '')
        .text(product.title);
      
      $dropdown.append(option);
    });
  });
}

$(document).on('change', '.product-select.gift-select', function() {
    $(this).closest('td').parent().find('.column-ribbon-message .product__ribbon-message').val('')  
});
  
// Function to fetch product data from Shopify
async function fetchProduct(url) {
    try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(`Network response was not ok for URL: ${url}`);
        return await response.json();
    } catch (error) {
        console.error('Error fetching product data:', error);
        return null;
    }
}

// Inventory cache to store product inventory by handle
const inventoryCache = {};

// Function to fetch inventory from PHP endpoint
async function fetchProductInventory(productHandle) {
    // Return cached inventory if available
    if (inventoryCache[productHandle] !== undefined) {
        return inventoryCache[productHandle];
    }
    
    try {
        const response = await fetch('https://gifting-company.gifttree.com/techtic/get-inventory.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ handle: productHandle })
        });
        
        if (!response.ok) {
            console.error(`Failed to fetch inventory for ${productHandle}: ${response.status}`);
            return null;
        }
        
        const data = await response.json();
        
        if (data.success && data.inventory !== undefined) {
            // Cache the inventory
            inventoryCache[productHandle] = data.inventory;
            return data.inventory;
        } else {
            console.error(`Error fetching inventory for ${productHandle}:`, data.error);
            return null;
        }
    } catch (error) {
        console.error(`Error fetching inventory for ${productHandle}:`, error);
        return null;
    }
}

// Function to validate inventory for all products in the table
async function validateInventory() {
    const tableRows = document.querySelectorAll('#orderTableBody tr');
    const productQuantities = {}; // Track quantity per product handle
    const productTitles = {}; // Track product titles for error messages
    const inventoryErrors = []; // Store validation errors
    
    // Count quantities for each product
    for (const row of tableRows) {
        const productSelect = row.querySelector('.product-select');
        if (!productSelect) continue;
        
        const selectedOption = productSelect.selectedOptions[0];
        if (!selectedOption || !selectedOption.value) continue;
        
        const productHandle = selectedOption.getAttribute('data-url')?.replace('/products/', '');
        if (!productHandle) continue;
        
        const productTitle = selectedOption.text.trim();
        
        // Each row represents quantity 1
        if (!productQuantities[productHandle]) {
            productQuantities[productHandle] = 0;
            productTitles[productHandle] = productTitle;
        }
        productQuantities[productHandle]++;
    }
    
    // Fetch inventory for all unique products
    const uniqueHandles = Object.keys(productQuantities);
    const inventoryPromises = uniqueHandles.map(handle => fetchProductInventory(handle));
    const inventories = await Promise.all(inventoryPromises);
    
    // Validate each product
    for (let i = 0; i < uniqueHandles.length; i++) {
        const handle = uniqueHandles[i];
        const quantity = productQuantities[handle];
        const inventory = inventories[i];
        
        // Skip validation if inventory couldn't be fetched (null means error)
        if (inventory === null) {
            continue;
        }
        
        // Check if quantity exceeds inventory
        if (quantity > inventory) {
            inventoryErrors.push({
                handle: handle,
                title: productTitles[handle],
                quantity: quantity,
                inventory: inventory
            });
        }
    }
    
    return inventoryErrors;
}

// Function to display inventory validation errors
function displayInventoryErrors(errors) {
    // Remove any existing inventory error messages
    $('.inventory-error-message').remove();
    $('tr').removeClass('inventory-error');
    
    if (errors.length === 0) {
        return;
    }
    
    // Create error message
    let errorMessage = '<div class="inventory-error-message" style="background-color: #fee; border: 2px solid #f00; padding: 15px; margin: 15px 0; border-radius: 5px;">';
    errorMessage += '<h3 style="color: #c00; margin-top: 0;">Inventory Validation Error</h3>';
    errorMessage += '<p style="color: #c00;">The following products have insufficient inventory:</p>';
    errorMessage += '<ul style="margin: 10px 0; padding-left: 20px;">';
    
    errors.forEach(error => {
        errorMessage += `<li style="margin: 5px 0;"><strong>${error.title}</strong>: You ordered <b>${error.quantity}</b> units, but only <b>${error.inventory}</b> units are available in stock. Please adjust the quantity or contact us to change the gifts.</li>`;
    });
    
    errorMessage += '</ul>';
    errorMessage += '<p style="color: #c00; font-weight: bold;">Please adjust the quantities or contact us to change the gifts before submitting your order.</p>';
    errorMessage += '</div>';
    
    // Insert error message above the table-bottom_content
    const $tableBottomContent = $('.table-bottom_content');
    if ($tableBottomContent.length) {
        $tableBottomContent.before(errorMessage);
    } else {
        // Fallback: insert at the top of the table
        $('#orderTable').before(errorMessage);
    }
    
    // Scroll to error message
    $('html, body').animate({
        scrollTop: $('.inventory-error-message').offset().top - 100
    }, 500);
}

function generateGid() {
    return Math.floor(100000000 + Math.random() * 900000000).toString();
}

// Update generateOrderJSON to include more error details
async function generateOrderJSON() {
    try {
        const tableRows = document.querySelectorAll('#orderTableBody tr');
        
        
        const orders = { line_items: [] };
        const currency = await getCartCurrency();

        // Fetch special products upfront
        const [ribbonProduct, shippingProduct, signatureFeeProduct] = await Promise.all([
            fetchProduct('/products/select-a-ribbon.js'),
            fetchProduct('/products/expedited-shipping.js'),
            fetchProduct('/products/signature-fee.js')
        ]);

        window.ribbonProduct = ribbonProduct;
        window.signatureFeeProduct = signatureFeeProduct;

        for (const [index, row] of Array.from(tableRows).entries()) {
            try {
                
                
                // Get product information
                const productSelect = row.querySelector('.product-select');
                const selectedOption = productSelect?.selectedOptions[0];
                
                if (!selectedOption?.value) {
                    
                    continue;
                }

                const productHandle = selectedOption.getAttribute('data-url')?.replace('/products/', '');
                if (!productHandle) {
                    console.error(`No product handle found for row ${index + 1}`);
                    continue;
                }

                const productData = await fetchProduct(`/products/${productHandle}.js`);
                if (!productData) {
                    console.error(`Failed to fetch product data for ${productHandle} in row ${index + 1}`);
                    continue;
                }

                // Validate required fields for this specific row
                validateRowData(row);

                // Generate unique group ID for related items
                const gid = generateGid();
                const address = getAddressFromRow(row);

                // Create line items for this row
                const rowLineItems = await createLineItems(productData, row, gid, currency, shippingProduct);
                orders.line_items.push(...rowLineItems);
                
                
            } catch (error) {
                console.error(`Error processing row ${index + 1}:`, error);
                throw error;
            }
        }

        displayOutput(orders);
        
    } catch (error) {
        console.error('Error generating order JSON:', error);
        alert(error.message || 'Failed to build order JSON. Please select a product and shipping method for each row.');
        const submitButton = $('#submitOrderBtn');
        submitButton.prop('disabled', false);
        submitButton.text('Submit Order');
        // Do not open payment form with empty [] payloads
    }
}

function hasRibbon(product) {
    // Bulk order only: ribbon enabled only for products tagged bulk_order_ribbon
    const tags = (product && product.tags) ? product.tags : [];
    return tags.some(function (t) {
      return String(t).toLowerCase() === 'bulk_order_ribbon';
    });
}

function requiresSignatureFee(product) {
    return product.tags.includes("not-our-wine") || product.tags.includes("gt-wine");
}

// Generate unique 14-digit ID for line items
function generateUniqueLineItemId() {
    // Generate a 14-digit unique ID using timestamp and random number
    const timestamp = Date.now().toString().slice(-8); // Last 8 digits of timestamp
    const random = Math.floor(Math.random() * 1000000).toString().padStart(6, '0'); // 6-digit random number
    return parseInt(timestamp + random);
}

var GT_ORDER_MONTHS = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];

/** Parse "December 10, 2026" or "Sat Oct 31 2026" into a local noon Date (no timezone shift). */
function gtParseOrderDate(value) {
    if (typeof value !== 'string') return null;
    const m = value.trim().match(/^(?:[A-Za-z]+,?\s+)?([A-Za-z]+)\s+(\d{1,2}),?\s*(\d{4})$/);
    if (!m) return null;
    const mi = GT_ORDER_MONTHS.indexOf(m[1].slice(0, 3).toLowerCase());
    if (mi < 0) return null;
    return new Date(parseInt(m[3], 10), mi, parseInt(m[2], 10), 12, 0, 0);
}

/** Delivery date as sent in the order data: "Sat Oct 31 2026" */
function gtFormatOrderDeliveryDate(value) {
    const d = gtParseOrderDate(value);
    return d ? d.toDateString() : (value || '');
}

/** Order data date ("Sat Oct 31 2026") back to the on-screen format ("October 31, 2026") */
function gtOrderDateToDisplay(value) {
    const d = gtParseOrderDate(value);
    if (!d) return value || '';
    return d.toLocaleString('en-US', { month: 'long' }) + ' ' + d.getDate() + ', ' + d.getFullYear();
}

function createMainLineItem(product, row, gid, currency) {
    const variant = product.variants[0];
    const price = (parseFloat(variant.price) / 100).toFixed(2);
    const province = row.querySelector('[name="province"]')?.value;
    const PropertymessLine1 = row.querySelector('.personal_message_1')?.value || '';
    const PropertymessLine2 = row.querySelector('.personal_message_2')?.value || '';
    // Needs gtLoadPaLocations(variant.id) to have completed (see createLineItems / the save handler)
    const supplierName = window.gtResolveSupplier(
        row.querySelector('input[name="delivery_date"]')?.value || '',
        variant.id,
        product.vendor,
        product.tags
    );
    const uniqueId = generateUniqueLineItemId();
  
    return {
        id: uniqueId,
        admin_graphql_api_id: `gid://shopify/LineItem/${uniqueId}`,
        fulfillable_quantity: 1,
        fulfillment_service: "manual",
        fulfillment_status: null,
        gift_card: false,
        grams: parseFloat(variant.weight),
        name: product.title,
        price: price,
        product_exists: true,
        product_id: product.id,
        properties: [
            { name: "_gid", value: gid },
            { name: "_product", value: "true" },
            ...(variant.sku ? [{ name: "_sku", value: variant.sku }] : []),
            { name: "_supplier", value: supplierName },
            { name: "_delivery_date", value: gtFormatOrderDeliveryDate(row.querySelector('input[name="delivery_date"]')?.value || '') },
            ...(PropertymessLine1 ? [{ name: "Personal Message Line 1", value: PropertymessLine1 }] : []),
            ...(PropertymessLine2 ? [{ name: "Personal Message Line 2", value: PropertymessLine2 }] : []),
            ...(hasRibbon(product) ? [{ name: "_has-ribbon", value: "true" }] : []),
            ...(requiresSignatureFee(product) ? [{ name: "_wine", value: "true" }] : [])
        ],
        quantity: 1,
        requires_shipping: product.requires_shipping,
        sku: variant.sku,
        taxable: product.taxable,
        title: product.title,
        total_discount: "0.00",
        variant_id: variant.id,
        variant_title: variant.title,
        vendor: product.vendor,
        ...createPriceSet(price, currency),
        tax_lines: [createTaxLine(price, currency, province)]
    };
}

function createRibbonLineItem(ribbonProduct, row, gid, currency) {
    const ribbonSelect = row.querySelector('.ribbon-type-select');
    const ribbonColor = row.querySelector('.ribbon-color-select')?.value || '';
    const ribbonMessage = row.querySelector('.product__ribbon-message')?.value || '';
    const province = row.querySelector('[name="province"]')?.value;
    
    const selectedVariant = ribbonProduct.variants.find(v => v.id.toString() === ribbonSelect.value) || ribbonProduct.variants[0];
    const price = (selectedVariant.price / 100).toFixed(2);
    const uniqueId = generateUniqueLineItemId();

    return {
        id: uniqueId,
        admin_graphql_api_id: `gid://shopify/LineItem/${uniqueId}`,
        fulfillable_quantity: 1,
        fulfillment_service: "manual",
        fulfillment_status: null,
        gift_card: false,
        grams: parseFloat(selectedVariant.weight),
        name: `${ribbonProduct.title} - ${selectedVariant.title}`,
        price: price,
        product_exists: true,
        product_id: ribbonProduct.id,
        properties: [
            { name: "_gid", value: gid },
            { name: "_ribbon", value: "true" },
            { name: "Color", value: ribbonColor },
            { name: "Message", value: ribbonMessage }
        ],
        quantity: 1,
        requires_shipping: ribbonProduct.requires_shipping,
        sku: selectedVariant.sku,
        taxable: ribbonProduct.taxable,
        title: ribbonProduct.title,
        total_discount: "0.00",
        variant_id: selectedVariant.id,
        variant_title: selectedVariant.title,
        vendor: ribbonProduct.vendor,
        ...createPriceSet(price, currency),
        tax_lines: [createTaxLine(price, currency, province)]
    };
}

/** Standard shipping variant id (expedited-shipping product — "Standard") */
const GT_STANDARD_SHIPPING_VARIANT_ID = '46894299152693';

/**
 * Edit mode: leave only Standard shipping selectable; hide Overnight / Expedited / Saturday.
 * Clears delivery_date when the current value is outside the Standard window.
 */
function eboForceStandardShippingOnly($row) {
  if (!$row || !$row.length) return;
  const $radios = $row.find('shipping-methods input[type="radio"]');
  $radios.each(function () {
    const $input = $(this);
    const vid = String($input.val() || '');
    const title = String($input.attr('data-variant-title') || '').toLowerCase();
    const isChooseDate = $input.attr('data-show-calendar') === 'true';
    const isStandard =
      !isChooseDate &&
      (vid === GT_STANDARD_SHIPPING_VARIANT_ID || title.indexOf('standard') !== -1);
    if (isStandard) {
      $input.prop('disabled', false).prop('checked', true);
      $input.closest('.multiship-method').removeClass('ebo-non-standard-shipping');
    } else {
      $input.prop('checked', false).prop('disabled', true);
      $input.closest('.multiship-method').addClass('ebo-non-standard-shipping');
    }
  });

  const $dateInput = $row.find('input[name="delivery_date"]');
  const raw = ($dateInput.val() || '').trim();
  if (raw && typeof parseLocalDisplayDate === 'function' && typeof isStandardShippingWindowDate === 'function') {
    const selectedDate = parseLocalDisplayDate(raw);
    if (selectedDate && !isNaN(selectedDate.getTime())) {
      const currentDate = getCurrentEasternTime();
      const effectiveDate = getEffectiveDate(currentDate, $row);
      const effectiveDateWithoutTime = new Date(
        effectiveDate.getFullYear(),
        effectiveDate.getMonth(),
        effectiveDate.getDate()
      );
      const dateWithoutTime = new Date(
        selectedDate.getFullYear(),
        selectedDate.getMonth(),
        selectedDate.getDate()
      );
      const zone = checkZone($row.find('input[name="zip"]').val());
      if (!isStandardShippingWindowDate(dateWithoutTime, effectiveDateWithoutTime, zone)) {
        $dateInput.val('');
        $row.find('.delivery-date_cover').addClass('disabled');
        if ($dateInput[0] && $dateInput[0].datepicker && typeof $dateInput[0].datepicker.clear === 'function') {
          try { $dateInput[0].datepicker.clear(); } catch (e) { /* ignore */ }
        }
      }
    }
  }

  const $std = $row.find('shipping-methods input[type="radio"]:checked');
  let shipPrice = typeof parseShippingDataPrice === 'function' ? parseShippingDataPrice($std) : NaN;
  if (isNaN(shipPrice) || shipPrice <= 0) {
    shipPrice = parseFloat(String($row.find('#Standard-price').text() || '').replace(/[^0-9.]/g, '')) || 22.38;
  }
  const $priceInfo = $row.find('.tooltip-content .multiship-product__details');
  if ($priceInfo.length) {
    const giftPrice = parseFloat($priceInfo.find('.gift-fee').text().replace(/[^0-9.]/g, '')) || 0;
    const ribbonFee = parseFloat($priceInfo.find('.ribbon-fee').text().replace(/[^0-9.]/g, '')) || 0;
    const signatureFee = parseFloat($priceInfo.find('.signature-fee').text().replace(/[^0-9.]/g, '')) || 0;
    try {
      updatePriceInfo($row, giftPrice, shipPrice, signatureFee, ribbonFee > 0, ribbonFee);
    } catch (e) { /* ignore */ }
  }
}

function getStandardShippingVariant(shippingProduct) {
  if (!shippingProduct || !Array.isArray(shippingProduct.variants)) {
    return null;
  }
  const byId = shippingProduct.variants.find(function (v) {
    return String(v.id) === GT_STANDARD_SHIPPING_VARIANT_ID;
  });
  if (byId) return byId;
  const byTitle = shippingProduct.variants.find(function (v) {
    return String(v.title || '').toLowerCase().indexOf('standard') !== -1;
  });
  if (byTitle) return byTitle;
  // Prefer section setting first variant, else product first variant
  const sectionFirst = (window.gtShippingProductVariants || [])[0];
  if (sectionFirst) {
    const match = shippingProduct.variants.find(function (v) {
      return String(v.id) === String(sectionFirst.id);
    });
    if (match) return match;
  }
  return shippingProduct.variants[0] || null;
}

function resolveShippingVariantForRow(row, shippingProduct) {
  const shippingSelect = row.querySelector('shipping-methods input[type="radio"]:checked');
  if (shippingSelect && shippingProduct && shippingProduct.variants) {
    const selected = shippingProduct.variants.find(function (v) {
      return String(v.id) === String(shippingSelect.value);
    });
    if (selected) return selected;
  }
  return getStandardShippingVariant(shippingProduct);
}

// Update createShippingLineItem to use correct selector
function createShippingLineItem(shippingProduct, row, address, gid, currency) {
    const province = row.querySelector('[name="province"]')?.value;
    const variant = resolveShippingVariantForRow(row, shippingProduct);
    if (!variant) {
        throw new Error('Shipping product / Standard variant not found');
    }

    // Keep UI in sync: check Standard (or resolved) radio when none selected
    const $radios = row.querySelectorAll('shipping-methods input[type="radio"]');
    let anyChecked = false;
    $radios.forEach(function (r) { if (r.checked) anyChecked = true; });
    if (!anyChecked) {
      $radios.forEach(function (r) {
        if (String(r.value) === String(variant.id)) r.checked = true;
      });
    }

    const deliveryDateInput = row.querySelector('.delivery-date_cover input');
    const giftCardMessage = row.querySelector('.column-card-message textarea');

    const price = (variant.price / 100).toFixed(2);
    const uniqueId = generateUniqueLineItemId();

    return {
        id: uniqueId,
        admin_graphql_api_id: `gid://shopify/LineItem/${uniqueId}`,
        fulfillable_quantity: 1,
        fulfillment_service: "manual",
        fulfillment_status: null,
        gift_card: false,
        grams: parseFloat(variant.weight),
        name: `${shippingProduct.title} - ${variant.title}`,
        price: price,
        product_exists: true,
        product_id: shippingProduct.id,
        properties: [
            { name: "_gid", value: gid },
            { name: "_shipping", value: "true" },
            { name: "_address", value: JSON.stringify(address) },
            { name: "_delivery_date", value: gtFormatOrderDeliveryDate(deliveryDateInput?.value || '') },
            { name: "card_message", value: giftCardMessage?.value || '' }
        ],
        quantity: 1,
        requires_shipping: shippingProduct.requires_shipping,
        sku: variant.sku,
        taxable: shippingProduct.taxable,
        title: shippingProduct.title,
        total_discount: "0.00",
        variant_id: variant.id,
        variant_title: variant.title,
        vendor: shippingProduct.vendor,
        ...createPriceSet(price, currency),
        tax_lines: [createTaxLine(price, currency, province)]
    };
}

function createSignatureFeeLineItem(signatureFeeProduct, row, gid, currency) {
    const variant = signatureFeeProduct.variants[0];
    const price = (variant.price / 100).toFixed(2);
    const province = row.querySelector('[name="province"]')?.value;
    const uniqueId = generateUniqueLineItemId();
  
    return {
        id: uniqueId,
        admin_graphql_api_id: `gid://shopify/LineItem/${uniqueId}`,
        fulfillable_quantity: 1,
        fulfillment_service: "manual",
        fulfillment_status: null,
        gift_card: false,
        grams: parseFloat(variant.weight),
        name: signatureFeeProduct.title,
        price: price,
        product_exists: true,
        product_id: signatureFeeProduct.id,
        properties: [
            { name: "_gid", value: gid },
            { name: "_signature_fee", value: "true" }
        ],
        quantity: 1,
        requires_shipping: signatureFeeProduct.requires_shipping,
        sku: variant.sku,
        taxable: signatureFeeProduct.taxable,
        title: signatureFeeProduct.title,
        total_discount: "0.00",
        variant_id: variant.id,
        variant_title: variant.title,
        vendor: signatureFeeProduct.vendor,
        ...createPriceSet(price, currency),
        tax_lines: [createTaxLine(price, currency, province)]
    };
}

async function getCartCurrency() {
    try {
        const response = await fetch('/cart.js');
        const data = await response.json();
        return data.currency;
    } catch (error) {
        console.error('Error fetching cart data:', error);
        return 'USD'; // Default to USD if there's an error
    }
}

// function getAddressFromRow(row) {
//     return {
//         first_name: row.querySelector('[name="firstName"]')?.value || '',
//         last_name: row.querySelector('[name="lastName"]')?.value || '',
//         company: row.querySelector('[name="company"]')?.value || '',
//         address1: row.querySelector('[name="address1"]')?.value || '',
//         address2: row.querySelector('[name="address2"]')?.value || '',
//         city: row.querySelector('[name="city"]')?.value || '',
//         province: row.querySelector('[name="state"]')?.value || '',
//         zip: row.querySelector('[name="zip"]')?.value || '',
//         phone: row.querySelector('[name="phone"]')?.value || ''
//     };
// }

function getAddressFromRow(row) {
  return {
    "first_name": row.querySelector('[name="firstName"]')?.value || '',
    "last_name": row.querySelector('[name="lastName"]')?.value || '',
    "company": row.querySelector('[name="company"]')?.value || '',
    "address1": row.querySelector('[name="address1"]')?.value || '',
    "address2": row.querySelector('[name="address2"]')?.value || '',
    "city": row.querySelector('[name="city"]')?.value || '',
    "country": row.querySelector('[name="country"]')?.value || '',
    "province": row.querySelector('[name="province"]')?.value || '',
    "zip": row.querySelector('[name="zip"]')?.value || '',
    "phone": row.querySelector('[name="phone"]')?.value || ''
  };
}

// Update createLineItems to pass the row to shipping line item creation
async function createLineItems(product, row, gid, currency, shippingProduct) {
    const lineItems = [];

    // Supplier depends on the variant's assigned locations, so load them first
    await window.gtLoadPaLocations(product.variants[0].id);

    // Add main product
    const mainLineItem = createMainLineItem(product, row, gid, currency);
    lineItems.push(mainLineItem);
    
    // Add ribbon if applicable
    if (hasRibbon(product)) {
        const ribbonProduct = window.ribbonProduct;
        if (ribbonProduct) {
            const ribbonLineItem = createRibbonLineItem(ribbonProduct, row, gid, currency);
            lineItems.push(ribbonLineItem);
        }
    }
    
    // Validate and add shipping (defaults to Standard variant when none selected)
    validateShippingMethod(row);
    const address = getAddressFromRow(row);

    const shippingLineItem = createShippingLineItem(shippingProduct, row, address, gid, currency);
    lineItems.push(shippingLineItem);
    
    // Add signature fee if required
    if (requiresSignatureFee(product)) {
        const signatureFeeProduct = window.signatureFeeProduct;
        if (signatureFeeProduct) {
            const signatureFeeLineItem = createSignatureFeeLineItem(signatureFeeProduct, row, gid, currency);
            lineItems.push(signatureFeeLineItem);
        }
    }
    
    return lineItems;
}

// Function to convert existing line items JSON to custom format
// (unchanged shape: one custom draft line per gift group + Est. Tax Fee)
function convertToCustomLineItems(lineItemsData) {
    try {
        if (!lineItemsData || !lineItemsData.line_items || !Array.isArray(lineItemsData.line_items)) {
            console.error('Invalid line items data structure');
            return [];
        }

        const lineItems = lineItemsData.line_items;
        const customLineItems = [];
        
        // Group line items by _gid to combine related items
        const groupedItems = {};
        
        lineItems.forEach(item => {
            const gidProperty = (item.properties || []).find(prop => prop.name === '_gid');
            if (gidProperty) {
                const gid = gidProperty.value;
                if (!groupedItems[gid]) {
                    groupedItems[gid] = [];
                }
                groupedItems[gid].push(item);
            }
        });

        // Process each group
        Object.keys(groupedItems).forEach(gid => {
            const groupItems = groupedItems[gid];
            
            // Find the main product (has _product property)
            const mainProduct = groupItems.find(item => 
                (item.properties || []).some(prop => prop.name === '_product' && prop.value === 'true')
            );
            
            if (!mainProduct) {
                console.warn(`No main product found for group ${gid}`);
                return;
            }

            // Calculate total price (main + ribbon + shipping + signature)
            let totalPrice = 0;
            groupItems.forEach(item => {
                totalPrice += parseFloat(item.price) || 0;
            });

            // Collect all custom attributes
            const customAttributes = [];
            
            // Add main product properties
            (mainProduct.properties || []).forEach(prop => {
                customAttributes.push({
                    name: prop.name,
                    value: prop.value
                });
            });

            // Add properties from other items (ribbon, shipping, signature fee)
            groupItems.forEach(item => {
                if (item.id !== mainProduct.id) {
                    (item.properties || []).forEach(prop => {
                        // Skip _gid duplicates
                        // Skip _sku so it only comes from the main product
                        // Skip _delivery_date when the main product already carries it
                        if (prop.name !== '_gid' && prop.name !== '_sku' &&
                            !(prop.name === '_delivery_date' && customAttributes.some(function (a) { return a.name === '_delivery_date'; }))) {
                            customAttributes.push({
                                name: prop.name,
                                value: prop.value
                            });
                        }
                    });
                }
            });

            // Extract fee information directly from groupItems
            let shippingFee = 0;
            let ribbonFee = 0;
            let adultSignatureFee = 0;
            let mainProductImageUrl = '';
            
            groupItems.forEach(item => {
                const props = item.properties || [];
                const hasAddress = props.some(prop => prop.name === '_address' || prop.name === '_shipping');
                if (hasAddress) {
                    shippingFee = parseFloat(item.price) || 0;
                }
                
                const isRibbon = props.some(prop => prop.name === '_ribbon');
                if (isRibbon) {
                    ribbonFee = parseFloat(item.price) || 0;
                }
                
                const isSignatureFee = props.some(prop => prop.name === '_signature_fee');
                if (isSignatureFee) {
                    adultSignatureFee = parseFloat(item.price) || 0;
                }
            });
            
            // Get main product image URL from DOM
            const tableRows = document.querySelectorAll('#orderTableBody tr');
            for (let row of tableRows) {
                const selectedOption = row.querySelector('.product-select option:checked');
                if (selectedOption && selectedOption.value === mainProduct.product_id.toString()) {
                    mainProductImageUrl = selectedOption.getAttribute('data-image') || '';
                    break;
                }
            }

            if (mainProductImageUrl) {
                customAttributes.push({
                    name: "_image_url",
                    value: mainProductImageUrl
                });
            }

            customAttributes.push({
                name: "_shipping_fee",
                value: shippingFee.toFixed(2)
            });

            if (ribbonFee > 0) {
                customAttributes.push({
                    name: "_ribbon_fee",
                    value: ribbonFee.toFixed(2)
                });
            }

            if (adultSignatureFee > 0) {
                customAttributes.push({
                    name: "_adult_signature_fee",
                    value: adultSignatureFee.toFixed(2)
                });
            }

            // Every custom draft line must carry _product:true (main gifts + fees)
            if (!customAttributes.some(function (a) { return a && a.name === '_product'; })) {
                customAttributes.push({ name: '_product', value: 'true' });
            } else {
                customAttributes.forEach(function (a) {
                    if (a && a.name === '_product') a.value = 'true';
                });
            }

            // One custom draft line per gift (same format as before — no variant_id split)
            customLineItems.push({
                title: mainProduct.title,
                originalUnitPrice: parseFloat(totalPrice.toFixed(2)),
                quantity: 1,
                customAttributes: customAttributes
            });
        });

        // Add Tax Fee product at the end
        if (customLineItems.length > 0) {
            const totalSubtotal = customLineItems.reduce((sum, item) => sum + item.originalUnitPrice, 0);
            const taxFee = totalSubtotal * 0.0965;
            
            customLineItems.push({
                title: "Est. Tax Fee",
                originalUnitPrice: parseFloat(taxFee.toFixed(2)),
                quantity: 1,
                customAttributes: [
                    { name: "_product", value: "true" },
                    {
                        name: "_image_url",
                        // Protocol-relative — matches gift products (https: stripped on product images)
                        value: "//cdn.shopify.com/s/files/1/0761/9903/5189/files/Est._Tax_Fee.png?v=1790335911"
                    }
                ]
            });
        }

        return customLineItems;
        
    } catch (error) {
        console.error('Error converting to custom line items:', error);
        return [];
    }
}

function createPriceSet(price, currency) {
    return {
        pre_tax_price: price,
        pre_tax_price_set: createMoneySet(price, currency),
        price_set: createMoneySet(price, currency),
        total_discount_set: createMoneySet("0.00", currency)
    };
}

function createMoneySet(amount, currency) {
    return {
        shop_money: { amount, currency_code: currency },
        presentment_money: { amount, currency_code: currency }
    };
}

function createTaxLine(price, currency) {
    const taxAmount = (price * 0.0752).toFixed(2);
    return {
        channel_liable: false,
        price: taxAmount,
        price_set: createMoneySet(taxAmount, currency),
        rate: 0.0752,
        title: "Minnesota State Tax"
    };
}
// function createTaxLine(price, currency, province) {
//     // Define tax rates for each province/state
//     const taxRates = {
//         Alaska: 0.0181,
//         Arkansas: 0.0944,
//         "District of Columbia": 0.06,
//         Florida: 0.0702,
//         Hawaii: 0.0444,
//         Idaho: 0.0602,
//         "American Samoa": 0,
//         "Armed Forces Americas": 0,
//         "Armed Forces Europe": 0,
//         "Armed Forces Pacific": 0,
//         "South Dakota": 0.0611,
//         "Rhode Island": 0.07,
//         Mississippi: 0.0706,
//         Missouri: 0.0836,
//         Michigan: 0.06,
//         Utah: 0.072,
//         Alabama: 0.0924,
//         Arizona: 0.0837,
//         California: 0.0885,
//         Colorado: 0.0779,
//         Connecticut: 0.0635,
//         Delaware: 0,
//         Georgia: 0.0739,
//         Guam: 0,
//         Illinois: 0.0884,
//         Indiana: 0.07,
//         Iowa: 0.0693,
//         Kansas: 0.0875,
//         Kentucky: 0.06,
//         Louisiana: 0.0955,
//         Maine: 0.055,
//         Maryland: 0.06,
//         Massachusetts: 0.0625,
//         Minnesota: 0.0752,
//         "Marshall Islands": 0,
//         "Montana": 0,
//         "Federated States of Micronesia": 0,
//         Nebraska: 0.0697,
//         Nevada: 0.0824,
//         "New Jersey": 0.066,
//         "New Mexico": 0.076,
//         "New York": 0.0853,
//         "North Carolina": 0.07,
//         "North Dakota": 0.0704,
//         "New Hampshire": 0,
//         "Northern Mariana Islands": 0,
//         Ohio: 0.0724,
//         Oklahoma: 0.0899,
//         Oregon: 0,
//         Pennsylvania: 0.0634,
//         "Palau": 0,
//         "Puerto Rico": 0.1157,
//         "South Carolina": 0.075,
//         Tennessee: 0.0955,
//         Texas: 0.082,
//         Vermont: 0.0636,
//         Virginia: 0.0577,
//         "Virgin Islands": 0,
//         Washington: 0.094,
//         "West Virginia": 0.0657,
//         Wisconsin: 0.0543,
//         Wyoming: 0.0544
//     };

//     // Check if the province exists in the tax rates
//     const rate = taxRates[province];

//     if (!rate) {
//         throw new Error(`Tax rate not found for province: ${province}`);
//     }

//     // Calculate the tax amount based on the province's rate
//     const taxAmount = (price * rate).toFixed(2);

//     return {
//         channel_liable: false,
//         price: taxAmount,
//         price_set: createMoneySet(taxAmount, currency),
//         rate: rate,
//         title: `${province} State Tax`
//     };
// }

// Update validateRowData to use correct selectors for shipping method
function validateRowData(row) {
    // Address, delivery date, card message, and shipping method are optional
    // (shipping defaults to Standard). Product is still required.
    const required = {
        'Product': row.querySelector('.product-select')?.value
    };

    const missing = Object.entries(required)
        .filter(([_, value]) => !value)
        .map(([key]) => key);

    if (missing.length > 0) {
        console.error('Missing required fields:', missing);
        throw new Error(`Please fill in required fields: ${missing.join(', ')}`);
    }
}


// Update validateShippingMethod — default to Standard when none selected
function validateShippingMethod(row) {
    const shippingMethod = row.querySelector('shipping-methods input[type="radio"]:checked');
    
    const validShippingIds = [
        '46894299152693', // Standard
        '46894299185461', // Expedited
        '46894299250997', // Overnight
        '50078531354933', // Saturday
        '52991816499509', // DC-Overnight
        '52953609896245', // Overnight-Affordable (perishable)
        '52953609929013' // Affordable-Expedited (perishable)
    ];

    if (!shippingMethod) {
        // Default: Standard — still valid for create-without-address flow
        return GT_STANDARD_SHIPPING_VARIANT_ID;
    }
    
    if (!validShippingIds.includes(shippingMethod.value)) {
        // Unknown radio value — fall back to Standard
        console.warn('Invalid shipping method selected, using Standard:', shippingMethod.value);
        return GT_STANDARD_SHIPPING_VARIANT_ID;
    }
    
    return shippingMethod.value;
}

function displayOutput(data) {
    const outputElement = document.getElementById('output');
    const customOutputElement = document.getElementById('custom-item-output');

    if (data && data.error) {
        console.error('Order JSON error:', data.error);
        alert(data.error);
        return;
    }

    // Exact metafield payload (clear JSON array — same as Download Metafield JSON / previous format)
    const lineItems = (data && Array.isArray(data.line_items)) ? data.line_items : [];
    if (!lineItems.length) {
        alert('No line items were generated. Select a product and a shipping method for each gift row, then click Submit Order again.');
        const submitButton = $('#submitOrderBtn');
        submitButton.prop('disabled', false);
        submitButton.text('Submit Order');
        return;
    }

    outputElement.textContent = JSON.stringify(lineItems);

    // Custom draft line items still need the full { line_items: [...] } shape
    const customLineItems = convertToCustomLineItems(
      (data && data.line_items) ? data : { line_items: lineItems }
    );
    /* console.log('Custom Line Items Generated:', customLineItems.length, 'items') */;
    /* console.log('Metafield line items JSON bytes:', new Blob([outputElement.textContent]).size) */;

    if (!customLineItems.length) {
        alert('Could not build custom line items from the order. Check each row has a product and shipping method selected.');
        const submitButton = $('#submitOrderBtn');
        submitButton.prop('disabled', false);
        submitButton.text('Submit Order');
        return;
    }

    customOutputElement.textContent = JSON.stringify(customLineItems);

    const submitButton = $('#submitOrderBtn');
    submitButton.prop('disabled', false);
    submitButton.text("Submit Order");

    // TEST MODE: do not open payment / create draft — download metafield JSON instead
    if (window.__GT_BULK_METAFIELD_TEST_ONLY__) {
      downloadMetafieldLineItemsJson(data);
      window.__GT_BULK_METAFIELD_TEST_ONLY__ = false;
      return;
    }

    // EDIT MODE: keep table open; do not show create-draft payment form
    if (window.GT_BULK_EDIT_MODE) {
      return;
    }

    $('.payment-form-container').show();
    $('.payment-form-container').addClass('is-active');
    $('body').addClass('is-overlay');
}

/**
 * Downloads the exact JSON array that belongs in custom.custom_line_items_json
 * (same clear format as previously stored — not gzip, not chunked).
 */
function downloadMetafieldLineItemsJson(data) {
    const lineItems = (data && Array.isArray(data.line_items)) ? data.line_items : [];
    const json = JSON.stringify(lineItems);
    const bytes = new Blob([json]).size;
    const mb = (bytes / (1024 * 1024)).toFixed(3);
    const limitMb = 2;
    const fits = bytes < (2 * 1024 * 1024);

    /* console.log('%c◇GT-METAFIELD-JSON◇', 'color:#0a7;font-weight:bold', {
      line_item_count: lineItems.length,
      bytes: bytes,
      mb: mb,
      shopify_json_limit: '2MB (grandfathered) / 128KB on API 2026-04+ for new apps',
      fits_2mb: fits
    }) */;

    const blob = new Blob([json], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'custom_line_items_json.json';
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);

    alert(
      'Metafield JSON downloaded: custom_line_items_json.json\n\n' +
      'Items: ' + lineItems.length + '\n' +
      'Size: ' + bytes.toLocaleString() + ' bytes (~' + mb + ' MB)\n' +
      'Fits in 2MB Draft Order JSON metafield: ' + (fits ? 'YES' : 'NO') + '\n\n' +
      'Paste this file contents into Draft order metafield:\n' +
      'custom.custom_line_items_json\n\n' +
      'Draft order was NOT created (test mode).'
    );
}

// Helper function to get custom line items data from custom output element
function getCustomLineItemsData() {
    const customOutputElement = document.getElementById('custom-item-output');
    const customData = customOutputElement.textContent;
    if (customData) {
        try {
            return JSON.parse(customData);
        } catch (error) {
            console.error('Error parsing custom line items data:', error);
            return [];
        }
    }
    return [];
}

// Add new function to get selected shipping method
function getSelectedShippingMethod(row) {
    const selectedInput = row.querySelector('shipping-methods input[type="radio"]:checked');
    if (!selectedInput) {
        throw new Error('Please select a shipping method');
    }
    return selectedInput.value;
}

const fileInput = document.getElementById('fileInput');
fileInput.addEventListener('click', function() {
    // Reset the value when clicking the input
    this.value = '';
});

// $(document).on('click', function (e) {
//   // Check if the click is outside the 'payment-form-container' div
//   if (!$(e.target).closest('.payment-form-container').length) {
//     // Remove the class from the body
//     $('body').removeClass('is-overlay');
//     // Remove the class from the payment-form-container
//     $('.payment-form-container').hide();
//     $('.payment-form-container').removeClass('is-active');
//   }
// });
$(document).on("click","#close-payment-from",function() {
  $('body').removeClass('is-overlay');
  $('.payment-form-container').hide();
  $('.payment-form-container').removeClass('is-active');
});

  // ——— Edit mode: load metafield into this same Bulk Order table, save metafield only ———
  if (window.GT_BULK_EDIT_MODE) {
    const EBO_API = 'https://gifting-company.gifttree.com/techtic/local-bulk-order';
    window.GT_EDIT_OWNER = null;

    function eboStatus(type, msg) {
      const $el = $('#ebo-status');
      if (!$el.length) return;
      $el.attr('class', 'ebo-status ebo-status--' + type).text(msg).show();
    }

    function eboPropGet(item, name) {
      const props = (item && item.properties) || [];
      if (!Array.isArray(props)) {
        if (props && typeof props === 'object' && props[name] != null) {
          return String(props[name]);
        }
        return '';
      }
      const found = props.find(function (p) { return p && p.name === name; });
      return found != null && found.value != null ? String(found.value) : '';
    }

    function eboClassifyItem(item) {
      const productFlag = eboPropGet(item, '_product');
      const ribbonFlag = eboPropGet(item, '_ribbon');
      const shippingFlag = eboPropGet(item, '_shipping');
      const hasAddress = !!eboPropGet(item, '_address');
      const sigFlag = eboPropGet(item, '_signature_fee');
      const title = String((item && (item.title || item.name)) || '').toLowerCase();

      if (ribbonFlag === 'true' || ribbonFlag === '1') return 'ribbon';
      if (sigFlag === 'true' || sigFlag === '1') return 'signature';
      if (hasAddress || shippingFlag === 'true' || shippingFlag === '1') return 'shipping';
      if (productFlag === 'true' || productFlag === '1') return 'main';
      if (title.indexOf('signature') !== -1) return 'signature';
      if (title.indexOf('ribbon') !== -1) return 'ribbon';
      if (title.indexOf('shipping') !== -1 || title.indexOf('expedited') !== -1) return 'shipping';
      if (item && item.product_id) return 'main';
      return 'other';
    }

    function eboParseAddress(raw) {
      const empty = {
        first_name: '', last_name: '', company: '', address1: '', address2: '',
        city: '', country: 'United States', province: '', zip: '', phone: ''
      };
      if (!raw) return empty;
      try {
        const obj = typeof raw === 'string' ? JSON.parse(raw) : raw;
        return Object.assign({}, empty, {
          first_name: obj.first_name || '',
          last_name: obj.last_name || '',
          company: obj.company || '',
          address1: obj.address1 || '',
          address2: obj.address2 || '',
          city: obj.city || '',
          country: obj.country || 'United States',
          province: obj.province || '',
          zip: obj.zip || '',
          phone: obj.phone || ''
        });
      } catch (e) {
        return empty;
      }
    }

    function eboGroupLineItems(lineItems) {
      const map = {};
      (lineItems || []).forEach(function (item, index) {
        const gid = eboPropGet(item, '_gid') || ('ungrouped-' + index);
        if (!map[gid]) {
          map[gid] = { gid: gid, main: null, shipping: null, ribbon: null, signature: null };
        }
        const kind = eboClassifyItem(item);
        if (kind === 'main' && !map[gid].main) map[gid].main = item;
        else if (kind === 'shipping' && !map[gid].shipping) map[gid].shipping = item;
        else if (kind === 'ribbon' && !map[gid].ribbon) map[gid].ribbon = item;
        else if (kind === 'signature' && !map[gid].signature) map[gid].signature = item;
        else if (kind === 'main') map[gid].main = map[gid].main || item;
      });
      const groups = Object.keys(map).map(function (k) { return map[k]; }).filter(function (g) { return !!g.main; });
      /* console.log('EBO grouped metafield line items:', {
        line_item_count: (lineItems || []).length,
        group_count: groups.length,
        gids: groups.map(function (g) { return g.gid; })
      }) */;
      return groups;
    }

    function eboWaitForProducts(ms) {
      return new Promise(function (resolve, reject) {
        const start = Date.now();
        (function tick() {
          if (typeof allProductsCache !== 'undefined' && allProductsCache && allProductsCache.length) {
            if (typeof populateAllDropdowns === 'function') populateAllDropdowns();
            resolve(allProductsCache);
            return;
          }
          if (Date.now() - start > ms) {
            reject(new Error('Products are still loading. Wait a moment and try Load again.'));
            return;
          }
          setTimeout(tick, 250);
        })();
      });
    }

    async function eboPopulateRowFromGroup($row, group) {
      const main = group.main;
      const shipping = group.shipping;
      const ribbon = group.ribbon;
      const signature = group.signature;
      const address = eboParseAddress(shipping ? eboPropGet(shipping, '_address') : '');
      const pm1 = eboPropGet(main, 'Personal Message Line 1');
      const pm2 = eboPropGet(main, 'Personal Message Line 2');
      const isWine =
        eboPropGet(main, '_wine') === 'true' ||
        eboPropGet(main, '_wine') === '1';

      const productId = main.product_id != null ? String(main.product_id) : '';
      const $productSelect = $row.find('select[name="products"]');

      // Ensure product option exists (collection may omit some SKUs)
      if (productId && $productSelect.length && !$productSelect.find('option[value="' + productId + '"]').length) {
        const opt = $('<option></option>')
          .attr('value', productId)
          .attr('data-is-wine', isWine)
          .attr('data-has-ribbon', !!ribbon)
          .attr('data-price', main.price || '0')
          .attr('data-image', '')
          .attr('data-url', '')
          .text(main.title || main.name || ('Product ' + productId));
        $productSelect.append(opt);
      }

      const rowData = {
        productId: productId,
        ribbonType: ribbon && ribbon.variant_id != null ? String(ribbon.variant_id) : '',
        ribbonColor: ribbon ? eboPropGet(ribbon, 'Color') : '',
        ribbonMessage: ribbon ? eboPropGet(ribbon, 'Message') : '',
        personalMessages: [pm1, pm2],
        noMessage: !pm1 && !pm2,
        personalMessagesDisabled: !pm1 && !pm2,
        firstName: address.first_name,
        lastName: address.last_name,
        company: address.company,
        address1: address.address1,
        address2: address.address2,
        city: address.city,
        country: address.country,
        province: address.province,
        zip: address.zip,
        phone: address.phone,
        deliveryDate: shipping
          ? gtOrderDateToDisplay(eboPropGet(shipping, '_delivery_date') || eboPropGet(shipping, 'delivery_date'))
          : '',
        cardMessage: shipping ? eboPropGet(shipping, 'card_message') : '',
        price: parseFloat(main.price) || 0,
        shippingPrice: shipping ? (parseFloat(shipping.price) || 0) : 0,
        signatureFee: signature ? (parseFloat(signature.price) || 0) : 0,
        isWine: isWine,
        hasRibbon: !!ribbon
      };

      populateRowData($row, rowData);

      // Select shipping radio WITHOUT .trigger('change')
      const shipVid = shipping && shipping.variant_id != null
        ? String(shipping.variant_id)
        : (typeof GT_STANDARD_SHIPPING_VARIANT_ID !== 'undefined' ? GT_STANDARD_SHIPPING_VARIANT_ID : '');
      if (shipVid) {
        $row.find('input[name^="shipping-"]').prop('checked', false);
        const $radio = $row.find('input[name^="shipping-"][value="' + shipVid + '"]');
        if ($radio.length) {
          $radio.prop('checked', true);
        } else {
          const $std = $row.find('input[name^="shipping-"][value="' + GT_STANDARD_SHIPPING_VARIANT_ID + '"]');
          if ($std.length) $std.prop('checked', true);
          else $row.find('input[name^="shipping-"]').first().prop('checked', true);
        }
      }

      // Edit mode: lock to Standard only (hide/disable other shipping; clear non-standard dates)
      if (window.GT_BULK_EDIT_MODE && typeof eboForceStandardShippingOnly === 'function') {
        eboForceStandardShippingOnly($row);
      } else {
        try {
          updatePriceInfo($row, rowData.price, rowData.shippingPrice, rowData.signatureFee, rowData.hasRibbon);
        } catch (e) {
          console.warn('updatePriceInfo during edit load', e);
        }
      }

      if (rowData.deliveryDate && typeof setDatepickerDate === 'function') {
        try { setDatepickerDate($row, rowData.deliveryDate); } catch (e) { /* ignore */ }
      }

      // Re-apply Standard lock after datepicker init (clears Saturday / overnight dates)
      if (window.GT_BULK_EDIT_MODE && typeof eboForceStandardShippingOnly === 'function') {
        eboForceStandardShippingOnly($row);
        if ($row.find('input[name="delivery_date"]').val() && typeof updateEstimatedDeliveryDate === 'function') {
          try { updateEstimatedDeliveryDate($row); } catch (e) { /* ignore */ }
        }
      }

      // Bind row to metafield _gid so save can patch the same JSON objects
      $row.attr('data-ebo-gid', String(group.gid));
    }

    function eboPropGet(item, name) {
      const found = ((item && item.properties) || []).find(function (p) { return p && p.name === name; });
      return found ? found.value : undefined;
    }

    function eboPropSet(item, name, value) {
      if (!item) return;
      if (!Array.isArray(item.properties)) item.properties = [];
      const idx = item.properties.findIndex(function (p) { return p && p.name === name; });
      if (value === null || value === undefined) {
        if (idx >= 0) item.properties.splice(idx, 1);
        return;
      }
      const str = String(value);
      if (idx >= 0) item.properties[idx].value = str;
      else item.properties.push({ name: name, value: str });
    }

    /** Update price + money sets on a metafield line item (keeps currency codes). */
    function eboSetLineMoney(item, amount) {
      if (!item) return;
      const num = parseFloat(amount);
      if (isNaN(num) || num < 0) return;
      const amt = num.toFixed(2);
      item.price = amt;
      item.pre_tax_price = amt;
      if (item.price_set) {
        if (item.price_set.shop_money) item.price_set.shop_money.amount = amt;
        if (item.price_set.presentment_money) item.price_set.presentment_money.amount = amt;
      }
      if (item.pre_tax_price_set) {
        if (item.pre_tax_price_set.shop_money) item.pre_tax_price_set.shop_money.amount = amt;
        if (item.pre_tax_price_set.presentment_money) item.pre_tax_price_set.presentment_money.amount = amt;
      }
    }

    /**
     * Patch the original Custom Line items JSON from table fields.
     * Preserves id / admin_graphql_api_id / price_set / tax_lines / _gid structure.
     * Per-row shipping radio updates that gift's shipping variant_id + price only.
     */
    function eboApplyTableEditsToMetafieldJson(lineItems) {
      const groups = eboGroupLineItems(lineItems);
      const byGid = {};
      groups.forEach(function (g) { byGid[String(g.gid)] = g; });
      const shippingPatches = [];

      // Prefer top-level gift rows (data-ebo-gid) so nested DataTables trs are ignored
      $('#orderTableBody tr[data-ebo-gid]').each(function () {
        const $row = $(this);
        const gid = String($row.attr('data-ebo-gid') || '');
        if (!gid || !byGid[gid]) return;
        const g = byGid[gid];

        const get = function (sel) {
          const $el = $row.find(sel);
          return $el.length ? ($el.val() || '') : '';
        };

        if (g.shipping) {
          const address = {
            first_name: get('input[name="firstName"]'),
            last_name: get('input[name="lastName"]'),
            company: get('input[name="company"]'),
            address1: get('input[name="address1"]'),
            address2: get('input[name="address2"]'),
            city: get('input[name="city"]'),
            country: get('select[name="country"]') || 'United States',
            province: get('select[name="province"]'),
            zip: get('input[name="zip"]'),
            phone: get('input[name="phone"]')
          };
          eboPropSet(g.shipping, '_shipping', 'true');
          eboPropSet(g.shipping, '_address', JSON.stringify(address));
          eboPropSet(g.shipping, '_delivery_date', gtFormatOrderDeliveryDate(get('input[name="delivery_date"]')));
          eboPropSet(g.shipping, 'delivery_date', null);
          eboPropSet(g.shipping, 'card_message', get('textarea[name="note"]'));

          const $shipChecked = $row.find('shipping-methods input[type="radio"]:checked');
          if ($shipChecked.length && $shipChecked.val()) {
            const vid = parseInt(String($shipChecked.val()).replace(/\D/g, ''), 10);
            if (!isNaN(vid)) {
              g.shipping.variant_id = vid;
              const title = $shipChecked.attr('data-variant-title') || g.shipping.variant_title || '';
              if (title) {
                g.shipping.variant_title = title;
                g.shipping.name = 'Shipping - ' + title;
                if (!g.shipping.title || String(g.shipping.title).toLowerCase().indexOf('shipping') !== -1) {
                  g.shipping.title = 'Shipping';
                }
              }
              // Prefer radio data-price; fall back to on-screen shipping-fee
              let shipPrice = typeof parseShippingDataPrice === 'function'
                ? parseShippingDataPrice($shipChecked)
                : NaN;
              if (isNaN(shipPrice) || shipPrice < 0) {
                shipPrice = parseFloat(
                  String($row.find('.shipping-fee').first().text() || '').replace(/[^0-9.]/g, '')
                );
              }
              if (!isNaN(shipPrice) && shipPrice >= 0) {
                eboSetLineMoney(g.shipping, shipPrice);
                if (g.main) eboPropSet(g.main, '_shipping_fee', shipPrice.toFixed(2));
              }
              shippingPatches.push({
                gid: gid,
                variant_id: vid,
                variant_title: title,
                price: g.shipping.price
              });
            }
          } else {
            shippingPatches.push({ gid: gid, error: 'no shipping radio checked' });
          }
        }

        if (g.main) {
          eboPropSet(g.main, 'delivery_date', null);
          eboPropSet(g.main, '_delivery_date', gtFormatOrderDeliveryDate(get('input[name="delivery_date"]')));
          if (eboPropGet(g.main, '_supplier') !== undefined) {
            eboPropSet(g.main, '_supplier', window.gtResolveSupplier(
              get('input[name="delivery_date"]'),
              g.main.variant_id,
              g.main.vendor,
              getRowProductTags($row)
            ));
          }
          const pms = $row.find('.personal-message__body').map(function () {
            return $(this).val() || '';
          }).get();
          const noMsg = $row.find('input[name="opt-out-personal-message"]').is(':checked');
          if (noMsg || !pms[0]) eboPropSet(g.main, 'Personal Message Line 1', null);
          else eboPropSet(g.main, 'Personal Message Line 1', pms[0]);
          if (noMsg || !pms[1]) eboPropSet(g.main, 'Personal Message Line 2', null);
          else eboPropSet(g.main, 'Personal Message Line 2', pms[1]);
        }

        if (g.ribbon) {
          eboPropSet(g.ribbon, 'Color', get('select[name="ribbon-color"]'));
          eboPropSet(g.ribbon, 'Message', get('.product__ribbon-message'));
          const ribbonType = get('select[name="products-ribbon"]');
          if (ribbonType) {
            const rvid = parseInt(ribbonType, 10);
            if (!isNaN(rvid)) g.ribbon.variant_id = rvid;
          }
        }
      });

      /* console.log('EBO shipping metafield patches:', shippingPatches) */;
      return lineItems;
    }

    async function eboLoadIntoTable() {
      const id = ($('#ebo-order-id').val() || '').trim();
      const type = $('#ebo-lookup-type').val() || 'draft';
      if (!id) {
        eboStatus('error', 'Enter a Draft Order ID, Order ID, or Bulk Order ID');
        return;
      }

      let body = {};
      if (type === 'draft') body = { draft_order_id: id };
      else if (type === 'order') body = { order_id: id };
      else body = { bulk_order_id: id };

      $('#ebo-load-btn').prop('disabled', true).text('Loading…');
      eboStatus('info', 'Fetching Custom Line items JSON metafield…');

      try {
        await eboWaitForProducts(60000);

        // Retry transient failures (network blip / cold API) before giving up
        let res, data, lastErr;
        for (let attempt = 1; attempt <= 3; attempt++) {
          try {
            res = await fetch(EBO_API + '/fetch_bulk_metafield.php', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(body)
            });
            data = await res.json();
            if (res.ok && data.success) { lastErr = null; break; }
            lastErr = new Error(data.error || data.details || 'Fetch failed');
            if (res.status >= 400 && res.status < 500) break; // bad ID etc. – don't retry
          } catch (e) {
            lastErr = e;
          }
          if (attempt < 3) {
            eboStatus('info', 'Fetch failed, retrying (' + attempt + '/2)…');
            await new Promise(function (r) { setTimeout(r, 1000 * attempt); });
          }
        }
        if (lastErr) throw lastErr;

        const lineItems = Array.isArray(data.line_items) ? data.line_items : [];
        // Keep exact metafield array for save (same Custom Line items JSON shape)
        window.GT_EDIT_LINE_ITEMS = JSON.parse(JSON.stringify(lineItems));

        const groups = eboGroupLineItems(window.GT_EDIT_LINE_ITEMS);
        if (!groups.length) {
          throw new Error(
            data.warning ||
            'No gift groups found in custom.custom_line_items_json (' + lineItems.length + ' line items).'
          );
        }

        window.GT_EDIT_OWNER = {
          owner_type: data.owner_type,
          owner_id: data.owner_id
        };

        table.clear().draw();
        let loaded = 0;
        const errors = [];
        for (let i = 0; i < groups.length; i++) {
          try {
            const newRowData = createRow(i + 1);
            const rowApi = table.row.add(newRowData).draw(false);
            const $row = $(rowApi.node());
            if (typeof populateAllDropdowns === 'function') populateAllDropdowns();
            await eboPopulateRowFromGroup($row, groups[i]);
            loaded += 1;
          } catch (rowErr) {
            console.error('Failed to populate gift row', i + 1, groups[i], rowErr);
            errors.push('Row ' + (i + 1) + ': ' + (rowErr.message || rowErr));
          }
        }
        table.draw(false);

        if (typeof initializeCountryProvinceSelectors === 'function') {
          initializeCountryProvinceSelectors();
        }
        if (typeof DefaultCountySelection === 'function') {
          setTimeout(function () { DefaultCountySelection(); }, 400);
        }
        // Re-apply province after country selectors init
        setTimeout(function () {
          $('#orderTableBody tr').each(function () {
            const gid = $(this).attr('data-ebo-gid');
            if (!gid) return;
            const g = groups.find(function (x) { return String(x.gid) === String(gid); });
            if (!g || !g.shipping) return;
            const addr = eboParseAddress(eboPropGet(g.shipping, '_address'));
            if (addr.province) {
              $(this).find('select[name="province"]').val(addr.province).trigger('change');
            }
          });
          if (typeof calculateTotals === 'function') calculateTotals();
        }, 600);

        if (typeof calculateTotals === 'function') calculateTotals();

        $('#ebo-meta').text(
          data.owner_type + ' · ' + data.owner_id + ' · ' + loaded + '/' + groups.length + ' gift(s) · ' + lineItems.length + ' line item(s) in metafield'
        ).show();

        if (loaded === 0) {
          throw new Error('Could not populate any rows. ' + errors.join('; '));
        }
        if (errors.length) {
          eboStatus('error', 'Loaded ' + loaded + ' of ' + groups.length + ' gifts. Some rows failed: ' + errors.join('; '));
        } else {
          eboStatus(
            'success',
            'Loaded ' + loaded + ' gift(s) from Custom Line items JSON. Edit the table, then Save Metafield.'
          );
        }
      } catch (err) {
        console.error(err);
        eboStatus('error', err.message || 'Load failed');
      } finally {
        $('#ebo-load-btn').prop('disabled', false).text('Load into table');
      }
    }

    async function eboSaveMetafield() {
      if (!window.GT_EDIT_OWNER || !window.GT_EDIT_OWNER.owner_id) {
        eboStatus('error', 'Load an order into the table first');
        return;
      }
      if (!Array.isArray(window.GT_EDIT_LINE_ITEMS) || !window.GT_EDIT_LINE_ITEMS.length) {
        eboStatus('error', 'No Custom Line items JSON loaded. Click Load into table first.');
        return;
      }

      $('#ebo-save-btn').prop('disabled', true).text('Saving…');
      eboStatus('info', 'Updating custom.custom_line_items_json from the table…');

      try {
        // Supplier depends on each product's assigned locations; load them before patching
        await window.gtLoadPaLocations(
          window.GT_EDIT_LINE_ITEMS
            .filter(function (it) { return eboPropGet(it, '_product') === 'true'; })
            .map(function (it) { return it.variant_id; })
        );

        // Patch the original metafield array (keep ids, price_sets, tax_lines, _gid)
        const lineItems = eboApplyTableEditsToMetafieldJson(window.GT_EDIT_LINE_ITEMS);
        window.GT_EDIT_LINE_ITEMS = lineItems;

        const payload = { line_items: lineItems };
        if (window.GT_EDIT_OWNER.owner_type === 'DraftOrder') {
          payload.draft_order_id = window.GT_EDIT_OWNER.owner_id;
        } else {
          payload.order_id = window.GT_EDIT_OWNER.owner_id;
        }

        const res = await fetch(EBO_API + '/update_bulk_metafield.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
        const data = await res.json();
        if (!res.ok || !data.success) {
          throw new Error(data.error || JSON.stringify(data.details || data) || 'Save failed');
        }

        const count = data.line_item_count || lineItems.length;
        let msg = 'Metafield updated (' + count + ' line items)';
        if (data.draft_sync && data.draft_sync.success) {
          msg += '; draft order lines synced';
        } else if (data.warning) {
          msg += '. Warning: ' + data.warning;
        } else if (window.GT_EDIT_OWNER.owner_type === 'Order') {
          msg += '. Paid order line properties stay on metafield only (Shopify cannot edit them)';
        }
        let secondsLeft = 5;
        eboStatus('success', msg + '. Page will refresh in ' + secondsLeft + ' seconds…');
        $('#ebo-save-btn').prop('disabled', true).text('Saved — refreshing…');
        $('#ebo-load-btn').prop('disabled', true);
        // Allow automatic reload without "Reload site? / unsaved changes" prompt
        allowRefresh = true;
        $('#refreshConfirmationModal').hide();

        const countdown = setInterval(function () {
          secondsLeft -= 1;
          if (secondsLeft <= 0) {
            clearInterval(countdown);
            allowRefresh = true;
            window.location.reload();
            return;
          }
          eboStatus('success', msg + '. Page will refresh in ' + secondsLeft + ' seconds…');
        }, 1000);
        return;
      } catch (err) {
        console.error(err);
        eboStatus('error', err.message || 'Save failed');
        $('#ebo-save-btn').prop('disabled', false).text('Save Metafield');
      }
    }

    $('#ebo-load-btn').on('click', function (e) {
      e.preventDefault();
      eboLoadIntoTable();
    });
    $('#ebo-save-btn').on('click', function (e) {
      e.preventDefault();
      eboSaveMetafield();
    });
    $('#ebo-order-id').on('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        eboLoadIntoTable();
      }
    });

    // Prefill + auto-load from URL: /pages/edit-bulk-order?order-type=order&id=123
    (function eboPrefillFromUrl() {
      const params = new URLSearchParams(window.location.search);
      const rawType = (params.get('order-type') || '').toLowerCase().replace(/[_\s-]order$/, '');
      const id = (params.get('id') || '').trim();
      if (['draft', 'order', 'bulk'].indexOf(rawType) !== -1) {
        $('#ebo-lookup-type').val(rawType);
      }
      if (id) {
        $('#ebo-order-id').val(id);
        // Don't hit the API until the product cache is ready, otherwise rows can't be matched
        $('#ebo-load-btn').prop('disabled', true);
        eboStatus('info', 'Loading products, then your order…');
        eboWaitForProducts(120000)
          .then(function () { return eboLoadIntoTable(); })
          .catch(function (err) {
            $('#ebo-load-btn').prop('disabled', false);
            eboStatus('error', err.message || 'Products failed to load. Click Load into table to retry.');
          });
      }
    })();
  }

});
